var yo = Object.defineProperty;
var Jn = (e) => {
  throw TypeError(e);
};
var mo = (e, t, r) => t in e ? yo(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r;
var ae = (e, t, r) => mo(e, typeof t != "symbol" ? t + "" : t, r), zn = (e, t, r) => t.has(e) || Jn("Cannot " + r);
var g = (e, t, r) => (zn(e, t, "read from private field"), r ? r.call(e) : t.get(e)), ye = (e, t, r) => t.has(e) ? Jn("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(e) : t.set(e, r), me = (e, t, r, n) => (zn(e, t, "write to private field"), n ? n.call(e, r) : t.set(e, r), r);
var vo = function(e, t, r) {
  if (r || arguments.length === 2) for (var n = 0, a = t.length, s; n < a; n++)
    (s || !(n in t)) && (s || (s = Array.prototype.slice.call(t, 0, n)), s[n] = t[n]);
  return e.concat(s || Array.prototype.slice.call(t));
};
function go(e) {
  return e;
}
function be(e, t, r, n, a, s, i, o, u) {
  switch (arguments.length) {
    case 1:
      return e;
    case 2:
      return function() {
        return t(e.apply(this, arguments));
      };
    case 3:
      return function() {
        return r(t(e.apply(this, arguments)));
      };
    case 4:
      return function() {
        return n(r(t(e.apply(this, arguments))));
      };
    case 5:
      return function() {
        return a(n(r(t(e.apply(this, arguments)))));
      };
    case 6:
      return function() {
        return s(a(n(r(t(e.apply(this, arguments))))));
      };
    case 7:
      return function() {
        return i(s(a(n(r(t(e.apply(this, arguments)))))));
      };
    case 8:
      return function() {
        return o(i(s(a(n(r(t(e.apply(this, arguments))))))));
      };
    case 9:
      return function() {
        return u(o(i(s(a(n(r(t(e.apply(this, arguments)))))))));
      };
  }
}
function _(e, t, r, n, a, s, i, o, u) {
  switch (arguments.length) {
    case 1:
      return e;
    case 2:
      return t(e);
    case 3:
      return r(t(e));
    case 4:
      return n(r(t(e)));
    case 5:
      return a(n(r(t(e))));
    case 6:
      return s(a(n(r(t(e)))));
    case 7:
      return i(s(a(n(r(t(e))))));
    case 8:
      return o(i(s(a(n(r(t(e)))))));
    case 9:
      return u(o(i(s(a(n(r(t(e))))))));
    default: {
      for (var d = arguments[0], y = 1; y < arguments.length; y++)
        d = arguments[y](d);
      return d;
    }
  }
}
var _o = function(e, t) {
  var r = function(n) {
    return n.length >= e;
  };
  return function() {
    var n = Array.from(arguments);
    return r(arguments) ? t.apply(this, n) : function(a) {
      return t.apply(void 0, vo([a], n, !1));
    };
  };
}, bo = function(e) {
  return {
    equals: function(t, r) {
      return t === r || e(t, r);
    }
  };
}, So = function(e) {
  return bo(function(t, r) {
    for (var n in e)
      if (!e[n].equals(t[n], r[n]))
        return !1;
    return !0;
  });
}, Ya = function(e) {
  return e._tag === "Some";
}, Xa = { _tag: "None" }, es = function(e) {
  return { _tag: "Some", value: e };
}, Ao = function(e) {
  return e._tag === "Left";
}, To = function(e) {
  return e._tag === "Right";
}, $o = function(e) {
  return { _tag: "Left", left: e };
}, Eo = function(e) {
  return { _tag: "Right", right: e };
}, wo = function(e) {
  return [e];
}, Co = [], xo = Object.prototype.hasOwnProperty, Ro = function(e) {
  return function(t) {
    return function(r) {
      return r.reduce(function(n, a) {
        return e.concat(n, a);
      }, t);
    };
  };
}, Oo = function(e) {
  return {
    concat: function(t, r) {
      var n = {};
      for (var a in e)
        xo.call(e, a) && (n[a] = e[a].concat(t[a], r[a]));
      return n;
    }
  };
}, kr = function() {
  return { concat: go };
}, Io = function() {
  return { concat: function(e, t) {
    return t;
  } };
}, ko = Ro, Qn = function(e, t, r) {
  if (r || arguments.length === 2) for (var n = 0, a = t.length, s; n < a; n++)
    (s || !(n in t)) && (s || (s = Array.prototype.slice.call(t, 0, n)), s[n] = t[n]);
  return e.concat(s || Array.prototype.slice.call(t));
}, Po = Co, Vo = function(e, t) {
  return e < 0 || e >= t.length;
}, No = function(e) {
  return function(t) {
    return Qn(Qn([], t, !0), [e], !1);
  };
}, Mo = No, jo = wo, ve = {
  equals: function(e, t) {
    return e === t;
  }
}, Ho = {
  concat: function(e, t) {
    return e + t;
  }
}, Do = "", on = {
  concat: Ho.concat,
  empty: Do
};
ve.equals;
var ts = function(e) {
  return e.trim();
}, rs = function(e) {
  return e.length === 0;
}, Nt = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function ns(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function Lo() {
  this.__data__ = [], this.size = 0;
}
var Uo = Lo;
function Ko(e, t) {
  return e === t || e !== e && t !== t;
}
var cn = Ko, Bo = cn;
function qo(e, t) {
  for (var r = e.length; r--; )
    if (Bo(e[r][0], t))
      return r;
  return -1;
}
var or = qo, Zo = or, Fo = Array.prototype, Wo = Fo.splice;
function Go(e) {
  var t = this.__data__, r = Zo(t, e);
  if (r < 0)
    return !1;
  var n = t.length - 1;
  return r == n ? t.pop() : Wo.call(t, r, 1), --this.size, !0;
}
var Jo = Go, zo = or;
function Qo(e) {
  var t = this.__data__, r = zo(t, e);
  return r < 0 ? void 0 : t[r][1];
}
var Yo = Qo, Xo = or;
function ec(e) {
  return Xo(this.__data__, e) > -1;
}
var tc = ec, rc = or;
function nc(e, t) {
  var r = this.__data__, n = rc(r, e);
  return n < 0 ? (++this.size, r.push([e, t])) : r[n][1] = t, this;
}
var ac = nc, sc = Uo, ic = Jo, oc = Yo, cc = tc, uc = ac;
function it(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.clear(); ++t < r; ) {
    var n = e[t];
    this.set(n[0], n[1]);
  }
}
it.prototype.clear = sc;
it.prototype.delete = ic;
it.prototype.get = oc;
it.prototype.has = cc;
it.prototype.set = uc;
var cr = it, lc = cr;
function dc() {
  this.__data__ = new lc(), this.size = 0;
}
var fc = dc;
function hc(e) {
  var t = this.__data__, r = t.delete(e);
  return this.size = t.size, r;
}
var pc = hc;
function yc(e) {
  return this.__data__.get(e);
}
var mc = yc;
function vc(e) {
  return this.__data__.has(e);
}
var gc = vc, _c = typeof Nt == "object" && Nt && Nt.Object === Object && Nt, as = _c, bc = as, Sc = typeof self == "object" && self && self.Object === Object && self, Ac = bc || Sc || Function("return this")(), re = Ac, Tc = re, $c = Tc.Symbol, ur = $c, Yn = ur, ss = Object.prototype, Ec = ss.hasOwnProperty, wc = ss.toString, ht = Yn ? Yn.toStringTag : void 0;
function Cc(e) {
  var t = Ec.call(e, ht), r = e[ht];
  try {
    e[ht] = void 0;
    var n = !0;
  } catch {
  }
  var a = wc.call(e);
  return n && (t ? e[ht] = r : delete e[ht]), a;
}
var xc = Cc, Rc = Object.prototype, Oc = Rc.toString;
function Ic(e) {
  return Oc.call(e);
}
var kc = Ic, Xn = ur, Pc = xc, Vc = kc, Nc = "[object Null]", Mc = "[object Undefined]", ea = Xn ? Xn.toStringTag : void 0;
function jc(e) {
  return e == null ? e === void 0 ? Mc : Nc : ea && ea in Object(e) ? Pc(e) : Vc(e);
}
var lr = jc;
function Hc(e) {
  var t = typeof e;
  return e != null && (t == "object" || t == "function");
}
var At = Hc, Dc = lr, Lc = At, Uc = "[object AsyncFunction]", Kc = "[object Function]", Bc = "[object GeneratorFunction]", qc = "[object Proxy]";
function Zc(e) {
  if (!Lc(e))
    return !1;
  var t = Dc(e);
  return t == Kc || t == Bc || t == Uc || t == qc;
}
var is = Zc, Fc = re, Wc = Fc["__core-js_shared__"], Gc = Wc, Pr = Gc, ta = function() {
  var e = /[^.]+$/.exec(Pr && Pr.keys && Pr.keys.IE_PROTO || "");
  return e ? "Symbol(src)_1." + e : "";
}();
function Jc(e) {
  return !!ta && ta in e;
}
var zc = Jc, Qc = Function.prototype, Yc = Qc.toString;
function Xc(e) {
  if (e != null) {
    try {
      return Yc.call(e);
    } catch {
    }
    try {
      return e + "";
    } catch {
    }
  }
  return "";
}
var os = Xc, eu = is, tu = zc, ru = At, nu = os, au = /[\\^$.*+?()[\]{}|]/g, su = /^\[object .+?Constructor\]$/, iu = Function.prototype, ou = Object.prototype, cu = iu.toString, uu = ou.hasOwnProperty, lu = RegExp(
  "^" + cu.call(uu).replace(au, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function du(e) {
  if (!ru(e) || tu(e))
    return !1;
  var t = eu(e) ? lu : su;
  return t.test(nu(e));
}
var fu = du;
function hu(e, t) {
  return e == null ? void 0 : e[t];
}
var pu = hu, yu = fu, mu = pu;
function vu(e, t) {
  var r = mu(e, t);
  return yu(r) ? r : void 0;
}
var Ve = vu, gu = Ve, _u = re, bu = gu(_u, "Map"), un = bu, Su = Ve, Au = Su(Object, "create"), dr = Au, ra = dr;
function Tu() {
  this.__data__ = ra ? ra(null) : {}, this.size = 0;
}
var $u = Tu;
function Eu(e) {
  var t = this.has(e) && delete this.__data__[e];
  return this.size -= t ? 1 : 0, t;
}
var wu = Eu, Cu = dr, xu = "__lodash_hash_undefined__", Ru = Object.prototype, Ou = Ru.hasOwnProperty;
function Iu(e) {
  var t = this.__data__;
  if (Cu) {
    var r = t[e];
    return r === xu ? void 0 : r;
  }
  return Ou.call(t, e) ? t[e] : void 0;
}
var ku = Iu, Pu = dr, Vu = Object.prototype, Nu = Vu.hasOwnProperty;
function Mu(e) {
  var t = this.__data__;
  return Pu ? t[e] !== void 0 : Nu.call(t, e);
}
var ju = Mu, Hu = dr, Du = "__lodash_hash_undefined__";
function Lu(e, t) {
  var r = this.__data__;
  return this.size += this.has(e) ? 0 : 1, r[e] = Hu && t === void 0 ? Du : t, this;
}
var Uu = Lu, Ku = $u, Bu = wu, qu = ku, Zu = ju, Fu = Uu;
function ot(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.clear(); ++t < r; ) {
    var n = e[t];
    this.set(n[0], n[1]);
  }
}
ot.prototype.clear = Ku;
ot.prototype.delete = Bu;
ot.prototype.get = qu;
ot.prototype.has = Zu;
ot.prototype.set = Fu;
var Wu = ot, na = Wu, Gu = cr, Ju = un;
function zu() {
  this.size = 0, this.__data__ = {
    hash: new na(),
    map: new (Ju || Gu)(),
    string: new na()
  };
}
var Qu = zu;
function Yu(e) {
  var t = typeof e;
  return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? e !== "__proto__" : e === null;
}
var Xu = Yu, el = Xu;
function tl(e, t) {
  var r = e.__data__;
  return el(t) ? r[typeof t == "string" ? "string" : "hash"] : r.map;
}
var fr = tl, rl = fr;
function nl(e) {
  var t = rl(this, e).delete(e);
  return this.size -= t ? 1 : 0, t;
}
var al = nl, sl = fr;
function il(e) {
  return sl(this, e).get(e);
}
var ol = il, cl = fr;
function ul(e) {
  return cl(this, e).has(e);
}
var ll = ul, dl = fr;
function fl(e, t) {
  var r = dl(this, e), n = r.size;
  return r.set(e, t), this.size += r.size == n ? 0 : 1, this;
}
var hl = fl, pl = Qu, yl = al, ml = ol, vl = ll, gl = hl;
function ct(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.clear(); ++t < r; ) {
    var n = e[t];
    this.set(n[0], n[1]);
  }
}
ct.prototype.clear = pl;
ct.prototype.delete = yl;
ct.prototype.get = ml;
ct.prototype.has = vl;
ct.prototype.set = gl;
var cs = ct, _l = cr, bl = un, Sl = cs, Al = 200;
function Tl(e, t) {
  var r = this.__data__;
  if (r instanceof _l) {
    var n = r.__data__;
    if (!bl || n.length < Al - 1)
      return n.push([e, t]), this.size = ++r.size, this;
    r = this.__data__ = new Sl(n);
  }
  return r.set(e, t), this.size = r.size, this;
}
var $l = Tl, El = cr, wl = fc, Cl = pc, xl = mc, Rl = gc, Ol = $l;
function ut(e) {
  var t = this.__data__ = new El(e);
  this.size = t.size;
}
ut.prototype.clear = wl;
ut.prototype.delete = Cl;
ut.prototype.get = xl;
ut.prototype.has = Rl;
ut.prototype.set = Ol;
var us = ut;
function Il(e, t) {
  for (var r = -1, n = e == null ? 0 : e.length; ++r < n && t(e[r], r, e) !== !1; )
    ;
  return e;
}
var kl = Il, Pl = Ve, Vl = function() {
  try {
    var e = Pl(Object, "defineProperty");
    return e({}, "", {}), e;
  } catch {
  }
}(), Nl = Vl, aa = Nl;
function Ml(e, t, r) {
  t == "__proto__" && aa ? aa(e, t, {
    configurable: !0,
    enumerable: !0,
    value: r,
    writable: !0
  }) : e[t] = r;
}
var ls = Ml, jl = ls, Hl = cn, Dl = Object.prototype, Ll = Dl.hasOwnProperty;
function Ul(e, t, r) {
  var n = e[t];
  (!(Ll.call(e, t) && Hl(n, r)) || r === void 0 && !(t in e)) && jl(e, t, r);
}
var ds = Ul, Kl = ds, Bl = ls;
function ql(e, t, r, n) {
  var a = !r;
  r || (r = {});
  for (var s = -1, i = t.length; ++s < i; ) {
    var o = t[s], u = n ? n(r[o], e[o], o, r, e) : void 0;
    u === void 0 && (u = e[o]), a ? Bl(r, o, u) : Kl(r, o, u);
  }
  return r;
}
var hr = ql;
function Zl(e, t) {
  for (var r = -1, n = Array(e); ++r < e; )
    n[r] = t(r);
  return n;
}
var Fl = Zl;
function Wl(e) {
  return e != null && typeof e == "object";
}
var lt = Wl, Gl = lr, Jl = lt, zl = "[object Arguments]";
function Ql(e) {
  return Jl(e) && Gl(e) == zl;
}
var Yl = Ql, sa = Yl, Xl = lt, fs = Object.prototype, ed = fs.hasOwnProperty, td = fs.propertyIsEnumerable, rd = sa(/* @__PURE__ */ function() {
  return arguments;
}()) ? sa : function(e) {
  return Xl(e) && ed.call(e, "callee") && !td.call(e, "callee");
}, nd = rd, ad = Array.isArray, pr = ad, Dt = { exports: {} };
function sd() {
  return !1;
}
var id = sd;
Dt.exports;
(function(e, t) {
  var r = re, n = id, a = t && !t.nodeType && t, s = a && !0 && e && !e.nodeType && e, i = s && s.exports === a, o = i ? r.Buffer : void 0, u = o ? o.isBuffer : void 0, d = u || n;
  e.exports = d;
})(Dt, Dt.exports);
var ln = Dt.exports, od = 9007199254740991, cd = /^(?:0|[1-9]\d*)$/;
function ud(e, t) {
  var r = typeof e;
  return t = t ?? od, !!t && (r == "number" || r != "symbol" && cd.test(e)) && e > -1 && e % 1 == 0 && e < t;
}
var ld = ud, dd = 9007199254740991;
function fd(e) {
  return typeof e == "number" && e > -1 && e % 1 == 0 && e <= dd;
}
var hs = fd, hd = lr, pd = hs, yd = lt, md = "[object Arguments]", vd = "[object Array]", gd = "[object Boolean]", _d = "[object Date]", bd = "[object Error]", Sd = "[object Function]", Ad = "[object Map]", Td = "[object Number]", $d = "[object Object]", Ed = "[object RegExp]", wd = "[object Set]", Cd = "[object String]", xd = "[object WeakMap]", Rd = "[object ArrayBuffer]", Od = "[object DataView]", Id = "[object Float32Array]", kd = "[object Float64Array]", Pd = "[object Int8Array]", Vd = "[object Int16Array]", Nd = "[object Int32Array]", Md = "[object Uint8Array]", jd = "[object Uint8ClampedArray]", Hd = "[object Uint16Array]", Dd = "[object Uint32Array]", I = {};
I[Id] = I[kd] = I[Pd] = I[Vd] = I[Nd] = I[Md] = I[jd] = I[Hd] = I[Dd] = !0;
I[md] = I[vd] = I[Rd] = I[gd] = I[Od] = I[_d] = I[bd] = I[Sd] = I[Ad] = I[Td] = I[$d] = I[Ed] = I[wd] = I[Cd] = I[xd] = !1;
function Ld(e) {
  return yd(e) && pd(e.length) && !!I[hd(e)];
}
var Ud = Ld;
function Kd(e) {
  return function(t) {
    return e(t);
  };
}
var dn = Kd, Lt = { exports: {} };
Lt.exports;
(function(e, t) {
  var r = as, n = t && !t.nodeType && t, a = n && !0 && e && !e.nodeType && e, s = a && a.exports === n, i = s && r.process, o = function() {
    try {
      var u = a && a.require && a.require("util").types;
      return u || i && i.binding && i.binding("util");
    } catch {
    }
  }();
  e.exports = o;
})(Lt, Lt.exports);
var fn = Lt.exports, Bd = Ud, qd = dn, ia = fn, oa = ia && ia.isTypedArray, Zd = oa ? qd(oa) : Bd, ps = Zd, Fd = Fl, Wd = nd, Gd = pr, Jd = ln, zd = ld, Qd = ps, Yd = Object.prototype, Xd = Yd.hasOwnProperty;
function ef(e, t) {
  var r = Gd(e), n = !r && Wd(e), a = !r && !n && Jd(e), s = !r && !n && !a && Qd(e), i = r || n || a || s, o = i ? Fd(e.length, String) : [], u = o.length;
  for (var d in e)
    (t || Xd.call(e, d)) && !(i && // Safari 9 has enumerable `arguments.length` in strict mode.
    (d == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    a && (d == "offset" || d == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    s && (d == "buffer" || d == "byteLength" || d == "byteOffset") || // Skip index properties.
    zd(d, u))) && o.push(d);
  return o;
}
var ys = ef, tf = Object.prototype;
function rf(e) {
  var t = e && e.constructor, r = typeof t == "function" && t.prototype || tf;
  return e === r;
}
var hn = rf;
function nf(e, t) {
  return function(r) {
    return e(t(r));
  };
}
var ms = nf, af = ms, sf = af(Object.keys, Object), of = sf, cf = hn, uf = of, lf = Object.prototype, df = lf.hasOwnProperty;
function ff(e) {
  if (!cf(e))
    return uf(e);
  var t = [];
  for (var r in Object(e))
    df.call(e, r) && r != "constructor" && t.push(r);
  return t;
}
var hf = ff, pf = is, yf = hs;
function mf(e) {
  return e != null && yf(e.length) && !pf(e);
}
var vs = mf, vf = ys, gf = hf, _f = vs;
function bf(e) {
  return _f(e) ? vf(e) : gf(e);
}
var pn = bf, Sf = hr, Af = pn;
function Tf(e, t) {
  return e && Sf(t, Af(t), e);
}
var $f = Tf;
function Ef(e) {
  var t = [];
  if (e != null)
    for (var r in Object(e))
      t.push(r);
  return t;
}
var wf = Ef, Cf = At, xf = hn, Rf = wf, Of = Object.prototype, If = Of.hasOwnProperty;
function kf(e) {
  if (!Cf(e))
    return Rf(e);
  var t = xf(e), r = [];
  for (var n in e)
    n == "constructor" && (t || !If.call(e, n)) || r.push(n);
  return r;
}
var Pf = kf, Vf = ys, Nf = Pf, Mf = vs;
function jf(e) {
  return Mf(e) ? Vf(e, !0) : Nf(e);
}
var yn = jf, Hf = hr, Df = yn;
function Lf(e, t) {
  return e && Hf(t, Df(t), e);
}
var Uf = Lf, Ut = { exports: {} };
Ut.exports;
(function(e, t) {
  var r = re, n = t && !t.nodeType && t, a = n && !0 && e && !e.nodeType && e, s = a && a.exports === n, i = s ? r.Buffer : void 0, o = i ? i.allocUnsafe : void 0;
  function u(d, y) {
    if (y)
      return d.slice();
    var A = d.length, E = o ? o(A) : new d.constructor(A);
    return d.copy(E), E;
  }
  e.exports = u;
})(Ut, Ut.exports);
var Kf = Ut.exports;
function Bf(e, t) {
  var r = -1, n = e.length;
  for (t || (t = Array(n)); ++r < n; )
    t[r] = e[r];
  return t;
}
var qf = Bf;
function Zf(e, t) {
  for (var r = -1, n = e == null ? 0 : e.length, a = 0, s = []; ++r < n; ) {
    var i = e[r];
    t(i, r, e) && (s[a++] = i);
  }
  return s;
}
var Ff = Zf;
function Wf() {
  return [];
}
var gs = Wf, Gf = Ff, Jf = gs, zf = Object.prototype, Qf = zf.propertyIsEnumerable, ca = Object.getOwnPropertySymbols, Yf = ca ? function(e) {
  return e == null ? [] : (e = Object(e), Gf(ca(e), function(t) {
    return Qf.call(e, t);
  }));
} : Jf, mn = Yf, Xf = hr, eh = mn;
function th(e, t) {
  return Xf(e, eh(e), t);
}
var rh = th;
function nh(e, t) {
  for (var r = -1, n = t.length, a = e.length; ++r < n; )
    e[a + r] = t[r];
  return e;
}
var _s = nh, ah = ms, sh = ah(Object.getPrototypeOf, Object), bs = sh, ih = _s, oh = bs, ch = mn, uh = gs, lh = Object.getOwnPropertySymbols, dh = lh ? function(e) {
  for (var t = []; e; )
    ih(t, ch(e)), e = oh(e);
  return t;
} : uh, Ss = dh, fh = hr, hh = Ss;
function ph(e, t) {
  return fh(e, hh(e), t);
}
var yh = ph, mh = _s, vh = pr;
function gh(e, t, r) {
  var n = t(e);
  return vh(e) ? n : mh(n, r(e));
}
var As = gh, _h = As, bh = mn, Sh = pn;
function Ah(e) {
  return _h(e, Sh, bh);
}
var Ts = Ah, Th = As, $h = Ss, Eh = yn;
function wh(e) {
  return Th(e, Eh, $h);
}
var Ch = wh, xh = Ve, Rh = re, Oh = xh(Rh, "DataView"), Ih = Oh, kh = Ve, Ph = re, Vh = kh(Ph, "Promise"), Nh = Vh, Mh = Ve, jh = re, Hh = Mh(jh, "Set"), Dh = Hh, Lh = Ve, Uh = re, Kh = Lh(Uh, "WeakMap"), Bh = Kh, Kr = Ih, Br = un, qr = Nh, Zr = Dh, Fr = Bh, $s = lr, dt = os, ua = "[object Map]", qh = "[object Object]", la = "[object Promise]", da = "[object Set]", fa = "[object WeakMap]", ha = "[object DataView]", Zh = dt(Kr), Fh = dt(Br), Wh = dt(qr), Gh = dt(Zr), Jh = dt(Fr), Re = $s;
(Kr && Re(new Kr(new ArrayBuffer(1))) != ha || Br && Re(new Br()) != ua || qr && Re(qr.resolve()) != la || Zr && Re(new Zr()) != da || Fr && Re(new Fr()) != fa) && (Re = function(e) {
  var t = $s(e), r = t == qh ? e.constructor : void 0, n = r ? dt(r) : "";
  if (n)
    switch (n) {
      case Zh:
        return ha;
      case Fh:
        return ua;
      case Wh:
        return la;
      case Gh:
        return da;
      case Jh:
        return fa;
    }
  return t;
});
var yr = Re, zh = Object.prototype, Qh = zh.hasOwnProperty;
function Yh(e) {
  var t = e.length, r = new e.constructor(t);
  return t && typeof e[0] == "string" && Qh.call(e, "index") && (r.index = e.index, r.input = e.input), r;
}
var Xh = Yh, ep = re, tp = ep.Uint8Array, Es = tp, pa = Es;
function rp(e) {
  var t = new e.constructor(e.byteLength);
  return new pa(t).set(new pa(e)), t;
}
var vn = rp, np = vn;
function ap(e, t) {
  var r = t ? np(e.buffer) : e.buffer;
  return new e.constructor(r, e.byteOffset, e.byteLength);
}
var sp = ap, ip = /\w*$/;
function op(e) {
  var t = new e.constructor(e.source, ip.exec(e));
  return t.lastIndex = e.lastIndex, t;
}
var cp = op, ya = ur, ma = ya ? ya.prototype : void 0, va = ma ? ma.valueOf : void 0;
function up(e) {
  return va ? Object(va.call(e)) : {};
}
var lp = up, dp = vn;
function fp(e, t) {
  var r = t ? dp(e.buffer) : e.buffer;
  return new e.constructor(r, e.byteOffset, e.length);
}
var hp = fp, pp = vn, yp = sp, mp = cp, vp = lp, gp = hp, _p = "[object Boolean]", bp = "[object Date]", Sp = "[object Map]", Ap = "[object Number]", Tp = "[object RegExp]", $p = "[object Set]", Ep = "[object String]", wp = "[object Symbol]", Cp = "[object ArrayBuffer]", xp = "[object DataView]", Rp = "[object Float32Array]", Op = "[object Float64Array]", Ip = "[object Int8Array]", kp = "[object Int16Array]", Pp = "[object Int32Array]", Vp = "[object Uint8Array]", Np = "[object Uint8ClampedArray]", Mp = "[object Uint16Array]", jp = "[object Uint32Array]";
function Hp(e, t, r) {
  var n = e.constructor;
  switch (t) {
    case Cp:
      return pp(e);
    case _p:
    case bp:
      return new n(+e);
    case xp:
      return yp(e, r);
    case Rp:
    case Op:
    case Ip:
    case kp:
    case Pp:
    case Vp:
    case Np:
    case Mp:
    case jp:
      return gp(e, r);
    case Sp:
      return new n();
    case Ap:
    case Ep:
      return new n(e);
    case Tp:
      return mp(e);
    case $p:
      return new n();
    case wp:
      return vp(e);
  }
}
var Dp = Hp, Lp = At, ga = Object.create, Up = /* @__PURE__ */ function() {
  function e() {
  }
  return function(t) {
    if (!Lp(t))
      return {};
    if (ga)
      return ga(t);
    e.prototype = t;
    var r = new e();
    return e.prototype = void 0, r;
  };
}(), Kp = Up, Bp = Kp, qp = bs, Zp = hn;
function Fp(e) {
  return typeof e.constructor == "function" && !Zp(e) ? Bp(qp(e)) : {};
}
var Wp = Fp, Gp = yr, Jp = lt, zp = "[object Map]";
function Qp(e) {
  return Jp(e) && Gp(e) == zp;
}
var Yp = Qp, Xp = Yp, ey = dn, _a = fn, ba = _a && _a.isMap, ty = ba ? ey(ba) : Xp, ry = ty, ny = yr, ay = lt, sy = "[object Set]";
function iy(e) {
  return ay(e) && ny(e) == sy;
}
var oy = iy, cy = oy, uy = dn, Sa = fn, Aa = Sa && Sa.isSet, ly = Aa ? uy(Aa) : cy, dy = ly, fy = us, hy = kl, py = ds, yy = $f, my = Uf, vy = Kf, gy = qf, _y = rh, by = yh, Sy = Ts, Ay = Ch, Ty = yr, $y = Xh, Ey = Dp, wy = Wp, Cy = pr, xy = ln, Ry = ry, Oy = At, Iy = dy, ky = pn, Py = yn, Vy = 1, Ny = 2, My = 4, ws = "[object Arguments]", jy = "[object Array]", Hy = "[object Boolean]", Dy = "[object Date]", Ly = "[object Error]", Cs = "[object Function]", Uy = "[object GeneratorFunction]", Ky = "[object Map]", By = "[object Number]", xs = "[object Object]", qy = "[object RegExp]", Zy = "[object Set]", Fy = "[object String]", Wy = "[object Symbol]", Gy = "[object WeakMap]", Jy = "[object ArrayBuffer]", zy = "[object DataView]", Qy = "[object Float32Array]", Yy = "[object Float64Array]", Xy = "[object Int8Array]", em = "[object Int16Array]", tm = "[object Int32Array]", rm = "[object Uint8Array]", nm = "[object Uint8ClampedArray]", am = "[object Uint16Array]", sm = "[object Uint32Array]", O = {};
O[ws] = O[jy] = O[Jy] = O[zy] = O[Hy] = O[Dy] = O[Qy] = O[Yy] = O[Xy] = O[em] = O[tm] = O[Ky] = O[By] = O[xs] = O[qy] = O[Zy] = O[Fy] = O[Wy] = O[rm] = O[nm] = O[am] = O[sm] = !0;
O[Ly] = O[Cs] = O[Gy] = !1;
function Ht(e, t, r, n, a, s) {
  var i, o = t & Vy, u = t & Ny, d = t & My;
  if (r && (i = a ? r(e, n, a, s) : r(e)), i !== void 0)
    return i;
  if (!Oy(e))
    return e;
  var y = Cy(e);
  if (y) {
    if (i = $y(e), !o)
      return gy(e, i);
  } else {
    var A = Ty(e), E = A == Cs || A == Uy;
    if (xy(e))
      return vy(e, o);
    if (A == xs || A == ws || E && !a) {
      if (i = u || E ? {} : wy(e), !o)
        return u ? by(e, my(i, e)) : _y(e, yy(i, e));
    } else {
      if (!O[A])
        return a ? e : {};
      i = Ey(e, A, o);
    }
  }
  s || (s = new fy());
  var Z = s.get(e);
  if (Z)
    return Z;
  s.set(e, i), Iy(e) ? e.forEach(function(D) {
    i.add(Ht(D, t, r, D, e, s));
  }) : Ry(e) && e.forEach(function(D, K) {
    i.set(K, Ht(D, t, r, K, e, s));
  });
  var U = d ? u ? Ay : Sy : u ? Py : ky, F = y ? void 0 : U(e);
  return hy(F || e, function(D, K) {
    F && (K = D, D = e[K]), py(i, K, Ht(D, t, r, K, e, s));
  }), i;
}
var im = Ht, om = im, cm = 1, um = 4;
function lm(e) {
  return om(e, cm | um);
}
var dm = lm;
const fm = /* @__PURE__ */ ns(dm);
var R;
(function(e) {
  e.assertEqual = (a) => {
  };
  function t(a) {
  }
  e.assertIs = t;
  function r(a) {
    throw new Error();
  }
  e.assertNever = r, e.arrayToEnum = (a) => {
    const s = {};
    for (const i of a)
      s[i] = i;
    return s;
  }, e.getValidEnumValues = (a) => {
    const s = e.objectKeys(a).filter((o) => typeof a[a[o]] != "number"), i = {};
    for (const o of s)
      i[o] = a[o];
    return e.objectValues(i);
  }, e.objectValues = (a) => e.objectKeys(a).map(function(s) {
    return a[s];
  }), e.objectKeys = typeof Object.keys == "function" ? (a) => Object.keys(a) : (a) => {
    const s = [];
    for (const i in a)
      Object.prototype.hasOwnProperty.call(a, i) && s.push(i);
    return s;
  }, e.find = (a, s) => {
    for (const i of a)
      if (s(i))
        return i;
  }, e.isInteger = typeof Number.isInteger == "function" ? (a) => Number.isInteger(a) : (a) => typeof a == "number" && Number.isFinite(a) && Math.floor(a) === a;
  function n(a, s = " | ") {
    return a.map((i) => typeof i == "string" ? `'${i}'` : i).join(s);
  }
  e.joinValues = n, e.jsonStringifyReplacer = (a, s) => typeof s == "bigint" ? s.toString() : s;
})(R || (R = {}));
var Ta;
(function(e) {
  e.mergeShapes = (t, r) => ({
    ...t,
    ...r
    // second overwrites first
  });
})(Ta || (Ta = {}));
const m = R.arrayToEnum([
  "string",
  "nan",
  "number",
  "integer",
  "float",
  "boolean",
  "date",
  "bigint",
  "symbol",
  "function",
  "undefined",
  "null",
  "array",
  "object",
  "unknown",
  "promise",
  "void",
  "never",
  "map",
  "set"
]), ge = (e) => {
  switch (typeof e) {
    case "undefined":
      return m.undefined;
    case "string":
      return m.string;
    case "number":
      return Number.isNaN(e) ? m.nan : m.number;
    case "boolean":
      return m.boolean;
    case "function":
      return m.function;
    case "bigint":
      return m.bigint;
    case "symbol":
      return m.symbol;
    case "object":
      return Array.isArray(e) ? m.array : e === null ? m.null : e.then && typeof e.then == "function" && e.catch && typeof e.catch == "function" ? m.promise : typeof Map < "u" && e instanceof Map ? m.map : typeof Set < "u" && e instanceof Set ? m.set : typeof Date < "u" && e instanceof Date ? m.date : m.object;
    default:
      return m.unknown;
  }
}, h = R.arrayToEnum([
  "invalid_type",
  "invalid_literal",
  "custom",
  "invalid_union",
  "invalid_union_discriminator",
  "invalid_enum_value",
  "unrecognized_keys",
  "invalid_arguments",
  "invalid_return_type",
  "invalid_date",
  "invalid_string",
  "too_small",
  "too_big",
  "invalid_intersection_types",
  "not_multiple_of",
  "not_finite"
]);
class ue extends Error {
  get errors() {
    return this.issues;
  }
  constructor(t) {
    super(), this.issues = [], this.addIssue = (n) => {
      this.issues = [...this.issues, n];
    }, this.addIssues = (n = []) => {
      this.issues = [...this.issues, ...n];
    };
    const r = new.target.prototype;
    Object.setPrototypeOf ? Object.setPrototypeOf(this, r) : this.__proto__ = r, this.name = "ZodError", this.issues = t;
  }
  format(t) {
    const r = t || function(s) {
      return s.message;
    }, n = { _errors: [] }, a = (s) => {
      for (const i of s.issues)
        if (i.code === "invalid_union")
          i.unionErrors.map(a);
        else if (i.code === "invalid_return_type")
          a(i.returnTypeError);
        else if (i.code === "invalid_arguments")
          a(i.argumentsError);
        else if (i.path.length === 0)
          n._errors.push(r(i));
        else {
          let o = n, u = 0;
          for (; u < i.path.length; ) {
            const d = i.path[u];
            u === i.path.length - 1 ? (o[d] = o[d] || { _errors: [] }, o[d]._errors.push(r(i))) : o[d] = o[d] || { _errors: [] }, o = o[d], u++;
          }
        }
    };
    return a(this), n;
  }
  static assert(t) {
    if (!(t instanceof ue))
      throw new Error(`Not a ZodError: ${t}`);
  }
  toString() {
    return this.message;
  }
  get message() {
    return JSON.stringify(this.issues, R.jsonStringifyReplacer, 2);
  }
  get isEmpty() {
    return this.issues.length === 0;
  }
  flatten(t = (r) => r.message) {
    const r = {}, n = [];
    for (const a of this.issues)
      a.path.length > 0 ? (r[a.path[0]] = r[a.path[0]] || [], r[a.path[0]].push(t(a))) : n.push(t(a));
    return { formErrors: n, fieldErrors: r };
  }
  get formErrors() {
    return this.flatten();
  }
}
ue.create = (e) => new ue(e);
const Wr = (e, t) => {
  let r;
  switch (e.code) {
    case h.invalid_type:
      e.received === m.undefined ? r = "Required" : r = `Expected ${e.expected}, received ${e.received}`;
      break;
    case h.invalid_literal:
      r = `Invalid literal value, expected ${JSON.stringify(e.expected, R.jsonStringifyReplacer)}`;
      break;
    case h.unrecognized_keys:
      r = `Unrecognized key(s) in object: ${R.joinValues(e.keys, ", ")}`;
      break;
    case h.invalid_union:
      r = "Invalid input";
      break;
    case h.invalid_union_discriminator:
      r = `Invalid discriminator value. Expected ${R.joinValues(e.options)}`;
      break;
    case h.invalid_enum_value:
      r = `Invalid enum value. Expected ${R.joinValues(e.options)}, received '${e.received}'`;
      break;
    case h.invalid_arguments:
      r = "Invalid function arguments";
      break;
    case h.invalid_return_type:
      r = "Invalid function return type";
      break;
    case h.invalid_date:
      r = "Invalid date";
      break;
    case h.invalid_string:
      typeof e.validation == "object" ? "includes" in e.validation ? (r = `Invalid input: must include "${e.validation.includes}"`, typeof e.validation.position == "number" && (r = `${r} at one or more positions greater than or equal to ${e.validation.position}`)) : "startsWith" in e.validation ? r = `Invalid input: must start with "${e.validation.startsWith}"` : "endsWith" in e.validation ? r = `Invalid input: must end with "${e.validation.endsWith}"` : R.assertNever(e.validation) : e.validation !== "regex" ? r = `Invalid ${e.validation}` : r = "Invalid";
      break;
    case h.too_small:
      e.type === "array" ? r = `Array must contain ${e.exact ? "exactly" : e.inclusive ? "at least" : "more than"} ${e.minimum} element(s)` : e.type === "string" ? r = `String must contain ${e.exact ? "exactly" : e.inclusive ? "at least" : "over"} ${e.minimum} character(s)` : e.type === "number" ? r = `Number must be ${e.exact ? "exactly equal to " : e.inclusive ? "greater than or equal to " : "greater than "}${e.minimum}` : e.type === "date" ? r = `Date must be ${e.exact ? "exactly equal to " : e.inclusive ? "greater than or equal to " : "greater than "}${new Date(Number(e.minimum))}` : r = "Invalid input";
      break;
    case h.too_big:
      e.type === "array" ? r = `Array must contain ${e.exact ? "exactly" : e.inclusive ? "at most" : "less than"} ${e.maximum} element(s)` : e.type === "string" ? r = `String must contain ${e.exact ? "exactly" : e.inclusive ? "at most" : "under"} ${e.maximum} character(s)` : e.type === "number" ? r = `Number must be ${e.exact ? "exactly" : e.inclusive ? "less than or equal to" : "less than"} ${e.maximum}` : e.type === "bigint" ? r = `BigInt must be ${e.exact ? "exactly" : e.inclusive ? "less than or equal to" : "less than"} ${e.maximum}` : e.type === "date" ? r = `Date must be ${e.exact ? "exactly" : e.inclusive ? "smaller than or equal to" : "smaller than"} ${new Date(Number(e.maximum))}` : r = "Invalid input";
      break;
    case h.custom:
      r = "Invalid input";
      break;
    case h.invalid_intersection_types:
      r = "Intersection results could not be merged";
      break;
    case h.not_multiple_of:
      r = `Number must be a multiple of ${e.multipleOf}`;
      break;
    case h.not_finite:
      r = "Number must be finite";
      break;
    default:
      r = t.defaultError, R.assertNever(e);
  }
  return { message: r };
};
let hm = Wr;
function pm() {
  return hm;
}
const ym = (e) => {
  const { data: t, path: r, errorMaps: n, issueData: a } = e, s = [...r, ...a.path || []], i = {
    ...a,
    path: s
  };
  if (a.message !== void 0)
    return {
      ...a,
      path: s,
      message: a.message
    };
  let o = "";
  const u = n.filter((d) => !!d).slice().reverse();
  for (const d of u)
    o = d(i, { data: t, defaultError: o }).message;
  return {
    ...a,
    path: s,
    message: o
  };
};
function p(e, t) {
  const r = pm(), n = ym({
    issueData: t,
    data: e.data,
    path: e.path,
    errorMaps: [
      e.common.contextualErrorMap,
      // contextual error map is first priority
      e.schemaErrorMap,
      // then schema-bound map if available
      r,
      // then global override map
      r === Wr ? void 0 : Wr
      // then global default map
    ].filter((a) => !!a)
  });
  e.common.issues.push(n);
}
class B {
  constructor() {
    this.value = "valid";
  }
  dirty() {
    this.value === "valid" && (this.value = "dirty");
  }
  abort() {
    this.value !== "aborted" && (this.value = "aborted");
  }
  static mergeArray(t, r) {
    const n = [];
    for (const a of r) {
      if (a.status === "aborted")
        return S;
      a.status === "dirty" && t.dirty(), n.push(a.value);
    }
    return { status: t.value, value: n };
  }
  static async mergeObjectAsync(t, r) {
    const n = [];
    for (const a of r) {
      const s = await a.key, i = await a.value;
      n.push({
        key: s,
        value: i
      });
    }
    return B.mergeObjectSync(t, n);
  }
  static mergeObjectSync(t, r) {
    const n = {};
    for (const a of r) {
      const { key: s, value: i } = a;
      if (s.status === "aborted" || i.status === "aborted")
        return S;
      s.status === "dirty" && t.dirty(), i.status === "dirty" && t.dirty(), s.value !== "__proto__" && (typeof i.value < "u" || a.alwaysSet) && (n[s.value] = i.value);
    }
    return { status: t.value, value: n };
  }
}
const S = Object.freeze({
  status: "aborted"
}), yt = (e) => ({ status: "dirty", value: e }), Q = (e) => ({ status: "valid", value: e }), $a = (e) => e.status === "aborted", Ea = (e) => e.status === "dirty", Qe = (e) => e.status === "valid", Kt = (e) => typeof Promise < "u" && e instanceof Promise;
var v;
(function(e) {
  e.errToObj = (t) => typeof t == "string" ? { message: t } : t || {}, e.toString = (t) => typeof t == "string" ? t : t == null ? void 0 : t.message;
})(v || (v = {}));
var Bt = function(e, t, r, n) {
  if (r === "a" && !n) throw new TypeError("Private accessor was defined without a getter");
  if (typeof t == "function" ? e !== t || !n : !t.has(e)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return r === "m" ? n : r === "a" ? n.call(e) : n ? n.value : t.get(e);
}, Rs = function(e, t, r, n, a) {
  if (n === "m") throw new TypeError("Private method is not writable");
  if (n === "a" && !a) throw new TypeError("Private accessor was defined without a setter");
  if (typeof t == "function" ? e !== t || !a : !t.has(e)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
  return n === "a" ? a.call(e, r) : a ? a.value = r : t.set(e, r), r;
}, mt, vt;
class ee {
  constructor(t, r, n, a) {
    this._cachedPath = [], this.parent = t, this.data = r, this._path = n, this._key = a;
  }
  get path() {
    return this._cachedPath.length || (Array.isArray(this._key) ? this._cachedPath.push(...this._path, ...this._key) : this._cachedPath.push(...this._path, this._key)), this._cachedPath;
  }
}
const wa = (e, t) => {
  if (Qe(t))
    return { success: !0, data: t.value };
  if (!e.common.issues.length)
    throw new Error("Validation failed but no issues detected.");
  return {
    success: !1,
    get error() {
      if (this._error)
        return this._error;
      const r = new ue(e.common.issues);
      return this._error = r, this._error;
    }
  };
};
function $(e) {
  if (!e)
    return {};
  const { errorMap: t, invalid_type_error: r, required_error: n, description: a } = e;
  if (t && (r || n))
    throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
  return t ? { errorMap: t, description: a } : { errorMap: (i, o) => {
    const { message: u } = e;
    return i.code === "invalid_enum_value" ? { message: u ?? o.defaultError } : typeof o.data > "u" ? { message: u ?? n ?? o.defaultError } : i.code !== "invalid_type" ? { message: o.defaultError } : { message: u ?? r ?? o.defaultError };
  }, description: a };
}
class C {
  get description() {
    return this._def.description;
  }
  _getType(t) {
    return ge(t.data);
  }
  _getOrReturnCtx(t, r) {
    return r || {
      common: t.parent.common,
      data: t.data,
      parsedType: ge(t.data),
      schemaErrorMap: this._def.errorMap,
      path: t.path,
      parent: t.parent
    };
  }
  _processInputParams(t) {
    return {
      status: new B(),
      ctx: {
        common: t.parent.common,
        data: t.data,
        parsedType: ge(t.data),
        schemaErrorMap: this._def.errorMap,
        path: t.path,
        parent: t.parent
      }
    };
  }
  _parseSync(t) {
    const r = this._parse(t);
    if (Kt(r))
      throw new Error("Synchronous parse encountered promise.");
    return r;
  }
  _parseAsync(t) {
    const r = this._parse(t);
    return Promise.resolve(r);
  }
  parse(t, r) {
    const n = this.safeParse(t, r);
    if (n.success)
      return n.data;
    throw n.error;
  }
  safeParse(t, r) {
    const n = {
      common: {
        issues: [],
        async: (r == null ? void 0 : r.async) ?? !1,
        contextualErrorMap: r == null ? void 0 : r.errorMap
      },
      path: (r == null ? void 0 : r.path) || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: t,
      parsedType: ge(t)
    }, a = this._parseSync({ data: t, path: n.path, parent: n });
    return wa(n, a);
  }
  "~validate"(t) {
    var n, a;
    const r = {
      common: {
        issues: [],
        async: !!this["~standard"].async
      },
      path: [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: t,
      parsedType: ge(t)
    };
    if (!this["~standard"].async)
      try {
        const s = this._parseSync({ data: t, path: [], parent: r });
        return Qe(s) ? {
          value: s.value
        } : {
          issues: r.common.issues
        };
      } catch (s) {
        (a = (n = s == null ? void 0 : s.message) == null ? void 0 : n.toLowerCase()) != null && a.includes("encountered") && (this["~standard"].async = !0), r.common = {
          issues: [],
          async: !0
        };
      }
    return this._parseAsync({ data: t, path: [], parent: r }).then((s) => Qe(s) ? {
      value: s.value
    } : {
      issues: r.common.issues
    });
  }
  async parseAsync(t, r) {
    const n = await this.safeParseAsync(t, r);
    if (n.success)
      return n.data;
    throw n.error;
  }
  async safeParseAsync(t, r) {
    const n = {
      common: {
        issues: [],
        contextualErrorMap: r == null ? void 0 : r.errorMap,
        async: !0
      },
      path: (r == null ? void 0 : r.path) || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: t,
      parsedType: ge(t)
    }, a = this._parse({ data: t, path: n.path, parent: n }), s = await (Kt(a) ? a : Promise.resolve(a));
    return wa(n, s);
  }
  refine(t, r) {
    const n = (a) => typeof r == "string" || typeof r > "u" ? { message: r } : typeof r == "function" ? r(a) : r;
    return this._refinement((a, s) => {
      const i = t(a), o = () => s.addIssue({
        code: h.custom,
        ...n(a)
      });
      return typeof Promise < "u" && i instanceof Promise ? i.then((u) => u ? !0 : (o(), !1)) : i ? !0 : (o(), !1);
    });
  }
  refinement(t, r) {
    return this._refinement((n, a) => t(n) ? !0 : (a.addIssue(typeof r == "function" ? r(n, a) : r), !1));
  }
  _refinement(t) {
    return new le({
      schema: this,
      typeName: b.ZodEffects,
      effect: { type: "refinement", refinement: t }
    });
  }
  superRefine(t) {
    return this._refinement(t);
  }
  constructor(t) {
    this.spa = this.safeParseAsync, this._def = t, this.parse = this.parse.bind(this), this.safeParse = this.safeParse.bind(this), this.parseAsync = this.parseAsync.bind(this), this.safeParseAsync = this.safeParseAsync.bind(this), this.spa = this.spa.bind(this), this.refine = this.refine.bind(this), this.refinement = this.refinement.bind(this), this.superRefine = this.superRefine.bind(this), this.optional = this.optional.bind(this), this.nullable = this.nullable.bind(this), this.nullish = this.nullish.bind(this), this.array = this.array.bind(this), this.promise = this.promise.bind(this), this.or = this.or.bind(this), this.and = this.and.bind(this), this.transform = this.transform.bind(this), this.brand = this.brand.bind(this), this.default = this.default.bind(this), this.catch = this.catch.bind(this), this.describe = this.describe.bind(this), this.pipe = this.pipe.bind(this), this.readonly = this.readonly.bind(this), this.isNullable = this.isNullable.bind(this), this.isOptional = this.isOptional.bind(this), this["~standard"] = {
      version: 1,
      vendor: "zod",
      validate: (r) => this["~validate"](r)
    };
  }
  optional() {
    return ce.create(this, this._def);
  }
  nullable() {
    return Pe.create(this, this._def);
  }
  nullish() {
    return this.nullable().optional();
  }
  array() {
    return X.create(this);
  }
  promise() {
    return Yt.create(this, this._def);
  }
  or(t) {
    return Ft.create([this, t], this._def);
  }
  and(t) {
    return Wt.create(this, t, this._def);
  }
  transform(t) {
    return new le({
      ...$(this._def),
      schema: this,
      typeName: b.ZodEffects,
      effect: { type: "transform", transform: t }
    });
  }
  default(t) {
    const r = typeof t == "function" ? t : () => t;
    return new Xt({
      ...$(this._def),
      innerType: this,
      defaultValue: r,
      typeName: b.ZodDefault
    });
  }
  brand() {
    return new Ps({
      typeName: b.ZodBranded,
      type: this,
      ...$(this._def)
    });
  }
  catch(t) {
    const r = typeof t == "function" ? t : () => t;
    return new er({
      ...$(this._def),
      innerType: this,
      catchValue: r,
      typeName: b.ZodCatch
    });
  }
  describe(t) {
    const r = this.constructor;
    return new r({
      ...this._def,
      description: t
    });
  }
  pipe(t) {
    return _n.create(this, t);
  }
  readonly() {
    return tr.create(this);
  }
  isOptional() {
    return this.safeParse(void 0).success;
  }
  isNullable() {
    return this.safeParse(null).success;
  }
}
const mm = /^c[^\s-]{8,}$/i, vm = /^[0-9a-z]+$/, gm = /^[0-9A-HJKMNP-TV-Z]{26}$/i, _m = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i, bm = /^[a-z0-9_-]{21}$/i, Sm = /^[A-Za-z0-9-_]+\.[A-Za-z0-9-_]+\.[A-Za-z0-9-_]*$/, Am = /^[-+]?P(?!$)(?:(?:[-+]?\d+Y)|(?:[-+]?\d+[.,]\d+Y$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:(?:[-+]?\d+W)|(?:[-+]?\d+[.,]\d+W$))?(?:(?:[-+]?\d+D)|(?:[-+]?\d+[.,]\d+D$))?(?:T(?=[\d+-])(?:(?:[-+]?\d+H)|(?:[-+]?\d+[.,]\d+H$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:[-+]?\d+(?:[.,]\d+)?S)?)??$/, Tm = /^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i, $m = "^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$";
let Vr;
const Em = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/, wm = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/(3[0-2]|[12]?[0-9])$/, Cm = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))$/, xm = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/, Rm = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/, Om = /^([0-9a-zA-Z-_]{4})*(([0-9a-zA-Z-_]{2}(==)?)|([0-9a-zA-Z-_]{3}(=)?))?$/, Os = "((\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-((0[13578]|1[02])-(0[1-9]|[12]\\d|3[01])|(0[469]|11)-(0[1-9]|[12]\\d|30)|(02)-(0[1-9]|1\\d|2[0-8])))", Im = new RegExp(`^${Os}$`);
function Is(e) {
  let t = "[0-5]\\d";
  e.precision ? t = `${t}\\.\\d{${e.precision}}` : e.precision == null && (t = `${t}(\\.\\d+)?`);
  const r = e.precision ? "+" : "?";
  return `([01]\\d|2[0-3]):[0-5]\\d(:${t})${r}`;
}
function km(e) {
  return new RegExp(`^${Is(e)}$`);
}
function Pm(e) {
  let t = `${Os}T${Is(e)}`;
  const r = [];
  return r.push(e.local ? "Z?" : "Z"), e.offset && r.push("([+-]\\d{2}:?\\d{2})"), t = `${t}(${r.join("|")})`, new RegExp(`^${t}$`);
}
function Vm(e, t) {
  return !!((t === "v4" || !t) && Em.test(e) || (t === "v6" || !t) && Cm.test(e));
}
function Nm(e, t) {
  if (!Sm.test(e))
    return !1;
  try {
    const [r] = e.split("."), n = r.replace(/-/g, "+").replace(/_/g, "/").padEnd(r.length + (4 - r.length % 4) % 4, "="), a = JSON.parse(atob(n));
    return !(typeof a != "object" || a === null || "typ" in a && (a == null ? void 0 : a.typ) !== "JWT" || !a.alg || t && a.alg !== t);
  } catch {
    return !1;
  }
}
function Mm(e, t) {
  return !!((t === "v4" || !t) && wm.test(e) || (t === "v6" || !t) && xm.test(e));
}
class oe extends C {
  _parse(t) {
    if (this._def.coerce && (t.data = String(t.data)), this._getType(t) !== m.string) {
      const s = this._getOrReturnCtx(t);
      return p(s, {
        code: h.invalid_type,
        expected: m.string,
        received: s.parsedType
      }), S;
    }
    const n = new B();
    let a;
    for (const s of this._def.checks)
      if (s.kind === "min")
        t.data.length < s.value && (a = this._getOrReturnCtx(t, a), p(a, {
          code: h.too_small,
          minimum: s.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: s.message
        }), n.dirty());
      else if (s.kind === "max")
        t.data.length > s.value && (a = this._getOrReturnCtx(t, a), p(a, {
          code: h.too_big,
          maximum: s.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: s.message
        }), n.dirty());
      else if (s.kind === "length") {
        const i = t.data.length > s.value, o = t.data.length < s.value;
        (i || o) && (a = this._getOrReturnCtx(t, a), i ? p(a, {
          code: h.too_big,
          maximum: s.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: s.message
        }) : o && p(a, {
          code: h.too_small,
          minimum: s.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: s.message
        }), n.dirty());
      } else if (s.kind === "email")
        Tm.test(t.data) || (a = this._getOrReturnCtx(t, a), p(a, {
          validation: "email",
          code: h.invalid_string,
          message: s.message
        }), n.dirty());
      else if (s.kind === "emoji")
        Vr || (Vr = new RegExp($m, "u")), Vr.test(t.data) || (a = this._getOrReturnCtx(t, a), p(a, {
          validation: "emoji",
          code: h.invalid_string,
          message: s.message
        }), n.dirty());
      else if (s.kind === "uuid")
        _m.test(t.data) || (a = this._getOrReturnCtx(t, a), p(a, {
          validation: "uuid",
          code: h.invalid_string,
          message: s.message
        }), n.dirty());
      else if (s.kind === "nanoid")
        bm.test(t.data) || (a = this._getOrReturnCtx(t, a), p(a, {
          validation: "nanoid",
          code: h.invalid_string,
          message: s.message
        }), n.dirty());
      else if (s.kind === "cuid")
        mm.test(t.data) || (a = this._getOrReturnCtx(t, a), p(a, {
          validation: "cuid",
          code: h.invalid_string,
          message: s.message
        }), n.dirty());
      else if (s.kind === "cuid2")
        vm.test(t.data) || (a = this._getOrReturnCtx(t, a), p(a, {
          validation: "cuid2",
          code: h.invalid_string,
          message: s.message
        }), n.dirty());
      else if (s.kind === "ulid")
        gm.test(t.data) || (a = this._getOrReturnCtx(t, a), p(a, {
          validation: "ulid",
          code: h.invalid_string,
          message: s.message
        }), n.dirty());
      else if (s.kind === "url")
        try {
          new URL(t.data);
        } catch {
          a = this._getOrReturnCtx(t, a), p(a, {
            validation: "url",
            code: h.invalid_string,
            message: s.message
          }), n.dirty();
        }
      else s.kind === "regex" ? (s.regex.lastIndex = 0, s.regex.test(t.data) || (a = this._getOrReturnCtx(t, a), p(a, {
        validation: "regex",
        code: h.invalid_string,
        message: s.message
      }), n.dirty())) : s.kind === "trim" ? t.data = t.data.trim() : s.kind === "includes" ? t.data.includes(s.value, s.position) || (a = this._getOrReturnCtx(t, a), p(a, {
        code: h.invalid_string,
        validation: { includes: s.value, position: s.position },
        message: s.message
      }), n.dirty()) : s.kind === "toLowerCase" ? t.data = t.data.toLowerCase() : s.kind === "toUpperCase" ? t.data = t.data.toUpperCase() : s.kind === "startsWith" ? t.data.startsWith(s.value) || (a = this._getOrReturnCtx(t, a), p(a, {
        code: h.invalid_string,
        validation: { startsWith: s.value },
        message: s.message
      }), n.dirty()) : s.kind === "endsWith" ? t.data.endsWith(s.value) || (a = this._getOrReturnCtx(t, a), p(a, {
        code: h.invalid_string,
        validation: { endsWith: s.value },
        message: s.message
      }), n.dirty()) : s.kind === "datetime" ? Pm(s).test(t.data) || (a = this._getOrReturnCtx(t, a), p(a, {
        code: h.invalid_string,
        validation: "datetime",
        message: s.message
      }), n.dirty()) : s.kind === "date" ? Im.test(t.data) || (a = this._getOrReturnCtx(t, a), p(a, {
        code: h.invalid_string,
        validation: "date",
        message: s.message
      }), n.dirty()) : s.kind === "time" ? km(s).test(t.data) || (a = this._getOrReturnCtx(t, a), p(a, {
        code: h.invalid_string,
        validation: "time",
        message: s.message
      }), n.dirty()) : s.kind === "duration" ? Am.test(t.data) || (a = this._getOrReturnCtx(t, a), p(a, {
        validation: "duration",
        code: h.invalid_string,
        message: s.message
      }), n.dirty()) : s.kind === "ip" ? Vm(t.data, s.version) || (a = this._getOrReturnCtx(t, a), p(a, {
        validation: "ip",
        code: h.invalid_string,
        message: s.message
      }), n.dirty()) : s.kind === "jwt" ? Nm(t.data, s.alg) || (a = this._getOrReturnCtx(t, a), p(a, {
        validation: "jwt",
        code: h.invalid_string,
        message: s.message
      }), n.dirty()) : s.kind === "cidr" ? Mm(t.data, s.version) || (a = this._getOrReturnCtx(t, a), p(a, {
        validation: "cidr",
        code: h.invalid_string,
        message: s.message
      }), n.dirty()) : s.kind === "base64" ? Rm.test(t.data) || (a = this._getOrReturnCtx(t, a), p(a, {
        validation: "base64",
        code: h.invalid_string,
        message: s.message
      }), n.dirty()) : s.kind === "base64url" ? Om.test(t.data) || (a = this._getOrReturnCtx(t, a), p(a, {
        validation: "base64url",
        code: h.invalid_string,
        message: s.message
      }), n.dirty()) : R.assertNever(s);
    return { status: n.value, value: t.data };
  }
  _regex(t, r, n) {
    return this.refinement((a) => t.test(a), {
      validation: r,
      code: h.invalid_string,
      ...v.errToObj(n)
    });
  }
  _addCheck(t) {
    return new oe({
      ...this._def,
      checks: [...this._def.checks, t]
    });
  }
  email(t) {
    return this._addCheck({ kind: "email", ...v.errToObj(t) });
  }
  url(t) {
    return this._addCheck({ kind: "url", ...v.errToObj(t) });
  }
  emoji(t) {
    return this._addCheck({ kind: "emoji", ...v.errToObj(t) });
  }
  uuid(t) {
    return this._addCheck({ kind: "uuid", ...v.errToObj(t) });
  }
  nanoid(t) {
    return this._addCheck({ kind: "nanoid", ...v.errToObj(t) });
  }
  cuid(t) {
    return this._addCheck({ kind: "cuid", ...v.errToObj(t) });
  }
  cuid2(t) {
    return this._addCheck({ kind: "cuid2", ...v.errToObj(t) });
  }
  ulid(t) {
    return this._addCheck({ kind: "ulid", ...v.errToObj(t) });
  }
  base64(t) {
    return this._addCheck({ kind: "base64", ...v.errToObj(t) });
  }
  base64url(t) {
    return this._addCheck({
      kind: "base64url",
      ...v.errToObj(t)
    });
  }
  jwt(t) {
    return this._addCheck({ kind: "jwt", ...v.errToObj(t) });
  }
  ip(t) {
    return this._addCheck({ kind: "ip", ...v.errToObj(t) });
  }
  cidr(t) {
    return this._addCheck({ kind: "cidr", ...v.errToObj(t) });
  }
  datetime(t) {
    return typeof t == "string" ? this._addCheck({
      kind: "datetime",
      precision: null,
      offset: !1,
      local: !1,
      message: t
    }) : this._addCheck({
      kind: "datetime",
      precision: typeof (t == null ? void 0 : t.precision) > "u" ? null : t == null ? void 0 : t.precision,
      offset: (t == null ? void 0 : t.offset) ?? !1,
      local: (t == null ? void 0 : t.local) ?? !1,
      ...v.errToObj(t == null ? void 0 : t.message)
    });
  }
  date(t) {
    return this._addCheck({ kind: "date", message: t });
  }
  time(t) {
    return typeof t == "string" ? this._addCheck({
      kind: "time",
      precision: null,
      message: t
    }) : this._addCheck({
      kind: "time",
      precision: typeof (t == null ? void 0 : t.precision) > "u" ? null : t == null ? void 0 : t.precision,
      ...v.errToObj(t == null ? void 0 : t.message)
    });
  }
  duration(t) {
    return this._addCheck({ kind: "duration", ...v.errToObj(t) });
  }
  regex(t, r) {
    return this._addCheck({
      kind: "regex",
      regex: t,
      ...v.errToObj(r)
    });
  }
  includes(t, r) {
    return this._addCheck({
      kind: "includes",
      value: t,
      position: r == null ? void 0 : r.position,
      ...v.errToObj(r == null ? void 0 : r.message)
    });
  }
  startsWith(t, r) {
    return this._addCheck({
      kind: "startsWith",
      value: t,
      ...v.errToObj(r)
    });
  }
  endsWith(t, r) {
    return this._addCheck({
      kind: "endsWith",
      value: t,
      ...v.errToObj(r)
    });
  }
  min(t, r) {
    return this._addCheck({
      kind: "min",
      value: t,
      ...v.errToObj(r)
    });
  }
  max(t, r) {
    return this._addCheck({
      kind: "max",
      value: t,
      ...v.errToObj(r)
    });
  }
  length(t, r) {
    return this._addCheck({
      kind: "length",
      value: t,
      ...v.errToObj(r)
    });
  }
  /**
   * Equivalent to `.min(1)`
   */
  nonempty(t) {
    return this.min(1, v.errToObj(t));
  }
  trim() {
    return new oe({
      ...this._def,
      checks: [...this._def.checks, { kind: "trim" }]
    });
  }
  toLowerCase() {
    return new oe({
      ...this._def,
      checks: [...this._def.checks, { kind: "toLowerCase" }]
    });
  }
  toUpperCase() {
    return new oe({
      ...this._def,
      checks: [...this._def.checks, { kind: "toUpperCase" }]
    });
  }
  get isDatetime() {
    return !!this._def.checks.find((t) => t.kind === "datetime");
  }
  get isDate() {
    return !!this._def.checks.find((t) => t.kind === "date");
  }
  get isTime() {
    return !!this._def.checks.find((t) => t.kind === "time");
  }
  get isDuration() {
    return !!this._def.checks.find((t) => t.kind === "duration");
  }
  get isEmail() {
    return !!this._def.checks.find((t) => t.kind === "email");
  }
  get isURL() {
    return !!this._def.checks.find((t) => t.kind === "url");
  }
  get isEmoji() {
    return !!this._def.checks.find((t) => t.kind === "emoji");
  }
  get isUUID() {
    return !!this._def.checks.find((t) => t.kind === "uuid");
  }
  get isNANOID() {
    return !!this._def.checks.find((t) => t.kind === "nanoid");
  }
  get isCUID() {
    return !!this._def.checks.find((t) => t.kind === "cuid");
  }
  get isCUID2() {
    return !!this._def.checks.find((t) => t.kind === "cuid2");
  }
  get isULID() {
    return !!this._def.checks.find((t) => t.kind === "ulid");
  }
  get isIP() {
    return !!this._def.checks.find((t) => t.kind === "ip");
  }
  get isCIDR() {
    return !!this._def.checks.find((t) => t.kind === "cidr");
  }
  get isBase64() {
    return !!this._def.checks.find((t) => t.kind === "base64");
  }
  get isBase64url() {
    return !!this._def.checks.find((t) => t.kind === "base64url");
  }
  get minLength() {
    let t = null;
    for (const r of this._def.checks)
      r.kind === "min" && (t === null || r.value > t) && (t = r.value);
    return t;
  }
  get maxLength() {
    let t = null;
    for (const r of this._def.checks)
      r.kind === "max" && (t === null || r.value < t) && (t = r.value);
    return t;
  }
}
oe.create = (e) => new oe({
  checks: [],
  typeName: b.ZodString,
  coerce: (e == null ? void 0 : e.coerce) ?? !1,
  ...$(e)
});
function jm(e, t) {
  const r = (e.toString().split(".")[1] || "").length, n = (t.toString().split(".")[1] || "").length, a = r > n ? r : n, s = Number.parseInt(e.toFixed(a).replace(".", "")), i = Number.parseInt(t.toFixed(a).replace(".", ""));
  return s % i / 10 ** a;
}
class Ye extends C {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte, this.step = this.multipleOf;
  }
  _parse(t) {
    if (this._def.coerce && (t.data = Number(t.data)), this._getType(t) !== m.number) {
      const s = this._getOrReturnCtx(t);
      return p(s, {
        code: h.invalid_type,
        expected: m.number,
        received: s.parsedType
      }), S;
    }
    let n;
    const a = new B();
    for (const s of this._def.checks)
      s.kind === "int" ? R.isInteger(t.data) || (n = this._getOrReturnCtx(t, n), p(n, {
        code: h.invalid_type,
        expected: "integer",
        received: "float",
        message: s.message
      }), a.dirty()) : s.kind === "min" ? (s.inclusive ? t.data < s.value : t.data <= s.value) && (n = this._getOrReturnCtx(t, n), p(n, {
        code: h.too_small,
        minimum: s.value,
        type: "number",
        inclusive: s.inclusive,
        exact: !1,
        message: s.message
      }), a.dirty()) : s.kind === "max" ? (s.inclusive ? t.data > s.value : t.data >= s.value) && (n = this._getOrReturnCtx(t, n), p(n, {
        code: h.too_big,
        maximum: s.value,
        type: "number",
        inclusive: s.inclusive,
        exact: !1,
        message: s.message
      }), a.dirty()) : s.kind === "multipleOf" ? jm(t.data, s.value) !== 0 && (n = this._getOrReturnCtx(t, n), p(n, {
        code: h.not_multiple_of,
        multipleOf: s.value,
        message: s.message
      }), a.dirty()) : s.kind === "finite" ? Number.isFinite(t.data) || (n = this._getOrReturnCtx(t, n), p(n, {
        code: h.not_finite,
        message: s.message
      }), a.dirty()) : R.assertNever(s);
    return { status: a.value, value: t.data };
  }
  gte(t, r) {
    return this.setLimit("min", t, !0, v.toString(r));
  }
  gt(t, r) {
    return this.setLimit("min", t, !1, v.toString(r));
  }
  lte(t, r) {
    return this.setLimit("max", t, !0, v.toString(r));
  }
  lt(t, r) {
    return this.setLimit("max", t, !1, v.toString(r));
  }
  setLimit(t, r, n, a) {
    return new Ye({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: t,
          value: r,
          inclusive: n,
          message: v.toString(a)
        }
      ]
    });
  }
  _addCheck(t) {
    return new Ye({
      ...this._def,
      checks: [...this._def.checks, t]
    });
  }
  int(t) {
    return this._addCheck({
      kind: "int",
      message: v.toString(t)
    });
  }
  positive(t) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !1,
      message: v.toString(t)
    });
  }
  negative(t) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !1,
      message: v.toString(t)
    });
  }
  nonpositive(t) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !0,
      message: v.toString(t)
    });
  }
  nonnegative(t) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !0,
      message: v.toString(t)
    });
  }
  multipleOf(t, r) {
    return this._addCheck({
      kind: "multipleOf",
      value: t,
      message: v.toString(r)
    });
  }
  finite(t) {
    return this._addCheck({
      kind: "finite",
      message: v.toString(t)
    });
  }
  safe(t) {
    return this._addCheck({
      kind: "min",
      inclusive: !0,
      value: Number.MIN_SAFE_INTEGER,
      message: v.toString(t)
    })._addCheck({
      kind: "max",
      inclusive: !0,
      value: Number.MAX_SAFE_INTEGER,
      message: v.toString(t)
    });
  }
  get minValue() {
    let t = null;
    for (const r of this._def.checks)
      r.kind === "min" && (t === null || r.value > t) && (t = r.value);
    return t;
  }
  get maxValue() {
    let t = null;
    for (const r of this._def.checks)
      r.kind === "max" && (t === null || r.value < t) && (t = r.value);
    return t;
  }
  get isInt() {
    return !!this._def.checks.find((t) => t.kind === "int" || t.kind === "multipleOf" && R.isInteger(t.value));
  }
  get isFinite() {
    let t = null, r = null;
    for (const n of this._def.checks) {
      if (n.kind === "finite" || n.kind === "int" || n.kind === "multipleOf")
        return !0;
      n.kind === "min" ? (r === null || n.value > r) && (r = n.value) : n.kind === "max" && (t === null || n.value < t) && (t = n.value);
    }
    return Number.isFinite(r) && Number.isFinite(t);
  }
}
Ye.create = (e) => new Ye({
  checks: [],
  typeName: b.ZodNumber,
  coerce: (e == null ? void 0 : e.coerce) || !1,
  ...$(e)
});
class Xe extends C {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte;
  }
  _parse(t) {
    if (this._def.coerce)
      try {
        t.data = BigInt(t.data);
      } catch {
        return this._getInvalidInput(t);
      }
    if (this._getType(t) !== m.bigint)
      return this._getInvalidInput(t);
    let n;
    const a = new B();
    for (const s of this._def.checks)
      s.kind === "min" ? (s.inclusive ? t.data < s.value : t.data <= s.value) && (n = this._getOrReturnCtx(t, n), p(n, {
        code: h.too_small,
        type: "bigint",
        minimum: s.value,
        inclusive: s.inclusive,
        message: s.message
      }), a.dirty()) : s.kind === "max" ? (s.inclusive ? t.data > s.value : t.data >= s.value) && (n = this._getOrReturnCtx(t, n), p(n, {
        code: h.too_big,
        type: "bigint",
        maximum: s.value,
        inclusive: s.inclusive,
        message: s.message
      }), a.dirty()) : s.kind === "multipleOf" ? t.data % s.value !== BigInt(0) && (n = this._getOrReturnCtx(t, n), p(n, {
        code: h.not_multiple_of,
        multipleOf: s.value,
        message: s.message
      }), a.dirty()) : R.assertNever(s);
    return { status: a.value, value: t.data };
  }
  _getInvalidInput(t) {
    const r = this._getOrReturnCtx(t);
    return p(r, {
      code: h.invalid_type,
      expected: m.bigint,
      received: r.parsedType
    }), S;
  }
  gte(t, r) {
    return this.setLimit("min", t, !0, v.toString(r));
  }
  gt(t, r) {
    return this.setLimit("min", t, !1, v.toString(r));
  }
  lte(t, r) {
    return this.setLimit("max", t, !0, v.toString(r));
  }
  lt(t, r) {
    return this.setLimit("max", t, !1, v.toString(r));
  }
  setLimit(t, r, n, a) {
    return new Xe({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: t,
          value: r,
          inclusive: n,
          message: v.toString(a)
        }
      ]
    });
  }
  _addCheck(t) {
    return new Xe({
      ...this._def,
      checks: [...this._def.checks, t]
    });
  }
  positive(t) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !1,
      message: v.toString(t)
    });
  }
  negative(t) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !1,
      message: v.toString(t)
    });
  }
  nonpositive(t) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !0,
      message: v.toString(t)
    });
  }
  nonnegative(t) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !0,
      message: v.toString(t)
    });
  }
  multipleOf(t, r) {
    return this._addCheck({
      kind: "multipleOf",
      value: t,
      message: v.toString(r)
    });
  }
  get minValue() {
    let t = null;
    for (const r of this._def.checks)
      r.kind === "min" && (t === null || r.value > t) && (t = r.value);
    return t;
  }
  get maxValue() {
    let t = null;
    for (const r of this._def.checks)
      r.kind === "max" && (t === null || r.value < t) && (t = r.value);
    return t;
  }
}
Xe.create = (e) => new Xe({
  checks: [],
  typeName: b.ZodBigInt,
  coerce: (e == null ? void 0 : e.coerce) ?? !1,
  ...$(e)
});
class Gr extends C {
  _parse(t) {
    if (this._def.coerce && (t.data = !!t.data), this._getType(t) !== m.boolean) {
      const n = this._getOrReturnCtx(t);
      return p(n, {
        code: h.invalid_type,
        expected: m.boolean,
        received: n.parsedType
      }), S;
    }
    return Q(t.data);
  }
}
Gr.create = (e) => new Gr({
  typeName: b.ZodBoolean,
  coerce: (e == null ? void 0 : e.coerce) || !1,
  ...$(e)
});
class gt extends C {
  _parse(t) {
    if (this._def.coerce && (t.data = new Date(t.data)), this._getType(t) !== m.date) {
      const s = this._getOrReturnCtx(t);
      return p(s, {
        code: h.invalid_type,
        expected: m.date,
        received: s.parsedType
      }), S;
    }
    if (Number.isNaN(t.data.getTime())) {
      const s = this._getOrReturnCtx(t);
      return p(s, {
        code: h.invalid_date
      }), S;
    }
    const n = new B();
    let a;
    for (const s of this._def.checks)
      s.kind === "min" ? t.data.getTime() < s.value && (a = this._getOrReturnCtx(t, a), p(a, {
        code: h.too_small,
        message: s.message,
        inclusive: !0,
        exact: !1,
        minimum: s.value,
        type: "date"
      }), n.dirty()) : s.kind === "max" ? t.data.getTime() > s.value && (a = this._getOrReturnCtx(t, a), p(a, {
        code: h.too_big,
        message: s.message,
        inclusive: !0,
        exact: !1,
        maximum: s.value,
        type: "date"
      }), n.dirty()) : R.assertNever(s);
    return {
      status: n.value,
      value: new Date(t.data.getTime())
    };
  }
  _addCheck(t) {
    return new gt({
      ...this._def,
      checks: [...this._def.checks, t]
    });
  }
  min(t, r) {
    return this._addCheck({
      kind: "min",
      value: t.getTime(),
      message: v.toString(r)
    });
  }
  max(t, r) {
    return this._addCheck({
      kind: "max",
      value: t.getTime(),
      message: v.toString(r)
    });
  }
  get minDate() {
    let t = null;
    for (const r of this._def.checks)
      r.kind === "min" && (t === null || r.value > t) && (t = r.value);
    return t != null ? new Date(t) : null;
  }
  get maxDate() {
    let t = null;
    for (const r of this._def.checks)
      r.kind === "max" && (t === null || r.value < t) && (t = r.value);
    return t != null ? new Date(t) : null;
  }
}
gt.create = (e) => new gt({
  checks: [],
  coerce: (e == null ? void 0 : e.coerce) || !1,
  typeName: b.ZodDate,
  ...$(e)
});
class Jr extends C {
  _parse(t) {
    if (this._getType(t) !== m.symbol) {
      const n = this._getOrReturnCtx(t);
      return p(n, {
        code: h.invalid_type,
        expected: m.symbol,
        received: n.parsedType
      }), S;
    }
    return Q(t.data);
  }
}
Jr.create = (e) => new Jr({
  typeName: b.ZodSymbol,
  ...$(e)
});
class qt extends C {
  _parse(t) {
    if (this._getType(t) !== m.undefined) {
      const n = this._getOrReturnCtx(t);
      return p(n, {
        code: h.invalid_type,
        expected: m.undefined,
        received: n.parsedType
      }), S;
    }
    return Q(t.data);
  }
}
qt.create = (e) => new qt({
  typeName: b.ZodUndefined,
  ...$(e)
});
class Zt extends C {
  _parse(t) {
    if (this._getType(t) !== m.null) {
      const n = this._getOrReturnCtx(t);
      return p(n, {
        code: h.invalid_type,
        expected: m.null,
        received: n.parsedType
      }), S;
    }
    return Q(t.data);
  }
}
Zt.create = (e) => new Zt({
  typeName: b.ZodNull,
  ...$(e)
});
class _t extends C {
  constructor() {
    super(...arguments), this._any = !0;
  }
  _parse(t) {
    return Q(t.data);
  }
}
_t.create = (e) => new _t({
  typeName: b.ZodAny,
  ...$(e)
});
class zr extends C {
  constructor() {
    super(...arguments), this._unknown = !0;
  }
  _parse(t) {
    return Q(t.data);
  }
}
zr.create = (e) => new zr({
  typeName: b.ZodUnknown,
  ...$(e)
});
class Se extends C {
  _parse(t) {
    const r = this._getOrReturnCtx(t);
    return p(r, {
      code: h.invalid_type,
      expected: m.never,
      received: r.parsedType
    }), S;
  }
}
Se.create = (e) => new Se({
  typeName: b.ZodNever,
  ...$(e)
});
class Qr extends C {
  _parse(t) {
    if (this._getType(t) !== m.undefined) {
      const n = this._getOrReturnCtx(t);
      return p(n, {
        code: h.invalid_type,
        expected: m.void,
        received: n.parsedType
      }), S;
    }
    return Q(t.data);
  }
}
Qr.create = (e) => new Qr({
  typeName: b.ZodVoid,
  ...$(e)
});
class X extends C {
  _parse(t) {
    const { ctx: r, status: n } = this._processInputParams(t), a = this._def;
    if (r.parsedType !== m.array)
      return p(r, {
        code: h.invalid_type,
        expected: m.array,
        received: r.parsedType
      }), S;
    if (a.exactLength !== null) {
      const i = r.data.length > a.exactLength.value, o = r.data.length < a.exactLength.value;
      (i || o) && (p(r, {
        code: i ? h.too_big : h.too_small,
        minimum: o ? a.exactLength.value : void 0,
        maximum: i ? a.exactLength.value : void 0,
        type: "array",
        inclusive: !0,
        exact: !0,
        message: a.exactLength.message
      }), n.dirty());
    }
    if (a.minLength !== null && r.data.length < a.minLength.value && (p(r, {
      code: h.too_small,
      minimum: a.minLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: a.minLength.message
    }), n.dirty()), a.maxLength !== null && r.data.length > a.maxLength.value && (p(r, {
      code: h.too_big,
      maximum: a.maxLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: a.maxLength.message
    }), n.dirty()), r.common.async)
      return Promise.all([...r.data].map((i, o) => a.type._parseAsync(new ee(r, i, r.path, o)))).then((i) => B.mergeArray(n, i));
    const s = [...r.data].map((i, o) => a.type._parseSync(new ee(r, i, r.path, o)));
    return B.mergeArray(n, s);
  }
  get element() {
    return this._def.type;
  }
  min(t, r) {
    return new X({
      ...this._def,
      minLength: { value: t, message: v.toString(r) }
    });
  }
  max(t, r) {
    return new X({
      ...this._def,
      maxLength: { value: t, message: v.toString(r) }
    });
  }
  length(t, r) {
    return new X({
      ...this._def,
      exactLength: { value: t, message: v.toString(r) }
    });
  }
  nonempty(t) {
    return this.min(1, t);
  }
}
X.create = (e, t) => new X({
  type: e,
  minLength: null,
  maxLength: null,
  exactLength: null,
  typeName: b.ZodArray,
  ...$(t)
});
function Ze(e) {
  if (e instanceof V) {
    const t = {};
    for (const r in e.shape) {
      const n = e.shape[r];
      t[r] = ce.create(Ze(n));
    }
    return new V({
      ...e._def,
      shape: () => t
    });
  } else return e instanceof X ? new X({
    ...e._def,
    type: Ze(e.element)
  }) : e instanceof ce ? ce.create(Ze(e.unwrap())) : e instanceof Pe ? Pe.create(Ze(e.unwrap())) : e instanceof Ie ? Ie.create(e.items.map((t) => Ze(t))) : e;
}
class V extends C {
  constructor() {
    super(...arguments), this._cached = null, this.nonstrict = this.passthrough, this.augment = this.extend;
  }
  _getCached() {
    if (this._cached !== null)
      return this._cached;
    const t = this._def.shape(), r = R.objectKeys(t);
    return this._cached = { shape: t, keys: r }, this._cached;
  }
  _parse(t) {
    if (this._getType(t) !== m.object) {
      const d = this._getOrReturnCtx(t);
      return p(d, {
        code: h.invalid_type,
        expected: m.object,
        received: d.parsedType
      }), S;
    }
    const { status: n, ctx: a } = this._processInputParams(t), { shape: s, keys: i } = this._getCached(), o = [];
    if (!(this._def.catchall instanceof Se && this._def.unknownKeys === "strip"))
      for (const d in a.data)
        i.includes(d) || o.push(d);
    const u = [];
    for (const d of i) {
      const y = s[d], A = a.data[d];
      u.push({
        key: { status: "valid", value: d },
        value: y._parse(new ee(a, A, a.path, d)),
        alwaysSet: d in a.data
      });
    }
    if (this._def.catchall instanceof Se) {
      const d = this._def.unknownKeys;
      if (d === "passthrough")
        for (const y of o)
          u.push({
            key: { status: "valid", value: y },
            value: { status: "valid", value: a.data[y] }
          });
      else if (d === "strict")
        o.length > 0 && (p(a, {
          code: h.unrecognized_keys,
          keys: o
        }), n.dirty());
      else if (d !== "strip") throw new Error("Internal ZodObject error: invalid unknownKeys value.");
    } else {
      const d = this._def.catchall;
      for (const y of o) {
        const A = a.data[y];
        u.push({
          key: { status: "valid", value: y },
          value: d._parse(
            new ee(a, A, a.path, y)
            //, ctx.child(key), value, getParsedType(value)
          ),
          alwaysSet: y in a.data
        });
      }
    }
    return a.common.async ? Promise.resolve().then(async () => {
      const d = [];
      for (const y of u) {
        const A = await y.key, E = await y.value;
        d.push({
          key: A,
          value: E,
          alwaysSet: y.alwaysSet
        });
      }
      return d;
    }).then((d) => B.mergeObjectSync(n, d)) : B.mergeObjectSync(n, u);
  }
  get shape() {
    return this._def.shape();
  }
  strict(t) {
    return v.errToObj, new V({
      ...this._def,
      unknownKeys: "strict",
      ...t !== void 0 ? {
        errorMap: (r, n) => {
          var s, i;
          const a = ((i = (s = this._def).errorMap) == null ? void 0 : i.call(s, r, n).message) ?? n.defaultError;
          return r.code === "unrecognized_keys" ? {
            message: v.errToObj(t).message ?? a
          } : {
            message: a
          };
        }
      } : {}
    });
  }
  strip() {
    return new V({
      ...this._def,
      unknownKeys: "strip"
    });
  }
  passthrough() {
    return new V({
      ...this._def,
      unknownKeys: "passthrough"
    });
  }
  // const AugmentFactory =
  //   <Def extends ZodObjectDef>(def: Def) =>
  //   <Augmentation extends ZodRawShape>(
  //     augmentation: Augmentation
  //   ): ZodObject<
  //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
  //     Def["unknownKeys"],
  //     Def["catchall"]
  //   > => {
  //     return new ZodObject({
  //       ...def,
  //       shape: () => ({
  //         ...def.shape(),
  //         ...augmentation,
  //       }),
  //     }) as any;
  //   };
  extend(t) {
    return new V({
      ...this._def,
      shape: () => ({
        ...this._def.shape(),
        ...t
      })
    });
  }
  /**
   * Prior to zod@1.0.12 there was a bug in the
   * inferred type of merged objects. Please
   * upgrade if you are experiencing issues.
   */
  merge(t) {
    return new V({
      unknownKeys: t._def.unknownKeys,
      catchall: t._def.catchall,
      shape: () => ({
        ...this._def.shape(),
        ...t._def.shape()
      }),
      typeName: b.ZodObject
    });
  }
  // merge<
  //   Incoming extends AnyZodObject,
  //   Augmentation extends Incoming["shape"],
  //   NewOutput extends {
  //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
  //       ? Augmentation[k]["_output"]
  //       : k extends keyof Output
  //       ? Output[k]
  //       : never;
  //   },
  //   NewInput extends {
  //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
  //       ? Augmentation[k]["_input"]
  //       : k extends keyof Input
  //       ? Input[k]
  //       : never;
  //   }
  // >(
  //   merging: Incoming
  // ): ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"],
  //   NewOutput,
  //   NewInput
  // > {
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  setKey(t, r) {
    return this.augment({ [t]: r });
  }
  // merge<Incoming extends AnyZodObject>(
  //   merging: Incoming
  // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
  // ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"]
  // > {
  //   // const mergedShape = objectUtil.mergeShapes(
  //   //   this._def.shape(),
  //   //   merging._def.shape()
  //   // );
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  catchall(t) {
    return new V({
      ...this._def,
      catchall: t
    });
  }
  pick(t) {
    const r = {};
    for (const n of R.objectKeys(t))
      t[n] && this.shape[n] && (r[n] = this.shape[n]);
    return new V({
      ...this._def,
      shape: () => r
    });
  }
  omit(t) {
    const r = {};
    for (const n of R.objectKeys(this.shape))
      t[n] || (r[n] = this.shape[n]);
    return new V({
      ...this._def,
      shape: () => r
    });
  }
  /**
   * @deprecated
   */
  deepPartial() {
    return Ze(this);
  }
  partial(t) {
    const r = {};
    for (const n of R.objectKeys(this.shape)) {
      const a = this.shape[n];
      t && !t[n] ? r[n] = a : r[n] = a.optional();
    }
    return new V({
      ...this._def,
      shape: () => r
    });
  }
  required(t) {
    const r = {};
    for (const n of R.objectKeys(this.shape))
      if (t && !t[n])
        r[n] = this.shape[n];
      else {
        let s = this.shape[n];
        for (; s instanceof ce; )
          s = s._def.innerType;
        r[n] = s;
      }
    return new V({
      ...this._def,
      shape: () => r
    });
  }
  keyof() {
    return ks(R.objectKeys(this.shape));
  }
}
V.create = (e, t) => new V({
  shape: () => e,
  unknownKeys: "strip",
  catchall: Se.create(),
  typeName: b.ZodObject,
  ...$(t)
});
V.strictCreate = (e, t) => new V({
  shape: () => e,
  unknownKeys: "strict",
  catchall: Se.create(),
  typeName: b.ZodObject,
  ...$(t)
});
V.lazycreate = (e, t) => new V({
  shape: e,
  unknownKeys: "strip",
  catchall: Se.create(),
  typeName: b.ZodObject,
  ...$(t)
});
class Ft extends C {
  _parse(t) {
    const { ctx: r } = this._processInputParams(t), n = this._def.options;
    function a(s) {
      for (const o of s)
        if (o.result.status === "valid")
          return o.result;
      for (const o of s)
        if (o.result.status === "dirty")
          return r.common.issues.push(...o.ctx.common.issues), o.result;
      const i = s.map((o) => new ue(o.ctx.common.issues));
      return p(r, {
        code: h.invalid_union,
        unionErrors: i
      }), S;
    }
    if (r.common.async)
      return Promise.all(n.map(async (s) => {
        const i = {
          ...r,
          common: {
            ...r.common,
            issues: []
          },
          parent: null
        };
        return {
          result: await s._parseAsync({
            data: r.data,
            path: r.path,
            parent: i
          }),
          ctx: i
        };
      })).then(a);
    {
      let s;
      const i = [];
      for (const u of n) {
        const d = {
          ...r,
          common: {
            ...r.common,
            issues: []
          },
          parent: null
        }, y = u._parseSync({
          data: r.data,
          path: r.path,
          parent: d
        });
        if (y.status === "valid")
          return y;
        y.status === "dirty" && !s && (s = { result: y, ctx: d }), d.common.issues.length && i.push(d.common.issues);
      }
      if (s)
        return r.common.issues.push(...s.ctx.common.issues), s.result;
      const o = i.map((u) => new ue(u));
      return p(r, {
        code: h.invalid_union,
        unionErrors: o
      }), S;
    }
  }
  get options() {
    return this._def.options;
  }
}
Ft.create = (e, t) => new Ft({
  options: e,
  typeName: b.ZodUnion,
  ...$(t)
});
const ie = (e) => e instanceof Jt ? ie(e.schema) : e instanceof le ? ie(e.innerType()) : e instanceof zt ? [e.value] : e instanceof ke ? e.options : e instanceof Qt ? R.objectValues(e.enum) : e instanceof Xt ? ie(e._def.innerType) : e instanceof qt ? [void 0] : e instanceof Zt ? [null] : e instanceof ce ? [void 0, ...ie(e.unwrap())] : e instanceof Pe ? [null, ...ie(e.unwrap())] : e instanceof Ps || e instanceof tr ? ie(e.unwrap()) : e instanceof er ? ie(e._def.innerType) : [];
class gn extends C {
  _parse(t) {
    const { ctx: r } = this._processInputParams(t);
    if (r.parsedType !== m.object)
      return p(r, {
        code: h.invalid_type,
        expected: m.object,
        received: r.parsedType
      }), S;
    const n = this.discriminator, a = r.data[n], s = this.optionsMap.get(a);
    return s ? r.common.async ? s._parseAsync({
      data: r.data,
      path: r.path,
      parent: r
    }) : s._parseSync({
      data: r.data,
      path: r.path,
      parent: r
    }) : (p(r, {
      code: h.invalid_union_discriminator,
      options: Array.from(this.optionsMap.keys()),
      path: [n]
    }), S);
  }
  get discriminator() {
    return this._def.discriminator;
  }
  get options() {
    return this._def.options;
  }
  get optionsMap() {
    return this._def.optionsMap;
  }
  /**
   * The constructor of the discriminated union schema. Its behaviour is very similar to that of the normal z.union() constructor.
   * However, it only allows a union of objects, all of which need to share a discriminator property. This property must
   * have a different value for each object in the union.
   * @param discriminator the name of the discriminator property
   * @param types an array of object schemas
   * @param params
   */
  static create(t, r, n) {
    const a = /* @__PURE__ */ new Map();
    for (const s of r) {
      const i = ie(s.shape[t]);
      if (!i.length)
        throw new Error(`A discriminator value for key \`${t}\` could not be extracted from all schema options`);
      for (const o of i) {
        if (a.has(o))
          throw new Error(`Discriminator property ${String(t)} has duplicate value ${String(o)}`);
        a.set(o, s);
      }
    }
    return new gn({
      typeName: b.ZodDiscriminatedUnion,
      discriminator: t,
      options: r,
      optionsMap: a,
      ...$(n)
    });
  }
}
function Yr(e, t) {
  const r = ge(e), n = ge(t);
  if (e === t)
    return { valid: !0, data: e };
  if (r === m.object && n === m.object) {
    const a = R.objectKeys(t), s = R.objectKeys(e).filter((o) => a.indexOf(o) !== -1), i = { ...e, ...t };
    for (const o of s) {
      const u = Yr(e[o], t[o]);
      if (!u.valid)
        return { valid: !1 };
      i[o] = u.data;
    }
    return { valid: !0, data: i };
  } else if (r === m.array && n === m.array) {
    if (e.length !== t.length)
      return { valid: !1 };
    const a = [];
    for (let s = 0; s < e.length; s++) {
      const i = e[s], o = t[s], u = Yr(i, o);
      if (!u.valid)
        return { valid: !1 };
      a.push(u.data);
    }
    return { valid: !0, data: a };
  } else return r === m.date && n === m.date && +e == +t ? { valid: !0, data: e } : { valid: !1 };
}
class Wt extends C {
  _parse(t) {
    const { status: r, ctx: n } = this._processInputParams(t), a = (s, i) => {
      if ($a(s) || $a(i))
        return S;
      const o = Yr(s.value, i.value);
      return o.valid ? ((Ea(s) || Ea(i)) && r.dirty(), { status: r.value, value: o.data }) : (p(n, {
        code: h.invalid_intersection_types
      }), S);
    };
    return n.common.async ? Promise.all([
      this._def.left._parseAsync({
        data: n.data,
        path: n.path,
        parent: n
      }),
      this._def.right._parseAsync({
        data: n.data,
        path: n.path,
        parent: n
      })
    ]).then(([s, i]) => a(s, i)) : a(this._def.left._parseSync({
      data: n.data,
      path: n.path,
      parent: n
    }), this._def.right._parseSync({
      data: n.data,
      path: n.path,
      parent: n
    }));
  }
}
Wt.create = (e, t, r) => new Wt({
  left: e,
  right: t,
  typeName: b.ZodIntersection,
  ...$(r)
});
class Ie extends C {
  _parse(t) {
    const { status: r, ctx: n } = this._processInputParams(t);
    if (n.parsedType !== m.array)
      return p(n, {
        code: h.invalid_type,
        expected: m.array,
        received: n.parsedType
      }), S;
    if (n.data.length < this._def.items.length)
      return p(n, {
        code: h.too_small,
        minimum: this._def.items.length,
        inclusive: !0,
        exact: !1,
        type: "array"
      }), S;
    !this._def.rest && n.data.length > this._def.items.length && (p(n, {
      code: h.too_big,
      maximum: this._def.items.length,
      inclusive: !0,
      exact: !1,
      type: "array"
    }), r.dirty());
    const s = [...n.data].map((i, o) => {
      const u = this._def.items[o] || this._def.rest;
      return u ? u._parse(new ee(n, i, n.path, o)) : null;
    }).filter((i) => !!i);
    return n.common.async ? Promise.all(s).then((i) => B.mergeArray(r, i)) : B.mergeArray(r, s);
  }
  get items() {
    return this._def.items;
  }
  rest(t) {
    return new Ie({
      ...this._def,
      rest: t
    });
  }
}
Ie.create = (e, t) => {
  if (!Array.isArray(e))
    throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
  return new Ie({
    items: e,
    typeName: b.ZodTuple,
    rest: null,
    ...$(t)
  });
};
class Gt extends C {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(t) {
    const { status: r, ctx: n } = this._processInputParams(t);
    if (n.parsedType !== m.object)
      return p(n, {
        code: h.invalid_type,
        expected: m.object,
        received: n.parsedType
      }), S;
    const a = [], s = this._def.keyType, i = this._def.valueType;
    for (const o in n.data)
      a.push({
        key: s._parse(new ee(n, o, n.path, o)),
        value: i._parse(new ee(n, n.data[o], n.path, o)),
        alwaysSet: o in n.data
      });
    return n.common.async ? B.mergeObjectAsync(r, a) : B.mergeObjectSync(r, a);
  }
  get element() {
    return this._def.valueType;
  }
  static create(t, r, n) {
    return r instanceof C ? new Gt({
      keyType: t,
      valueType: r,
      typeName: b.ZodRecord,
      ...$(n)
    }) : new Gt({
      keyType: oe.create(),
      valueType: t,
      typeName: b.ZodRecord,
      ...$(r)
    });
  }
}
class Xr extends C {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(t) {
    const { status: r, ctx: n } = this._processInputParams(t);
    if (n.parsedType !== m.map)
      return p(n, {
        code: h.invalid_type,
        expected: m.map,
        received: n.parsedType
      }), S;
    const a = this._def.keyType, s = this._def.valueType, i = [...n.data.entries()].map(([o, u], d) => ({
      key: a._parse(new ee(n, o, n.path, [d, "key"])),
      value: s._parse(new ee(n, u, n.path, [d, "value"]))
    }));
    if (n.common.async) {
      const o = /* @__PURE__ */ new Map();
      return Promise.resolve().then(async () => {
        for (const u of i) {
          const d = await u.key, y = await u.value;
          if (d.status === "aborted" || y.status === "aborted")
            return S;
          (d.status === "dirty" || y.status === "dirty") && r.dirty(), o.set(d.value, y.value);
        }
        return { status: r.value, value: o };
      });
    } else {
      const o = /* @__PURE__ */ new Map();
      for (const u of i) {
        const d = u.key, y = u.value;
        if (d.status === "aborted" || y.status === "aborted")
          return S;
        (d.status === "dirty" || y.status === "dirty") && r.dirty(), o.set(d.value, y.value);
      }
      return { status: r.value, value: o };
    }
  }
}
Xr.create = (e, t, r) => new Xr({
  valueType: t,
  keyType: e,
  typeName: b.ZodMap,
  ...$(r)
});
class et extends C {
  _parse(t) {
    const { status: r, ctx: n } = this._processInputParams(t);
    if (n.parsedType !== m.set)
      return p(n, {
        code: h.invalid_type,
        expected: m.set,
        received: n.parsedType
      }), S;
    const a = this._def;
    a.minSize !== null && n.data.size < a.minSize.value && (p(n, {
      code: h.too_small,
      minimum: a.minSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: a.minSize.message
    }), r.dirty()), a.maxSize !== null && n.data.size > a.maxSize.value && (p(n, {
      code: h.too_big,
      maximum: a.maxSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: a.maxSize.message
    }), r.dirty());
    const s = this._def.valueType;
    function i(u) {
      const d = /* @__PURE__ */ new Set();
      for (const y of u) {
        if (y.status === "aborted")
          return S;
        y.status === "dirty" && r.dirty(), d.add(y.value);
      }
      return { status: r.value, value: d };
    }
    const o = [...n.data.values()].map((u, d) => s._parse(new ee(n, u, n.path, d)));
    return n.common.async ? Promise.all(o).then((u) => i(u)) : i(o);
  }
  min(t, r) {
    return new et({
      ...this._def,
      minSize: { value: t, message: v.toString(r) }
    });
  }
  max(t, r) {
    return new et({
      ...this._def,
      maxSize: { value: t, message: v.toString(r) }
    });
  }
  size(t, r) {
    return this.min(t, r).max(t, r);
  }
  nonempty(t) {
    return this.min(1, t);
  }
}
et.create = (e, t) => new et({
  valueType: e,
  minSize: null,
  maxSize: null,
  typeName: b.ZodSet,
  ...$(t)
});
class Jt extends C {
  get schema() {
    return this._def.getter();
  }
  _parse(t) {
    const { ctx: r } = this._processInputParams(t);
    return this._def.getter()._parse({ data: r.data, path: r.path, parent: r });
  }
}
Jt.create = (e, t) => new Jt({
  getter: e,
  typeName: b.ZodLazy,
  ...$(t)
});
class zt extends C {
  _parse(t) {
    if (t.data !== this._def.value) {
      const r = this._getOrReturnCtx(t);
      return p(r, {
        received: r.data,
        code: h.invalid_literal,
        expected: this._def.value
      }), S;
    }
    return { status: "valid", value: t.data };
  }
  get value() {
    return this._def.value;
  }
}
zt.create = (e, t) => new zt({
  value: e,
  typeName: b.ZodLiteral,
  ...$(t)
});
function ks(e, t) {
  return new ke({
    values: e,
    typeName: b.ZodEnum,
    ...$(t)
  });
}
class ke extends C {
  constructor() {
    super(...arguments), mt.set(this, void 0);
  }
  _parse(t) {
    if (typeof t.data != "string") {
      const r = this._getOrReturnCtx(t), n = this._def.values;
      return p(r, {
        expected: R.joinValues(n),
        received: r.parsedType,
        code: h.invalid_type
      }), S;
    }
    if (Bt(this, mt, "f") || Rs(this, mt, new Set(this._def.values), "f"), !Bt(this, mt, "f").has(t.data)) {
      const r = this._getOrReturnCtx(t), n = this._def.values;
      return p(r, {
        received: r.data,
        code: h.invalid_enum_value,
        options: n
      }), S;
    }
    return Q(t.data);
  }
  get options() {
    return this._def.values;
  }
  get enum() {
    const t = {};
    for (const r of this._def.values)
      t[r] = r;
    return t;
  }
  get Values() {
    const t = {};
    for (const r of this._def.values)
      t[r] = r;
    return t;
  }
  get Enum() {
    const t = {};
    for (const r of this._def.values)
      t[r] = r;
    return t;
  }
  extract(t, r = this._def) {
    return ke.create(t, {
      ...this._def,
      ...r
    });
  }
  exclude(t, r = this._def) {
    return ke.create(this.options.filter((n) => !t.includes(n)), {
      ...this._def,
      ...r
    });
  }
}
mt = /* @__PURE__ */ new WeakMap();
ke.create = ks;
class Qt extends C {
  constructor() {
    super(...arguments), vt.set(this, void 0);
  }
  _parse(t) {
    const r = R.getValidEnumValues(this._def.values), n = this._getOrReturnCtx(t);
    if (n.parsedType !== m.string && n.parsedType !== m.number) {
      const a = R.objectValues(r);
      return p(n, {
        expected: R.joinValues(a),
        received: n.parsedType,
        code: h.invalid_type
      }), S;
    }
    if (Bt(this, vt, "f") || Rs(this, vt, new Set(R.getValidEnumValues(this._def.values)), "f"), !Bt(this, vt, "f").has(t.data)) {
      const a = R.objectValues(r);
      return p(n, {
        received: n.data,
        code: h.invalid_enum_value,
        options: a
      }), S;
    }
    return Q(t.data);
  }
  get enum() {
    return this._def.values;
  }
}
vt = /* @__PURE__ */ new WeakMap();
Qt.create = (e, t) => new Qt({
  values: e,
  typeName: b.ZodNativeEnum,
  ...$(t)
});
class Yt extends C {
  unwrap() {
    return this._def.type;
  }
  _parse(t) {
    const { ctx: r } = this._processInputParams(t);
    if (r.parsedType !== m.promise && r.common.async === !1)
      return p(r, {
        code: h.invalid_type,
        expected: m.promise,
        received: r.parsedType
      }), S;
    const n = r.parsedType === m.promise ? r.data : Promise.resolve(r.data);
    return Q(n.then((a) => this._def.type.parseAsync(a, {
      path: r.path,
      errorMap: r.common.contextualErrorMap
    })));
  }
}
Yt.create = (e, t) => new Yt({
  type: e,
  typeName: b.ZodPromise,
  ...$(t)
});
class le extends C {
  innerType() {
    return this._def.schema;
  }
  sourceType() {
    return this._def.schema._def.typeName === b.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
  }
  _parse(t) {
    const { status: r, ctx: n } = this._processInputParams(t), a = this._def.effect || null, s = {
      addIssue: (i) => {
        p(n, i), i.fatal ? r.abort() : r.dirty();
      },
      get path() {
        return n.path;
      }
    };
    if (s.addIssue = s.addIssue.bind(s), a.type === "preprocess") {
      const i = a.transform(n.data, s);
      if (n.common.async)
        return Promise.resolve(i).then(async (o) => {
          if (r.value === "aborted")
            return S;
          const u = await this._def.schema._parseAsync({
            data: o,
            path: n.path,
            parent: n
          });
          return u.status === "aborted" ? S : u.status === "dirty" || r.value === "dirty" ? yt(u.value) : u;
        });
      {
        if (r.value === "aborted")
          return S;
        const o = this._def.schema._parseSync({
          data: i,
          path: n.path,
          parent: n
        });
        return o.status === "aborted" ? S : o.status === "dirty" || r.value === "dirty" ? yt(o.value) : o;
      }
    }
    if (a.type === "refinement") {
      const i = (o) => {
        const u = a.refinement(o, s);
        if (n.common.async)
          return Promise.resolve(u);
        if (u instanceof Promise)
          throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
        return o;
      };
      if (n.common.async === !1) {
        const o = this._def.schema._parseSync({
          data: n.data,
          path: n.path,
          parent: n
        });
        return o.status === "aborted" ? S : (o.status === "dirty" && r.dirty(), i(o.value), { status: r.value, value: o.value });
      } else
        return this._def.schema._parseAsync({ data: n.data, path: n.path, parent: n }).then((o) => o.status === "aborted" ? S : (o.status === "dirty" && r.dirty(), i(o.value).then(() => ({ status: r.value, value: o.value }))));
    }
    if (a.type === "transform")
      if (n.common.async === !1) {
        const i = this._def.schema._parseSync({
          data: n.data,
          path: n.path,
          parent: n
        });
        if (!Qe(i))
          return i;
        const o = a.transform(i.value, s);
        if (o instanceof Promise)
          throw new Error("Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.");
        return { status: r.value, value: o };
      } else
        return this._def.schema._parseAsync({ data: n.data, path: n.path, parent: n }).then((i) => Qe(i) ? Promise.resolve(a.transform(i.value, s)).then((o) => ({
          status: r.value,
          value: o
        })) : i);
    R.assertNever(a);
  }
}
le.create = (e, t, r) => new le({
  schema: e,
  typeName: b.ZodEffects,
  effect: t,
  ...$(r)
});
le.createWithPreprocess = (e, t, r) => new le({
  schema: t,
  effect: { type: "preprocess", transform: e },
  typeName: b.ZodEffects,
  ...$(r)
});
class ce extends C {
  _parse(t) {
    return this._getType(t) === m.undefined ? Q(void 0) : this._def.innerType._parse(t);
  }
  unwrap() {
    return this._def.innerType;
  }
}
ce.create = (e, t) => new ce({
  innerType: e,
  typeName: b.ZodOptional,
  ...$(t)
});
class Pe extends C {
  _parse(t) {
    return this._getType(t) === m.null ? Q(null) : this._def.innerType._parse(t);
  }
  unwrap() {
    return this._def.innerType;
  }
}
Pe.create = (e, t) => new Pe({
  innerType: e,
  typeName: b.ZodNullable,
  ...$(t)
});
class Xt extends C {
  _parse(t) {
    const { ctx: r } = this._processInputParams(t);
    let n = r.data;
    return r.parsedType === m.undefined && (n = this._def.defaultValue()), this._def.innerType._parse({
      data: n,
      path: r.path,
      parent: r
    });
  }
  removeDefault() {
    return this._def.innerType;
  }
}
Xt.create = (e, t) => new Xt({
  innerType: e,
  typeName: b.ZodDefault,
  defaultValue: typeof t.default == "function" ? t.default : () => t.default,
  ...$(t)
});
class er extends C {
  _parse(t) {
    const { ctx: r } = this._processInputParams(t), n = {
      ...r,
      common: {
        ...r.common,
        issues: []
      }
    }, a = this._def.innerType._parse({
      data: n.data,
      path: n.path,
      parent: {
        ...n
      }
    });
    return Kt(a) ? a.then((s) => ({
      status: "valid",
      value: s.status === "valid" ? s.value : this._def.catchValue({
        get error() {
          return new ue(n.common.issues);
        },
        input: n.data
      })
    })) : {
      status: "valid",
      value: a.status === "valid" ? a.value : this._def.catchValue({
        get error() {
          return new ue(n.common.issues);
        },
        input: n.data
      })
    };
  }
  removeCatch() {
    return this._def.innerType;
  }
}
er.create = (e, t) => new er({
  innerType: e,
  typeName: b.ZodCatch,
  catchValue: typeof t.catch == "function" ? t.catch : () => t.catch,
  ...$(t)
});
class en extends C {
  _parse(t) {
    if (this._getType(t) !== m.nan) {
      const n = this._getOrReturnCtx(t);
      return p(n, {
        code: h.invalid_type,
        expected: m.nan,
        received: n.parsedType
      }), S;
    }
    return { status: "valid", value: t.data };
  }
}
en.create = (e) => new en({
  typeName: b.ZodNaN,
  ...$(e)
});
class Ps extends C {
  _parse(t) {
    const { ctx: r } = this._processInputParams(t), n = r.data;
    return this._def.type._parse({
      data: n,
      path: r.path,
      parent: r
    });
  }
  unwrap() {
    return this._def.type;
  }
}
class _n extends C {
  _parse(t) {
    const { status: r, ctx: n } = this._processInputParams(t);
    if (n.common.async)
      return (async () => {
        const s = await this._def.in._parseAsync({
          data: n.data,
          path: n.path,
          parent: n
        });
        return s.status === "aborted" ? S : s.status === "dirty" ? (r.dirty(), yt(s.value)) : this._def.out._parseAsync({
          data: s.value,
          path: n.path,
          parent: n
        });
      })();
    {
      const a = this._def.in._parseSync({
        data: n.data,
        path: n.path,
        parent: n
      });
      return a.status === "aborted" ? S : a.status === "dirty" ? (r.dirty(), {
        status: "dirty",
        value: a.value
      }) : this._def.out._parseSync({
        data: a.value,
        path: n.path,
        parent: n
      });
    }
  }
  static create(t, r) {
    return new _n({
      in: t,
      out: r,
      typeName: b.ZodPipeline
    });
  }
}
class tr extends C {
  _parse(t) {
    const r = this._def.innerType._parse(t), n = (a) => (Qe(a) && (a.value = Object.freeze(a.value)), a);
    return Kt(r) ? r.then((a) => n(a)) : n(r);
  }
  unwrap() {
    return this._def.innerType;
  }
}
tr.create = (e, t) => new tr({
  innerType: e,
  typeName: b.ZodReadonly,
  ...$(t)
});
function Ca(e, t) {
  const r = typeof e == "function" ? e(t) : typeof e == "string" ? { message: e } : e;
  return typeof r == "string" ? { message: r } : r;
}
function bn(e, t = {}, r) {
  return e ? _t.create().superRefine((n, a) => {
    const s = e(n);
    if (s instanceof Promise)
      return s.then((i) => {
        if (!i) {
          const o = Ca(t, n), u = o.fatal ?? r ?? !0;
          a.addIssue({ code: "custom", ...o, fatal: u });
        }
      });
    if (!s) {
      const i = Ca(t, n), o = i.fatal ?? r ?? !0;
      a.addIssue({ code: "custom", ...i, fatal: o });
    }
  }) : _t.create();
}
V.lazycreate;
var b;
(function(e) {
  e.ZodString = "ZodString", e.ZodNumber = "ZodNumber", e.ZodNaN = "ZodNaN", e.ZodBigInt = "ZodBigInt", e.ZodBoolean = "ZodBoolean", e.ZodDate = "ZodDate", e.ZodSymbol = "ZodSymbol", e.ZodUndefined = "ZodUndefined", e.ZodNull = "ZodNull", e.ZodAny = "ZodAny", e.ZodUnknown = "ZodUnknown", e.ZodNever = "ZodNever", e.ZodVoid = "ZodVoid", e.ZodArray = "ZodArray", e.ZodObject = "ZodObject", e.ZodUnion = "ZodUnion", e.ZodDiscriminatedUnion = "ZodDiscriminatedUnion", e.ZodIntersection = "ZodIntersection", e.ZodTuple = "ZodTuple", e.ZodRecord = "ZodRecord", e.ZodMap = "ZodMap", e.ZodSet = "ZodSet", e.ZodFunction = "ZodFunction", e.ZodLazy = "ZodLazy", e.ZodLiteral = "ZodLiteral", e.ZodEnum = "ZodEnum", e.ZodEffects = "ZodEffects", e.ZodNativeEnum = "ZodNativeEnum", e.ZodOptional = "ZodOptional", e.ZodNullable = "ZodNullable", e.ZodDefault = "ZodDefault", e.ZodCatch = "ZodCatch", e.ZodPromise = "ZodPromise", e.ZodBranded = "ZodBranded", e.ZodPipeline = "ZodPipeline", e.ZodReadonly = "ZodReadonly";
})(b || (b = {}));
const mr = (e, t = {
  message: `Input not instance of ${e.name}`
}) => bn((r) => r instanceof e, t), c = oe.create, Tt = Ye.create;
en.create;
Xe.create;
const w = Gr.create;
gt.create;
Jr.create;
qt.create;
Zt.create;
_t.create;
zr.create;
Se.create;
Qr.create;
const x = X.create, f = V.create;
V.strictCreate;
const k = Ft.create, N = gn.create;
Wt.create;
Ie.create;
const Hm = Gt.create;
Xr.create;
et.create;
const ne = Jt.create, l = zt.create, G = ke.create;
Qt.create;
Yt.create;
le.create;
const z = ce.create;
Pe.create;
le.createWithPreprocess;
var T = (e) => e, Dm = class {
  /**
   * @package
   */
  constructor(e, t, r) {
    this.versionMap = e, this.latestVersion = t, this.getVersion = r;
  }
  /**
   * Returns whether the given data is a valid entity of any version of the entity.
   * @param data The data to check
   * @returns Whether the given data is a valid entity of any version of the entity.
   */
  is(e) {
    let t = this.getVersion(e);
    if (t === null)
      return !1;
    const r = this.versionMap[t];
    return r ? r.schema.safeParse(e).success : !1;
  }
  /**
   * Returns whether the given data is a valid entity of the latest version of the entity.
   * @param data The data to check
   * @returns Whether the given data is a valid entity of the latest version of the entity.
   */
  isLatest(e) {
    return this.versionMap[this.latestVersion].schema.safeParse(e).success;
  }
  /**
   * Type guard that checks if data is valid for any version up to and including the specified version.
   * 
   * @param data The data to check
   * @param upToVersion The maximum version to check against (inclusive)
   * @returns true if the data is valid for any version from 1 to upToVersion,
   *          false if the data's version is higher than upToVersion or invalid
   * 
   * @example
   * ```ts
   * const entity = createVersionedEntity({ ... })
   * 
   * if (entity.isUpToVersion(data, 2)) {
   *   // data is guaranteed to be v1 or v2 (but not v3 or higher)
   * }
   * 
   * // Returns false for v3 data when checking up to v2
   * entity.isUpToVersion(v3Data, 2) // false
   * ```
   * 
   * Note: This is particularly useful for recursive entity definitions where you want to ensure
   * nested entities are at a specific version or lower.
   */
  isUpToVersion(e, t) {
    let r = this.getVersion(e);
    if (r === null || r > t)
      return !1;
    const n = this.versionMap[r];
    return n ? n.schema.safeParse(e).success : !1;
  }
  /**
   * Similar to Zod's `safeParse` method, but also migrates the data to the latest version.
   * @param data The data to parse
   * @returns The result from parsing data, if successful, older versions are migrated to the latest version
   */
  safeParse(e) {
    const t = this.getVersion(e);
    if (t === null)
      return { type: "err", error: { type: "VER_CHECK_FAIL" } };
    const r = this.versionMap[t];
    if (!r)
      return { type: "err", error: { type: "INVALID_VER" } };
    const n = r.schema.safeParse(e);
    if (!n.success)
      return {
        type: "err",
        error: {
          type: "GIVEN_VER_VALIDATION_FAIL",
          version: t,
          versionDef: r,
          error: n.error
        }
      };
    let a = n.data;
    for (let s = t + 1; s <= this.latestVersion; s++) {
      const i = this.versionMap[s];
      if (!i)
        return {
          type: "err",
          error: { type: "BUG_NO_INTERMEDIATE_FOUND", missingVer: s }
        };
      if (i.initial)
        return {
          type: "err",
          error: { type: "BUG_INTERMEDIATE_MARKED_INITIAL", ver: s }
        };
      a = i.up(a);
    }
    return { type: "ok", value: a };
  }
  /**
   * Parses data and migrates it up to a specific version (not beyond).
   * 
   * @param data The data to parse and potentially migrate
   * @param version The target version to migrate to (will not migrate beyond this)
   * @returns A ParseResult containing either the migrated data or an error.
   *          Returns { type: "err", error: { type: "INVALID_VER" } } if data version is higher than requested.
   * 
   * @example
   * ```ts
   * // If you have v1 data and versions up to v4 exist:
   * const result = entity.safeParseUpToVersion(v1Data, 2)
   * // result will contain v2 data (not v3 or v4)
   * 
   * // Trying to parse v3 data up to v2 returns an error
   * const result = entity.safeParseUpToVersion(v3Data, 2)
   * // result: { type: "err", error: { type: "INVALID_VER" } }
   * ```
   * 
   * Note: This is particularly useful for recursive entity definitions to prevent migration
   * functions from receiving future versions they weren't designed to handle.
   */
  safeParseUpToVersion(e, t) {
    const r = this.getVersion(e);
    if (r === null)
      return { type: "err", error: { type: "VER_CHECK_FAIL" } };
    if (r > t)
      return { type: "err", error: { type: "INVALID_VER" } };
    const n = this.versionMap[r];
    if (!n)
      return { type: "err", error: { type: "INVALID_VER" } };
    const a = n.schema.safeParse(e);
    if (!a.success)
      return {
        type: "err",
        error: {
          type: "GIVEN_VER_VALIDATION_FAIL",
          version: r,
          versionDef: n,
          error: a.error
        }
      };
    let s = a.data;
    for (let i = r + 1; i <= t; i++) {
      const o = this.versionMap[i];
      if (!o)
        return {
          type: "err",
          error: { type: "BUG_NO_INTERMEDIATE_FOUND", missingVer: i }
        };
      if (o.initial)
        return {
          type: "err",
          error: { type: "BUG_INTERMEDIATE_MARKED_INITIAL", ver: i }
        };
      s = o.up(s);
    }
    return { type: "ok", value: s };
  }
};
function Ne(e) {
  return new Dm(e.versionMap, e.latestVersion, e.getVersion);
}
function tt(e) {
  return bn((t) => e.is(t)).transform((t) => {
    const r = e.safeParse(t);
    if (r.type !== "ok")
      throw new Error(
        "Invalid entity definition. `entity.is` returned success, safeParse failed."
      );
    return r.value;
  });
}
function Te(e, t) {
  return bn((r) => e.isUpToVersion(r, t)).transform((r) => {
    const n = e.safeParseUpToVersion(r, t);
    if (n.type !== "ok")
      throw new Error(
        "Invalid entity definition. `entity.isUpToVersion` returned success, safeParse failed."
      );
    return n.value;
  });
}
var Lm = "__lodash_hash_undefined__";
function Um(e) {
  return this.__data__.set(e, Lm), this;
}
var Km = Um;
function Bm(e) {
  return this.__data__.has(e);
}
var qm = Bm, Zm = cs, Fm = Km, Wm = qm;
function rr(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.__data__ = new Zm(); ++t < r; )
    this.add(e[t]);
}
rr.prototype.add = rr.prototype.push = Fm;
rr.prototype.has = Wm;
var Gm = rr;
function Jm(e, t) {
  for (var r = -1, n = e == null ? 0 : e.length; ++r < n; )
    if (t(e[r], r, e))
      return !0;
  return !1;
}
var zm = Jm;
function Qm(e, t) {
  return e.has(t);
}
var Ym = Qm, Xm = Gm, ev = zm, tv = Ym, rv = 1, nv = 2;
function av(e, t, r, n, a, s) {
  var i = r & rv, o = e.length, u = t.length;
  if (o != u && !(i && u > o))
    return !1;
  var d = s.get(e), y = s.get(t);
  if (d && y)
    return d == t && y == e;
  var A = -1, E = !0, Z = r & nv ? new Xm() : void 0;
  for (s.set(e, t), s.set(t, e); ++A < o; ) {
    var U = e[A], F = t[A];
    if (n)
      var D = i ? n(F, U, A, t, e, s) : n(U, F, A, e, t, s);
    if (D !== void 0) {
      if (D)
        continue;
      E = !1;
      break;
    }
    if (Z) {
      if (!ev(t, function(K, we) {
        if (!tv(Z, we) && (U === K || a(U, K, r, n, s)))
          return Z.push(we);
      })) {
        E = !1;
        break;
      }
    } else if (!(U === F || a(U, F, r, n, s))) {
      E = !1;
      break;
    }
  }
  return s.delete(e), s.delete(t), E;
}
var Vs = av;
function sv(e) {
  var t = -1, r = Array(e.size);
  return e.forEach(function(n, a) {
    r[++t] = [a, n];
  }), r;
}
var iv = sv;
function ov(e) {
  var t = -1, r = Array(e.size);
  return e.forEach(function(n) {
    r[++t] = n;
  }), r;
}
var cv = ov, xa = ur, Ra = Es, uv = cn, lv = Vs, dv = iv, fv = cv, hv = 1, pv = 2, yv = "[object Boolean]", mv = "[object Date]", vv = "[object Error]", gv = "[object Map]", _v = "[object Number]", bv = "[object RegExp]", Sv = "[object Set]", Av = "[object String]", Tv = "[object Symbol]", $v = "[object ArrayBuffer]", Ev = "[object DataView]", Oa = xa ? xa.prototype : void 0, Nr = Oa ? Oa.valueOf : void 0;
function wv(e, t, r, n, a, s, i) {
  switch (r) {
    case Ev:
      if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset)
        return !1;
      e = e.buffer, t = t.buffer;
    case $v:
      return !(e.byteLength != t.byteLength || !s(new Ra(e), new Ra(t)));
    case yv:
    case mv:
    case _v:
      return uv(+e, +t);
    case vv:
      return e.name == t.name && e.message == t.message;
    case bv:
    case Av:
      return e == t + "";
    case gv:
      var o = dv;
    case Sv:
      var u = n & hv;
      if (o || (o = fv), e.size != t.size && !u)
        return !1;
      var d = i.get(e);
      if (d)
        return d == t;
      n |= pv, i.set(e, t);
      var y = lv(o(e), o(t), n, a, s, i);
      return i.delete(e), y;
    case Tv:
      if (Nr)
        return Nr.call(e) == Nr.call(t);
  }
  return !1;
}
var Cv = wv, Ia = Ts, xv = 1, Rv = Object.prototype, Ov = Rv.hasOwnProperty;
function Iv(e, t, r, n, a, s) {
  var i = r & xv, o = Ia(e), u = o.length, d = Ia(t), y = d.length;
  if (u != y && !i)
    return !1;
  for (var A = u; A--; ) {
    var E = o[A];
    if (!(i ? E in t : Ov.call(t, E)))
      return !1;
  }
  var Z = s.get(e), U = s.get(t);
  if (Z && U)
    return Z == t && U == e;
  var F = !0;
  s.set(e, t), s.set(t, e);
  for (var D = i; ++A < u; ) {
    E = o[A];
    var K = e[E], we = t[E];
    if (n)
      var Gn = i ? n(we, K, E, t, e, s) : n(K, we, E, e, t, s);
    if (!(Gn === void 0 ? K === we || a(K, we, r, n, s) : Gn)) {
      F = !1;
      break;
    }
    D || (D = E == "constructor");
  }
  if (F && !D) {
    var Pt = e.constructor, Vt = t.constructor;
    Pt != Vt && "constructor" in e && "constructor" in t && !(typeof Pt == "function" && Pt instanceof Pt && typeof Vt == "function" && Vt instanceof Vt) && (F = !1);
  }
  return s.delete(e), s.delete(t), F;
}
var kv = Iv, Mr = us, Pv = Vs, Vv = Cv, Nv = kv, ka = yr, Pa = pr, Va = ln, Mv = ps, jv = 1, Na = "[object Arguments]", Ma = "[object Array]", Mt = "[object Object]", Hv = Object.prototype, ja = Hv.hasOwnProperty;
function Dv(e, t, r, n, a, s) {
  var i = Pa(e), o = Pa(t), u = i ? Ma : ka(e), d = o ? Ma : ka(t);
  u = u == Na ? Mt : u, d = d == Na ? Mt : d;
  var y = u == Mt, A = d == Mt, E = u == d;
  if (E && Va(e)) {
    if (!Va(t))
      return !1;
    i = !0, y = !1;
  }
  if (E && !y)
    return s || (s = new Mr()), i || Mv(e) ? Pv(e, t, r, n, a, s) : Vv(e, t, u, r, n, a, s);
  if (!(r & jv)) {
    var Z = y && ja.call(e, "__wrapped__"), U = A && ja.call(t, "__wrapped__");
    if (Z || U) {
      var F = Z ? e.value() : e, D = U ? t.value() : t;
      return s || (s = new Mr()), a(F, D, r, n, s);
    }
  }
  return E ? (s || (s = new Mr()), Nv(e, t, r, n, a, s)) : !1;
}
var Lv = Dv, Uv = Lv, Ha = lt;
function Ns(e, t, r, n, a) {
  return e === t ? !0 : e == null || t == null || !Ha(e) && !Ha(t) ? e !== e && t !== t : Uv(e, t, r, n, Ns, a);
}
var Kv = Ns, Bv = Kv;
function qv(e, t) {
  return Bv(e, t);
}
var Zv = qv;
const Fv = /* @__PURE__ */ ns(Zv), Wv = (e) => ({
  equals(t, r) {
    return t !== void 0 && r !== void 0 ? e.equals(t, r) : t === void 0 && r === void 0;
  }
}), jr = (e, t) => ({
  equals(r, n) {
    return t.equals(e(r), e(n));
  }
}), Be = {
  equals(e, t) {
    return Fv(e, t);
  }
}, Gv = f({
  id: z(c()),
  // Firebase Firestore ID
  url: c(),
  path: c(),
  headers: x(
    f({
      key: c(),
      value: c(),
      active: w()
    })
  ),
  params: x(
    f({
      key: c(),
      value: c(),
      active: w()
    })
  ),
  name: c(),
  method: c(),
  preRequestScript: c(),
  testScript: c(),
  contentType: c(),
  body: c(),
  rawParams: z(c()),
  auth: z(c()),
  httpUser: z(c()),
  httpPassword: z(c()),
  bearerToken: z(c())
}), Da = T({
  initial: !0,
  schema: Gv
}), Sn = f({
  key: c(),
  active: w()
}).and(
  k([
    f({
      isFile: l(!0),
      value: x(mr(Blob).nullable())
    }),
    f({
      isFile: l(!1),
      value: c()
    })
  ])
);
f({
  contentType: l("multipart/form-data"),
  body: x(Sn)
});
const Jv = k([
  f({
    contentType: l(null),
    body: l(null).catch(null)
  }),
  f({
    contentType: l("multipart/form-data"),
    body: x(Sn).catch([])
  }),
  f({
    contentType: k([
      l("application/json"),
      l("application/ld+json"),
      l("application/hal+json"),
      l("application/vnd.api+json"),
      l("application/xml"),
      l("application/x-www-form-urlencoded"),
      l("text/html"),
      l("text/plain")
    ]),
    body: c().catch("")
  })
]), de = f({
  authType: l("none")
}), fe = f({
  authType: l("basic"),
  username: c().catch(""),
  password: c().catch("")
}), he = f({
  authType: l("bearer"),
  token: c().catch("")
}), zv = f({
  authType: l("oauth-2"),
  token: c().catch(""),
  oidcDiscoveryURL: c().catch(""),
  authURL: c().catch(""),
  accessTokenURL: c().catch(""),
  clientID: c().catch(""),
  scope: c().catch("")
}), An = f({
  authType: l("api-key"),
  key: c().catch(""),
  value: c().catch(""),
  addTo: c().catch("Headers")
}), pe = f({
  authType: l("inherit")
}), Qv = N("authType", [
  de,
  pe,
  fe,
  he,
  zv,
  An
]).and(
  f({
    authActive: w()
  })
), Yv = x(
  f({
    key: c().catch(""),
    value: c().catch(""),
    active: w().catch(!0)
  })
), Ms = x(
  f({
    key: c().catch(""),
    value: c().catch(""),
    active: w().catch(!0)
  })
), js = f({
  v: l("1"),
  id: z(c()),
  // Firebase Firestore ID
  name: c(),
  method: c(),
  endpoint: c(),
  params: Yv,
  headers: Ms,
  preRequestScript: c().catch(""),
  testScript: c().catch(""),
  auth: Qv,
  body: Jv
});
function Xv(e) {
  return {
    contentType: "application/json",
    body: e.contentType === "application/json" ? e.rawParams ?? "" : ""
  };
}
function eg(e) {
  return !e.auth || e.auth === "None" ? {
    authType: "none",
    authActive: !0
  } : e.auth === "Basic Auth" ? {
    authType: "basic",
    authActive: !0,
    username: e.httpUser ?? "",
    password: e.httpPassword ?? ""
  } : e.auth === "Bearer Token" ? {
    authType: "bearer",
    authActive: !0,
    token: e.bearerToken ?? ""
  } : { authType: "none", authActive: !0 };
}
const tg = T({
  initial: !1,
  schema: js,
  up(e) {
    const {
      url: t,
      path: r,
      headers: n,
      params: a,
      name: s,
      method: i,
      preRequestScript: o,
      testScript: u
    } = e, d = `${t}${r}`, y = Xv(e), A = eg(e), E = {
      v: "1",
      endpoint: d,
      headers: n,
      params: a,
      name: s,
      method: i,
      preRequestScript: o,
      testScript: u,
      body: y,
      auth: A
    };
    return e.id && (E.id = e.id), E;
  }
}), Tn = x(
  f({
    key: c().catch(""),
    value: c().catch(""),
    active: w().catch(!0)
  })
), Hs = js.extend({
  v: l("2"),
  requestVariables: Tn
}), rg = T({
  initial: !1,
  schema: Hs,
  up(e) {
    return {
      ...e,
      v: "2",
      requestVariables: []
    };
  }
}), Ds = f({
  grantType: l("AUTHORIZATION_CODE"),
  authEndpoint: c().trim(),
  tokenEndpoint: c().trim(),
  clientID: c().trim(),
  clientSecret: c().trim(),
  scopes: c().trim().optional(),
  token: c().catch(""),
  isPKCE: w(),
  codeVerifierMethod: k([l("plain"), l("S256")]).optional()
}), vr = f({
  grantType: l("CLIENT_CREDENTIALS"),
  authEndpoint: c().trim(),
  clientID: c().trim(),
  clientSecret: c().trim(),
  scopes: c().trim().optional(),
  token: c().catch("")
}), gr = f({
  grantType: l("PASSWORD"),
  authEndpoint: c().trim(),
  clientID: c().trim(),
  clientSecret: c().trim(),
  scopes: c().trim().optional(),
  username: c().trim(),
  password: c().trim(),
  token: c().catch("")
}), $t = f({
  grantType: l("IMPLICIT"),
  authEndpoint: c().trim(),
  clientID: c().trim(),
  scopes: c().trim().optional(),
  token: c().catch("")
}), _r = f({
  authType: l("oauth-2"),
  grantTypeInfo: N("grantType", [
    Ds,
    vr,
    gr,
    $t
  ]),
  addTo: G(["HEADERS", "QUERY_PARAMS"]).catch("HEADERS")
}), ng = N("authType", [
  de,
  pe,
  fe,
  he,
  _r,
  An
]).and(
  f({
    authActive: w()
  })
), Ls = Hs.extend({
  v: l("3"),
  auth: ng
}), ag = T({
  initial: !1,
  schema: Ls,
  up(e) {
    if (e.auth.authType === "oauth-2") {
      const { token: t, accessTokenURL: r, scope: n, clientID: a, authURL: s } = e.auth;
      return {
        ...e,
        v: "3",
        auth: {
          ...e.auth,
          authType: "oauth-2",
          grantTypeInfo: {
            grantType: "AUTHORIZATION_CODE",
            authEndpoint: s,
            tokenEndpoint: r,
            clientID: a,
            clientSecret: "",
            scopes: n,
            isPKCE: !1,
            token: t
          },
          addTo: "HEADERS"
        }
      };
    }
    return {
      ...e,
      v: "3",
      auth: {
        ...e.auth
      }
    };
  }
}), Me = An.extend({
  addTo: G(["HEADERS", "QUERY_PARAMS"]).catch("HEADERS")
}), sg = N("authType", [
  de,
  pe,
  fe,
  he,
  _r,
  Me
]).and(
  f({
    authActive: w()
  })
), Us = Ls.extend({
  v: l("4"),
  auth: sg
}), ig = T({
  schema: Us,
  initial: !1,
  up(e) {
    return e.auth.authType === "api-key" ? {
      ...e,
      v: "4",
      auth: {
        ...e.auth,
        addTo: e.auth.addTo === "Query params" ? "QUERY_PARAMS" : "HEADERS"
      }
    } : {
      ...e,
      auth: {
        ...e.auth
      },
      v: "4"
    };
  }
}), Ks = Ds.extend({
  clientSecret: c().optional()
}), br = _r.extend({
  grantTypeInfo: N("grantType", [
    Ks,
    vr,
    gr,
    $t
  ])
}), Bs = N("authType", [
  de,
  pe,
  fe,
  he,
  br,
  Me
]).and(
  f({
    authActive: w()
  })
), qs = Us.extend({
  v: l("5"),
  auth: Bs
}), og = T({
  schema: qs,
  initial: !1,
  up(e) {
    return {
      ...e,
      v: "5"
    };
  }
}), Zs = k([
  f({
    contentType: l(null),
    body: l(null).catch(null)
  }),
  f({
    contentType: l("multipart/form-data"),
    body: x(Sn).catch([])
  }),
  f({
    contentType: k([
      l("application/json"),
      l("application/ld+json"),
      l("application/hal+json"),
      l("application/vnd.api+json"),
      l("application/xml"),
      l("text/xml"),
      l("application/x-www-form-urlencoded"),
      l("text/html"),
      l("text/plain")
    ]),
    body: c().catch("")
  })
]), Fs = qs.extend({
  v: l("6"),
  body: Zs
}), cg = T({
  schema: Fs,
  initial: !1,
  up(e) {
    return {
      ...e,
      v: "6"
    };
  }
}), $n = Ks.extend({
  refreshToken: c().optional()
}), Ws = f({
  authType: l("oauth-2"),
  grantTypeInfo: N("grantType", [
    $n,
    vr,
    gr,
    $t
  ]),
  addTo: G(["HEADERS", "QUERY_PARAMS"]).catch("HEADERS")
}), En = x(
  f({
    key: c().catch(""),
    value: c().catch(""),
    active: w().catch(!0),
    description: c().catch("")
  })
), Sr = x(
  f({
    key: c().catch(""),
    value: c().catch(""),
    active: w().catch(!0),
    description: c().catch("")
  })
), ft = f({
  authType: l("aws-signature"),
  accessKey: c().catch(""),
  secretKey: c().catch(""),
  region: c().catch(""),
  serviceName: c().catch(""),
  serviceToken: c().optional(),
  signature: f({}).optional(),
  addTo: G(["HEADERS", "QUERY_PARAMS"]).catch("HEADERS")
}), Gs = N("authType", [
  de,
  pe,
  fe,
  he,
  Ws,
  Me,
  ft
]).and(
  f({
    authActive: w()
  })
), Js = Fs.extend({
  v: l("7"),
  params: En,
  headers: Sr,
  auth: Gs
}), ug = T({
  schema: Js,
  initial: !1,
  up(e) {
    const t = e.params.map((n) => ({
      ...n,
      description: ""
    })), r = e.headers.map((n) => ({
      ...n,
      description: ""
    }));
    return {
      ...e,
      v: "7",
      params: t,
      headers: r
      // no need to update anything for HoppRESTAuth, because the newly added refreshToken is optional
    };
  }
}), zs = vr.extend({
  clientSecret: c().optional()
}), Qs = gr.extend({
  clientSecret: c().optional()
}), lg = f({
  authType: l("oauth-2"),
  grantTypeInfo: N("grantType", [
    $n,
    zs,
    Qs,
    $t
  ]),
  addTo: G(["HEADERS", "QUERY_PARAMS"]).catch("HEADERS")
}), Ar = f({
  authType: l("digest"),
  username: c().catch(""),
  password: c().catch(""),
  realm: c().catch(""),
  nonce: c().catch(""),
  algorithm: G(["MD5", "MD5-sess"]).catch("MD5"),
  qop: G(["auth", "auth-int"]).catch("auth"),
  nc: c().catch(""),
  cnonce: c().catch(""),
  opaque: c().catch(""),
  disableRetry: w().catch(!1)
}), wn = N("authType", [
  de,
  pe,
  fe,
  he,
  lg,
  Me,
  ft,
  Ar
]).and(
  f({
    authActive: w()
  })
), Ys = f({
  v: l("1"),
  name: c(),
  method: c(),
  endpoint: c(),
  headers: Sr,
  params: En,
  body: Zs,
  auth: wn,
  requestVariables: Tn
}), La = T({
  initial: !0,
  schema: Ys
}), Xs = f({
  key: c(),
  active: w(),
  contentType: c().optional().catch(void 0)
}).and(
  k([
    f({
      isFile: l(!0),
      value: x(mr(Blob).nullable()).catch([])
    }),
    f({
      isFile: l(!1),
      value: c()
    })
  ])
).transform((e) => e.isFile && Array.isArray(e.value) && e.value.length === 0 ? {
  ...e,
  isFile: !1,
  value: ""
} : e), ei = k([
  f({
    contentType: l(null),
    body: l(null).catch(null)
  }),
  f({
    contentType: l("multipart/form-data"),
    body: x(Xs).catch([]),
    showIndividualContentType: w().optional().catch(!1)
  }),
  f({
    contentType: l("application/octet-stream"),
    body: mr(File).nullable().catch(null)
  }),
  f({
    contentType: k([
      l("application/json"),
      l("application/ld+json"),
      l("application/hal+json"),
      l("application/vnd.api+json"),
      l("application/xml"),
      l("text/xml"),
      l("application/x-www-form-urlencoded"),
      l("binary"),
      l("text/html"),
      l("text/plain")
    ]),
    body: c().catch("")
  })
]), ti = Ys.extend({
  v: l("2"),
  body: ei
}), dg = T({
  initial: !1,
  schema: ti,
  up(e) {
    return {
      ...e,
      v: "2"
    };
  }
}), fg = zs.extend({
  clientAuthentication: G(["AS_BASIC_AUTH_HEADERS", "IN_BODY"])
}), Tr = f({
  authType: l("oauth-2"),
  grantTypeInfo: N("grantType", [
    $n,
    fg,
    Qs,
    $t
  ]),
  addTo: G(["HEADERS", "QUERY_PARAMS"]).catch("HEADERS")
}), Cn = N("authType", [
  de,
  pe,
  fe,
  he,
  Tr,
  Me,
  ft,
  Ar
]).and(
  f({
    authActive: w()
  })
), xn = k([
  f({
    contentType: l(null),
    body: l(null).catch(null)
  }),
  f({
    contentType: l("multipart/form-data"),
    body: x(Xs).catch([]),
    showIndividualContentType: w().optional().catch(!1),
    isBulkEditing: w().optional().catch(!1)
  }),
  f({
    contentType: l("application/octet-stream"),
    body: mr(File).nullable().catch(null)
  }),
  f({
    contentType: l("application/x-www-form-urlencoded"),
    body: c().catch(""),
    isBulkEditing: w().optional().catch(!1)
  }),
  f({
    contentType: k([
      l("application/json"),
      l("application/ld+json"),
      l("application/hal+json"),
      l("application/vnd.api+json"),
      l("application/xml"),
      l("text/xml"),
      l("binary"),
      l("text/html"),
      l("text/plain")
    ]),
    body: c().catch("")
  })
]), ri = ti.extend({
  v: l("3"),
  auth: Cn,
  body: xn
}), hg = T({
  initial: !1,
  schema: ri,
  up(e) {
    const t = e.auth;
    return {
      ...e,
      v: "3",
      auth: t.authType === "oauth-2" ? {
        ...t,
        grantTypeInfo: t.grantTypeInfo.grantType === "CLIENT_CREDENTIALS" ? {
          ...t.grantTypeInfo,
          clientAuthentication: "IN_BODY"
        } : t.grantTypeInfo
      } : t
    };
  }
}), ni = f({
  authType: l("hawk"),
  authId: c().catch(""),
  authKey: c().catch(""),
  algorithm: G(["sha256", "sha1"]).catch("sha256"),
  includePayloadHash: w().catch(!1),
  // Optional fields
  user: c().optional(),
  nonce: c().optional(),
  ext: c().optional(),
  app: c().optional(),
  dlg: c().optional(),
  timestamp: c().optional()
}), ai = f({
  authType: l("akamai-eg"),
  accessToken: c().catch(""),
  clientToken: c().catch(""),
  clientSecret: c().catch(""),
  // Optional fields
  nonce: c().optional(),
  timestamp: c().optional(),
  host: c().optional(),
  headersToSign: c().optional(),
  maxBodySize: c().optional()
}), Rn = N("authType", [
  de,
  pe,
  fe,
  he,
  Tr,
  Me,
  ft,
  Ar,
  ni,
  ai
]).and(
  f({
    authActive: w()
  })
), si = ri.extend({
  v: l("4"),
  auth: Rn
}), pg = T({
  initial: !1,
  schema: si,
  up(e) {
    return {
      ...e,
      v: "4"
    };
  }
}), yg = f({
  authType: l("jwt"),
  secret: c().catch(""),
  privateKey: c().catch(""),
  // For RSA/ECDSA algorithms
  algorithm: G([
    "HS256",
    "HS384",
    "HS512",
    "RS256",
    "RS384",
    "RS512",
    "PS256",
    "PS384",
    "PS512",
    "ES256",
    "ES384",
    "ES512"
  ]).catch("HS256"),
  payload: c().catch("{}"),
  addTo: G(["HEADERS", "QUERY_PARAMS"]).catch("HEADERS"),
  isSecretBase64Encoded: w().catch(!1),
  headerPrefix: c().catch("Bearer "),
  paramName: c().catch("token"),
  jwtHeaders: c().catch("{}")
}), $r = N("authType", [
  de,
  pe,
  fe,
  he,
  Tr,
  Me,
  ft,
  Ar,
  ni,
  ai,
  yg
]).and(
  f({
    authActive: w()
  })
), mg = si.extend({
  v: l("5"),
  auth: $r
}), vg = T({
  initial: !1,
  schema: mg,
  up(e) {
    return {
      ...e,
      v: "5"
    };
  }
}), gg = f({
  // v is a stringified number
  v: c().regex(/^\d+$/).transform(Number)
}), _g = Ne({
  latestVersion: 5,
  versionMap: {
    1: La,
    2: dg,
    3: hg,
    4: pg,
    5: vg
  },
  getVersion(e) {
    const t = gg.safeParse(e);
    return t.success ? t.data.v : La.schema.safeParse(e).success ? 1 : null;
  }
}), bg = "5", Sg = {
  // 1xx Informational
  // Request received, continuing process.[2]
  // This class of status code indicates a provisional response, consisting only of the Status-Line and optional headers, and is terminated by an empty line. Since HTTP/1.0 did not define any 1xx status codes, servers must not send a 1xx response to an HTTP/1.0 client except under experimental conditions.
  100: "Continue",
  // This means that the server has received the request headers, and that the client should proceed to send the request body (in the case of a request for which a body needs to be sent; for example, a POST request). If the request body is large, sending it to a server when a request has already been rejected based upon inappropriate headers is inefficient. To have a server check if the request could be accepted based on the request's headers alone, a client must send Expect: 100-continue as a header in its initial request[2] and check if a 100 Continue status code is received in response before continuing (or receive 417 Expectation Failed and not continue).[2]
  101: "Switching Protocols",
  // This means the requester has asked the server to switch protocols and the server is acknowledging that it will do so.[2]
  102: "Processing",
  // (WebDAV; RFC 2518) As a WebDAV request may contain many sub-requests involving file operations, it may take a long time to complete the request. This code indicates that the server has received and is processing the request, but no response is available yet.[3] This prevents the client from timing out and assuming the request was lost.
  // 2xx Success
  // This class of status codes indicates the action requested by the client was received, understood, accepted and processed successfully.
  200: "OK",
  // Standard response for successful HTTP requests. The actual response will depend on the request method used. In a GET request, the response will contain an entity corresponding to the requested resource. In a POST request the response will contain an entity describing or containing the result of the action.[2]
  201: "Created",
  // The request has been fulfilled and resulted in a new resource being created.[2]
  202: "Accepted",
  // The request has been accepted for processing, but the processing has not been completed. The request might or might not eventually be acted upon, as it might be disallowed when processing actually takes place.[2]
  203: "Non-Authoritative Information",
  // (since HTTP/1.1) The server successfully processed the request, but is returning information that may be from another source.[2]
  204: "No Content",
  // The server successfully processed the request, but is not returning any content.[2]
  205: "Reset Content",
  // The server successfully processed the request, but is not returning any content. Unlike a 204 response, this response requires that the requester reset the document view.[2]
  206: "Partial Content",
  // The server is delivering only part of the resource due to a range header sent by the client. The range header is used by tools like wget to enable resuming of interrupted downloads, or split a download into multiple simultaneous streams.[2]
  207: "Multi-Status",
  // (WebDAV; RFC 4918) The message body that follows is an XML message and can contain a number of separate response codes, depending on how many sub-requests were made.[4]
  208: "Already Reported",
  // (WebDAV; RFC 5842) The members of a DAV binding have already been enumerated in a previous reply to this request, and are not being included again.
  226: "IM Used",
  // (RFC 3229) The server has fulfilled a GET request for the resource, and the response is a representation of the result of one or more instance-manipulations applied to the current instance. [5]
  // 3xx Redirection
  // The client must take additional action to complete the request.[2]
  // This class of status code indicates that further action needs to be taken by the user agent in order to fulfil the request. The action required may be carried out by the user agent without interaction with the user if and only if the method used in the second request is GET or HEAD. A user agent should not automatically redirect a request more than five times, since such redirections usually indicate an infinite loop.
  300: "Multiple Choices",
  // Indicates multiple options for the resource that the client may follow. It, for instance, could be used to present different format options for video, list files with different extensions, or word sense disambiguation.[2]
  301: "Moved Permanently",
  // This and all future requests should be directed to the given URI.[2]
  302: "Found",
  // This is an example of industry practice contradicting the standard.[2] The HTTP/1.0 specification (RFC 1945) required the client to perform a temporary redirect (the original describing phrase was "Moved Temporarily"),[6] but popular browsers implemented 302 with the functionality of a 303 See Other. Therefore, HTTP/1.1 added status codes 303 and 307 to distinguish between the two behaviours.[7] However, some Web applications and frameworks use the 302 status code as if it were the 303.[citation needed]
  303: "See Other",
  // (since HTTP/1.1) The response to the request can be found under another URI using a GET method. When received in response to a POST (or PUT/DELETE), it should be assumed that the server has received the data and the redirect should be issued with a separate GET message.[2]
  304: "Not Modified",
  // Indicates the resource has not been modified since last requested.[2] Typically, the HTTP client provides a header like the If-Modified-Since header to provide a time against which to compare. Using this saves bandwidth and reprocessing on both the server and client, as only the header data must be sent and received in comparison to the entirety of the page being re-processed by the server, then sent again using more bandwidth of the server and client.
  305: "Use Proxy",
  // (since HTTP/1.1) Many HTTP clients (such as Mozilla[8] and Internet Explorer) do not correctly handle responses with this status code, primarily for security reasons.[2]
  306: "Switch Proxy",
  // No longer used.[2] Originally meant "Subsequent requests should use the specified proxy."[9]
  307: "Temporary Redirect",
  // (since HTTP/1.1) In this case, the request should be repeated with another URI; however, future requests can still use the original URI.[2] In contrast to 302, the request method should not be changed when reissuing the original request. For instance, a POST request must be repeated using another POST request.
  308: "Permanent Redirect",
  // (experimental Internet-Draft)[10] The request, and all future requests should be repeated using another URI. 307 and 308 (as proposed) parallel the behaviours of 302 and 301, but do not require the HTTP method to change. So, for example, submitting a form to a permanently redirected resource may continue smoothly.
  // 4xx Client Error
  // The 4xx class of status code is intended for cases in which the client seems to have erred. Except when responding to a HEAD request, the server should include an entity containing an explanation of the error situation, and whether it is a temporary or permanent condition. These status codes are applicable to any request method. User agents should display any included entity to the user.
  400: "Bad Request",
  // The request cannot be fulfilled due to bad syntax.[2]
  401: "Unauthorized",
  // Similar to 403 Forbidden, but specifically for use when authentication is possible but has failed or not yet been provided.[2] The response must include a WWW-Authenticate header field containing a challenge applicable to the requested resource. See Basic access authentication and Digest access authentication.
  402: "Payment Required",
  // Reserved for future use.[2] The original intention was that this code might be used as part of some form of digital cash or micropayment scheme, but that has not happened, and this code is not usually used. As an example of its use, however, Apple's MobileMe service generates a 402 error ("httpStatusCode:402" in the Mac OS X Console log) if the MobileMe account is delinquent.[citation needed]
  403: "Forbidden",
  // The request was a legal request, but the server is refusing to respond to it.[2] Unlike a 401 Unauthorized response, authenticating will make no difference.[2]
  404: "Not Found",
  // The requested resource could not be found but may be available again in the future.[2] Subsequent requests by the client are permissible.
  405: "Method Not Allowed",
  // A request was made of a resource using a request method not supported by that resource;[2] for example, using GET on a form which requires data to be presented via POST, or using PUT on a read-only resource.
  406: "Not Acceptable",
  // The requested resource is only capable of generating content not acceptable according to the Accept headers sent in the request.[2]
  407: "Proxy Authentication Required",
  // The client must first authenticate itself with the proxy.[2]
  408: "Request Timeout",
  // The server timed out waiting for the request.[2] According to W3 HTTP specifications: "The client did not produce a request within the time that the server was prepared to wait. The client MAY repeat the request without modifications at any later time."
  409: "Conflict",
  // Indicates that the request could not be processed because of conflict in the request, such as an edit conflict.[2]
  410: "Gone",
  // Indicates that the resource requested is no longer available and will not be available again.[2] This should be used when a resource has been intentionally removed and the resource should be purged. Upon receiving a 410 status code, the client should not request the resource again in the future. Clients such as search engines should remove the resource from their indices. Most use cases do not require clients and search engines to purge the resource, and a "404 Not Found" may be used instead.
  411: "Length Required",
  // The request did not specify the length of its content, which is required by the requested resource.[2]
  412: "Precondition Failed",
  // The server does not meet one of the preconditions that the requester put on the request.[2]
  413: "Request Entity Too Large",
  // The request is larger than the server is willing or able to process.[2]
  414: "Request-URI Too Long",
  // The URI provided was too long for the server to process.[2]
  415: "Unsupported Media Type",
  // The request entity has a media type which the server or resource does not support.[2] For example, the client uploads an image as image/svg+xml, but the server requires that images use a different format.
  416: "Requested Range Not Satisfiable",
  // The client has asked for a portion of the file, but the server cannot supply that portion.[2] For example, if the client asked for a part of the file that lies beyond the end of the file.[2]
  417: "Expectation Failed",
  // The server cannot meet the requirements of the Expect request-header field.[2]
  418: "I'm a teapot",
  // (RFC 2324) This code was defined in 1998 as one of the traditional IETF April Fools' jokes, in RFC 2324, Hyper Text Coffee Pot Control Protocol, and is not expected to be implemented by actual HTTP servers. However, known implementations do exist.[11]
  420: "Enhance Your Calm",
  // (Twitter) Returned by the Twitter Search and Trends API when the client is being rate limited.[12] Likely a reference to this number's association with marijuana. Other services may wish to implement the 429 Too Many Requests response code instead. The phrase "Enhance Your Calm" is a reference to Demolition Man (film). In the film, Sylvester Stallone's character John Spartan is a hot-head in a generally more subdued future, and is regularly told to "Enhance your calm" rather than a more common phrase like "calm down".
  422: "Unprocessable Entity",
  // (WebDAV; RFC 4918) The request was well-formed but was unable to be followed due to semantic errors.[4]
  423: "Locked",
  // (WebDAV; RFC 4918) The resource that is being accessed is locked.[4]
  424: "Failed Dependency",
  // (WebDAV; RFC 4918) The request failed due to failure of a previous request (e.g. a PROPPATCH).[4]
  425: "Unordered Collection",
  // (Internet draft) Defined in drafts of "WebDAV Advanced Collections Protocol",[14] but not present in "Web Distributed Authoring and Versioning (WebDAV) Ordered Collections Protocol".[15]
  426: "Upgrade Required",
  // (RFC 2817) The client should switch to a different protocol such as TLS/1.0.[16]
  428: "Precondition Required",
  // (RFC 6585) The origin server requires the request to be conditional. Intended to prevent "the 'lost update' problem, where a client GETs a resource's state, modifies it, and PUTs it back to the server, when meanwhile a third party has modified the state on the server, leading to a conflict."[17]
  429: "Too Many Requests",
  // (RFC 6585) The user has sent too many requests in a given amount of time. Intended for use with rate limiting schemes.[17]
  431: "Request Header Fields Too Large",
  // (RFC 6585) The server is unwilling to process the request because either an individual header field, or all the header fields collectively, are too large.[17]
  444: "No Response",
  // (Nginx) Used in Nginx logs to indicate that the server has returned no information to the client and closed the connection (useful as a deterrent for malware).
  449: "Retry With",
  // (Microsoft) A Microsoft extension. The request should be retried after performing the appropriate action.[18] Often search-engines or custom applications will ignore required parameters. Where no default action is appropriate, the Aviongoo website sends a "HTTP/1.1 449 Retry with valid parameters: param1, param2, . . ." response. The applications may choose to learn, or not.
  450: "Blocked by Windows Parental Controls",
  // (Microsoft) A Microsoft extension. This error is given when Windows Parental Controls are turned on and are blocking access to the given webpage.[19]
  451: "Unavailable For Legal Reasons",
  // (Internet draft) Defined in the internet draft "A New HTTP Status Code for Legally-restricted Resources",[20]. Intended to be used when resource access is denied for legal reasons, e.g. censorship or government-mandated blocked access. Likely a reference to the 1953 dystopian novel Fahrenheit 451, where books are outlawed.
  499: "Client Closed Request",
  // (Nginx) Used in Nginx logs to indicate when the connection has been closed by client while the server is still processing its request, making server unable to send a status code back.[21]
  // 5xx Server Error
  // The server failed to fulfill an apparently valid request.[2]
  // Response status codes beginning with the digit "5" indicate cases in which the server is aware that it has encountered an error or is otherwise incapable of performing the request. Except when responding to a HEAD request, the server should include an entity containing an explanation of the error situation, and indicate whether it is a temporary or permanent condition. Likewise, user agents should display any included entity to the user. These response codes are applicable to any request method.
  500: "Internal Server Error",
  // A generic error message, given when no more specific message is suitable.[2]
  501: "Not Implemented",
  // The server either does not recognise the request method, or it lacks the ability to fulfill the request.[2]
  502: "Bad Gateway",
  // The server was acting as a gateway or proxy and received an invalid response from the upstream server.[2]
  503: "Service Unavailable",
  // The server is currently unavailable (because it is overloaded or down for maintenance).[2] Generally, this is a temporary state.
  504: "Gateway Timeout",
  // The server was acting as a gateway or proxy and did not receive a timely response from the upstream server.[2]
  505: "HTTP Version Not Supported",
  // The server does not support the HTTP protocol version used in the request.[2]
  506: "Variant Also Negotiates",
  // (RFC 2295) Transparent content negotiation for the request results in a circular reference.[22]
  507: "Insufficient Storage",
  // (WebDAV; RFC 4918) The server is unable to store the representation needed to complete the request.[4]
  508: "Loop Detected",
  // (WebDAV; RFC 5842) The server detected an infinite loop while processing the request (sent in lieu of 208).
  509: "Bandwidth Limit Exceeded",
  // (Apache bw/limited extension) This status code, while used by many servers, is not specified in any RFCs.
  510: "Not Extended",
  // (RFC 2774) Further extensions to the request are required for the server to fulfill it.[23]
  511: "Network Authentication Required",
  // (RFC 6585) The client needs to authenticate to gain network access. Intended for use by intercepting proxies used to control access to the network (e.g. "captive portals" used to require agreement to Terms of Service before granting full Internet access via a Wi-Fi hotspot).[17]
  598: "Network read timeout error",
  // (Unknown) This status code is not specified in any RFCs, but is used by Microsoft Corp. HTTP proxies to signal a network read timeout behind the proxy to a client in front of the proxy.
  599: "Network connect timeout error"
  // (Unknown) This status code is not specified in any RFCs, but is used by Microsoft Corp. HTTP proxies to signal a network connect timeout behind the proxy to a client in front of the proxy.
}, Ag = k(
  Object.keys(Sg).map((e) => l(parseInt(e)))
), Tg = x(
  f({
    key: c(),
    value: c()
  })
), $g = f({
  name: c(),
  originalRequest: tt(_g),
  status: c(),
  code: z(Ag).nullable().catch(null),
  headers: Tg,
  body: c()
}), Ua = T({
  initial: !0,
  schema: $g
}), Eg = f({
  v: Tt()
}), wg = Ne({
  latestVersion: 0,
  versionMap: {
    0: Ua
  },
  getVersion(e) {
    const t = Eg.safeParse(e);
    return t.success ? t.data.v : Ua.schema.safeParse(e).success ? 0 : null;
  }
}), ii = Hm(
  c(),
  tt(wg)
);
function MS(e) {
  return {
    v: bg,
    ...e
  };
}
const oi = Js.extend({
  v: l("8"),
  auth: wn,
  responses: ii
}), Cg = T({
  schema: oi,
  initial: !1,
  up(e) {
    return {
      ...e,
      v: "8",
      // no need to update anything for HoppRESTAuth, because we loosened the previous schema by making `clientSecret` optional
      responses: {}
    };
  }
}), ci = oi.extend({
  v: l("9"),
  body: ei
}), xg = T({
  schema: ci,
  initial: !1,
  up(e) {
    return {
      ...e,
      v: "9"
    };
  }
}), ui = ci.extend({
  v: l("10"),
  body: xn
}), Rg = T({
  schema: ui,
  initial: !1,
  up(e) {
    return {
      ...e,
      v: "10"
    };
  }
}), li = ui.extend({
  v: l("11"),
  auth: Cn
}), Og = T({
  schema: li,
  initial: !1,
  up(e) {
    const t = e.auth;
    return {
      ...e,
      v: "11",
      auth: t.authType === "oauth-2" ? {
        ...t,
        grantTypeInfo: t.grantTypeInfo.grantType === "CLIENT_CREDENTIALS" ? {
          ...t.grantTypeInfo,
          clientAuthentication: "IN_BODY"
        } : t.grantTypeInfo
      } : t
    };
  }
}), di = li.extend({
  v: l("12"),
  auth: Rn
}), Ig = T({
  schema: di,
  initial: !1,
  up(e) {
    return {
      ...e,
      v: "12"
    };
  }
}), fi = di.extend({
  v: l("13"),
  auth: $r
}), kg = T({
  schema: fi,
  initial: !1,
  up(e) {
    return {
      ...e,
      v: "13"
    };
  }
}), Pg = fi.extend({
  v: l("14")
}), Vg = T({
  schema: Pg,
  initial: !1,
  up(e) {
    return {
      ...e,
      v: "14"
    };
  }
}), Ng = {
  "application/json": "json",
  "application/ld+json": "json",
  "application/hal+json": "json",
  "application/vnd.api+json": "json",
  "application/xml": "xml",
  "text/xml": "xml",
  "application/x-www-form-urlencoded": "multipart",
  "multipart/form-data": "multipart",
  "application/octet-stream": "binary",
  "text/html": "html",
  "text/plain": "plain"
}, jS = Object.keys(
  Ng
), Mg = f({
  // v is a stringified number
  v: c().regex(/^\d+$/).transform(Number)
}), Er = Ne({
  latestVersion: 14,
  versionMap: {
    0: Da,
    1: tg,
    2: rg,
    3: ag,
    4: ig,
    5: og,
    6: cg,
    7: ug,
    8: Cg,
    9: xg,
    10: Rg,
    11: Og,
    12: Ig,
    13: kg,
    14: Vg
  },
  getVersion(e) {
    const t = Mg.safeParse(e);
    return t.success ? t.data.v : Da.schema.safeParse(e).success ? 0 : null;
  }
}), jg = So({
  id: Wv(ve),
  v: ve,
  auth: Be,
  body: Be,
  endpoint: ve,
  headers: jr(
    (e) => e.filter((t) => t.key !== "" && t.value !== ""),
    Be
  ),
  params: jr(
    (e) => e.filter((t) => t.key !== "" && t.value !== ""),
    Be
  ),
  method: ve,
  name: ve,
  preRequestScript: ve,
  testScript: ve,
  requestVariables: jr(
    (e) => e.filter((t) => t.key !== "" && t.value !== ""),
    Be
  ),
  responses: Be
}), hi = "14", HS = jg.equals;
function DS(e, t) {
  const r = fm(t);
  if (e && typeof e == "object") {
    if ("id" in e && typeof e.id == "string" && (r.id = e.id), "name" in e && typeof e.name == "string" && (r.name = e.name), "method" in e && typeof e.method == "string" && (r.method = e.method), "endpoint" in e && typeof e.endpoint == "string" && (r.endpoint = e.endpoint), "preRequestScript" in e && typeof e.preRequestScript == "string" && (r.preRequestScript = e.preRequestScript), "testScript" in e && typeof e.testScript == "string" && (r.testScript = e.testScript), "body" in e) {
      const n = xn.safeParse(e.body);
      n.success && (r.body = n.data);
    }
    if ("auth" in e) {
      const n = $r.safeParse(e.auth);
      n.success && (r.auth = n.data);
    }
    if ("params" in e) {
      const n = En.safeParse(e.params);
      n.success && (r.params = n.data);
    }
    if ("headers" in e) {
      const n = Sr.safeParse(e.headers);
      n.success && (r.headers = n.data);
    }
    if ("requestVariables" in e) {
      const n = Tn.safeParse(e.requestVariables);
      n.success && (r.requestVariables = n.data);
    }
    if ("responses" in e) {
      const n = ii.safeParse(e.responses);
      n.success && (r.responses = n.data);
    }
  }
  return r;
}
function LS(e) {
  return {
    v: hi,
    ...e
  };
}
function Hg() {
  return {
    v: hi,
    endpoint: "https://echo.hoppscotch.io",
    name: "Untitled",
    params: [],
    headers: [],
    method: "GET",
    auth: {
      authType: "inherit",
      authActive: !0
    },
    preRequestScript: "",
    testScript: "",
    body: {
      contentType: null,
      body: null
    },
    requestVariables: [],
    responses: {}
  };
}
function US(e) {
  return Er.isLatest(e);
}
function Dg(e) {
  const t = Er.safeParse(e);
  return t.type === "ok" ? t.value : Hg();
}
const On = f({
  key: c().catch(""),
  value: c().catch(""),
  active: w().catch(!0)
}), Lg = f({
  v: l(1),
  name: c(),
  url: c(),
  headers: x(On).catch([]),
  query: c(),
  variables: c()
}), Ug = T({
  initial: !0,
  schema: Lg
}), je = f({
  authType: l("none")
}), He = f({
  authType: l("basic"),
  username: c().catch(""),
  password: c().catch("")
}), De = f({
  authType: l("bearer"),
  token: c().catch("")
}), Kg = f({
  authType: l("oauth-2"),
  token: c().catch(""),
  oidcDiscoveryURL: c().catch(""),
  authURL: c().catch(""),
  accessTokenURL: c().catch(""),
  clientID: c().catch(""),
  scope: c().catch("")
}), In = f({
  authType: l("api-key"),
  key: c().catch(""),
  value: c().catch(""),
  addTo: c().catch("Headers")
}), Le = f({
  authType: l("inherit")
}), Bg = N("authType", [
  je,
  He,
  De,
  Kg,
  In,
  Le
]).and(
  f({
    authActive: w()
  })
), pi = f({
  id: z(c()),
  v: l(2),
  name: c(),
  url: c(),
  headers: x(On).catch([]),
  query: c(),
  variables: c(),
  auth: Bg
}), qg = T({
  initial: !1,
  schema: pi,
  up(e) {
    return {
      ...e,
      v: 2,
      auth: {
        authActive: !0,
        authType: "none"
      }
    };
  }
}), Zg = N("authType", [
  je,
  Le,
  He,
  De,
  In,
  _r
  // both rest and gql have the same auth type for oauth2
]).and(
  f({
    authActive: w()
  })
), yi = pi.extend({
  v: l(3),
  auth: Zg
}), Fg = T({
  initial: !1,
  schema: yi,
  up(e) {
    if (e.auth.authType === "oauth-2") {
      const { token: t, accessTokenURL: r, scope: n, clientID: a, authURL: s } = e.auth;
      return {
        ...e,
        v: 3,
        auth: {
          ...e.auth,
          authType: "oauth-2",
          grantTypeInfo: {
            grantType: "AUTHORIZATION_CODE",
            authEndpoint: s,
            tokenEndpoint: r,
            clientID: a,
            clientSecret: "",
            scopes: n,
            isPKCE: !1,
            token: t
          },
          addTo: "HEADERS"
        }
      };
    }
    return {
      ...e,
      v: 3,
      auth: {
        ...e.auth
      }
    };
  }
}), Et = In.extend({
  addTo: G(["HEADERS", "QUERY_PARAMS"]).catch("HEADERS")
}), Wg = N("authType", [
  je,
  Le,
  He,
  De,
  Et,
  br
  // both rest and gql have the same auth type for oauth2
]).and(
  f({
    authActive: w()
  })
), mi = yi.extend({
  v: l(4),
  auth: Wg
}), Gg = T({
  initial: !1,
  schema: mi,
  up(e) {
    return e.auth.authType === "api-key" ? {
      ...e,
      v: 4,
      auth: {
        ...e.auth,
        addTo: e.auth.addTo === "Query params" ? "QUERY_PARAMS" : "HEADERS"
      }
    } : {
      ...e,
      v: 4,
      auth: {
        ...e.auth
      }
    };
  }
}), vi = N("authType", [
  je,
  Le,
  He,
  De,
  Et,
  br
  // both rest and gql have the same auth type for oauth2
]).and(
  f({
    authActive: w()
  })
), gi = mi.extend({
  v: l(5),
  auth: vi
}), Jg = T({
  initial: !1,
  schema: gi,
  up(e) {
    return {
      ...e,
      v: 5
    };
  }
}), kn = ft, _i = f({
  key: c().catch(""),
  value: c().catch(""),
  active: w().catch(!0),
  description: c().catch("")
}), bi = N("authType", [
  je,
  Le,
  He,
  De,
  br,
  Et,
  kn
]).and(
  f({
    authActive: w()
  })
), Si = gi.extend({
  v: l(6),
  auth: bi,
  headers: x(_i).catch([])
}), zg = T({
  schema: Si,
  initial: !1,
  up(e) {
    const t = e.headers.map((r) => ({
      ...r,
      description: ""
    }));
    return {
      ...e,
      v: 6,
      headers: t
    };
  }
}), Ai = N("authType", [
  je,
  Le,
  He,
  De,
  Ws,
  Et,
  kn
]).and(
  f({
    authActive: w()
  })
), Ti = Si.extend({
  v: l(7),
  auth: Ai
}), Qg = T({
  schema: Ti,
  initial: !1,
  up(e) {
    return {
      ...e,
      v: 7
      // no need to update anything for HoppGQLAuth, because we loosened the previous schema by making `clientSecret` optional
    };
  }
}), wr = N("authType", [
  je,
  Le,
  He,
  De,
  Tr,
  Et,
  kn
]).and(
  f({
    authActive: w()
  })
), Yg = Ti.extend({
  v: l(8),
  auth: wr
}), Xg = T({
  schema: Yg,
  initial: !1,
  up(e) {
    const t = e.auth;
    return {
      ...e,
      v: 8,
      auth: t.authType === "oauth-2" ? {
        ...t,
        grantTypeInfo: t.grantTypeInfo.grantType === "CLIENT_CREDENTIALS" ? {
          ...t.grantTypeInfo,
          clientAuthentication: "IN_BODY"
        } : t.grantTypeInfo
      } : t
    };
  }
}), $i = 8, e_ = f({
  v: Tt()
}), Pn = Ne({
  latestVersion: 8,
  versionMap: {
    1: Ug,
    2: qg,
    3: Fg,
    4: Gg,
    5: Jg,
    6: zg,
    7: Qg,
    8: Xg
  },
  getVersion(e) {
    const t = e_.safeParse(e);
    return t.success ? t.data.v : null;
  }
}), t_ = `
query Request {
  method
  url
  headers {
    key
    value
  }
}`.trim();
function r_() {
  return {
    v: $i,
    name: "Untitled",
    url: "https://echo.hoppscotch.io/graphql",
    headers: [],
    variables: `
{
  "id": "1"
}`.trim(),
    query: t_,
    auth: {
      authType: "inherit",
      authActive: !0
    }
  };
}
function n_(e) {
  const t = Pn.safeParse(e);
  return t.type === "ok" ? t.value : r_();
}
function KS(e) {
  return {
    v: $i,
    ...e
  };
}
const a_ = f({
  v: l(1),
  id: z(c()),
  // For Firestore ID data
  name: c(),
  requests: x(
    ne(
      () => k([
        tt(Er),
        tt(Pn)
      ])
    )
  )
}), s_ = a_.extend({
  folders: ne(() => x(Te(q, 1)))
}), Ka = T({
  initial: !0,
  schema: s_
}), Ei = f({
  v: l(2),
  id: z(c()),
  // For Firestore ID data
  name: c(),
  requests: x(
    ne(
      () => k([
        tt(Er),
        tt(Pn)
      ])
    )
  ),
  auth: k([Bs, vi]),
  headers: k([Ms, x(On)])
}), i_ = Ei.extend({
  folders: ne(() => x(Te(q, 2)))
}), o_ = T({
  initial: !1,
  schema: i_,
  up(e) {
    const t = {
      ...e,
      v: 2,
      auth: {
        authActive: !0,
        authType: "inherit"
      },
      headers: [],
      folders: e.folders.map((r) => {
        const n = q.safeParseUpToVersion(r, 2);
        if (n.type !== "ok")
          throw new Error("Failed to migrate child collections");
        return n.value;
      })
    };
    return e.id && (t.id = e.id), t;
  }
}), wi = Ei.extend({
  v: l(3),
  // AWS Signature Authorization type addition
  auth: k([Gs, bi]),
  // `description` field addition under `headers`
  headers: k([Sr, x(_i)])
}), c_ = wi.extend({
  folders: ne(() => x(Te(q, 3)))
}), u_ = T({
  initial: !1,
  schema: c_,
  up(e) {
    const t = e.headers.map(
      (n) => ({
        ...n,
        description: ""
      })
    );
    return {
      ...e,
      v: 3,
      headers: t,
      folders: e.folders.map((n) => {
        const a = q.safeParseUpToVersion(n, 3);
        if (a.type !== "ok")
          throw new Error("Failed to migrate child collections");
        return a.value;
      })
    };
  }
}), Ci = wi.extend({
  v: l(4),
  auth: k([wn, Ai])
}), l_ = Ci.extend({
  folders: ne(() => x(Te(q, 4)))
}), d_ = T({
  initial: !1,
  schema: l_,
  up(e) {
    return {
      ...e,
      v: 4,
      folders: e.folders.map((r) => {
        const n = q.safeParseUpToVersion(r, 4);
        if (n.type !== "ok")
          throw new Error("Failed to migrate child collections");
        return n.value;
      })
    };
  }
});
var L = [];
for (var Hr = 0; Hr < 256; ++Hr)
  L.push((Hr + 256).toString(16).slice(1));
function f_(e, t = 0) {
  return (L[e[t + 0]] + L[e[t + 1]] + L[e[t + 2]] + L[e[t + 3]] + "-" + L[e[t + 4]] + L[e[t + 5]] + "-" + L[e[t + 6]] + L[e[t + 7]] + "-" + L[e[t + 8]] + L[e[t + 9]] + "-" + L[e[t + 10]] + L[e[t + 11]] + L[e[t + 12]] + L[e[t + 13]] + L[e[t + 14]] + L[e[t + 15]]).toLowerCase();
}
var jt, h_ = new Uint8Array(16);
function p_() {
  if (!jt && (jt = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto), !jt))
    throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  return jt(h_);
}
var y_ = typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto);
const Ba = {
  randomUUID: y_
};
function m_(e, t, r) {
  if (Ba.randomUUID && !t && !e)
    return Ba.randomUUID();
  e = e || {};
  var n = e.random || (e.rng || p_)();
  return n[6] = n[6] & 15 | 64, n[8] = n[8] & 63 | 128, f_(n);
}
const xi = (e = "") => {
  const t = Date.now().toString(36), r = m_();
  return `${e}_${t}_${r}`;
}, Ri = Ci.extend({
  v: l(5),
  _ref_id: c().optional()
}), v_ = Ri.extend({
  folders: ne(() => x(Te(q, 5)))
}), g_ = T({
  initial: !1,
  schema: v_,
  up(e) {
    return {
      ...e,
      v: 5,
      _ref_id: xi("coll"),
      folders: e.folders.map((r) => {
        const n = q.safeParseUpToVersion(r, 5);
        if (n.type !== "ok")
          throw new Error("Failed to migrate child collections");
        return n.value;
      })
    };
  }
}), Oi = Ri.extend({
  v: l(6),
  auth: k([Cn, wr])
}), __ = Oi.extend({
  folders: ne(() => x(Te(q, 6)))
}), b_ = T({
  initial: !1,
  schema: __,
  up(e) {
    const t = e.auth, r = t.authType === "oauth-2" ? {
      ...t,
      grantTypeInfo: t.grantTypeInfo.grantType === "CLIENT_CREDENTIALS" ? {
        ...t.grantTypeInfo,
        clientAuthentication: "IN_BODY"
      } : t.grantTypeInfo
    } : t;
    return {
      ...e,
      auth: r,
      v: 6,
      folders: e.folders.map((a) => {
        const s = q.safeParseUpToVersion(a, 6);
        if (s.type !== "ok")
          throw new Error("Failed to migrate child collections");
        return s.value;
      })
    };
  }
}), Ii = Oi.extend({
  v: l(7),
  auth: k([Rn, wr])
}), S_ = Ii.extend({
  folders: ne(() => x(Te(q, 7)))
}), A_ = T({
  initial: !1,
  schema: S_,
  up(e) {
    return {
      ...e,
      v: 7,
      folders: e.folders.map((r) => {
        const n = q.safeParseUpToVersion(r, 7);
        if (n.type !== "ok")
          throw new Error("Failed to migrate child collections");
        return n.value;
      })
    };
  }
}), T_ = Ii.extend({
  v: l(8),
  auth: k([$r, wr])
}), $_ = T_.extend({
  folders: ne(() => x(Te(q, 8)))
}), E_ = T({
  initial: !1,
  schema: $_,
  up(e) {
    return {
      ...e,
      v: 8,
      folders: e.folders.map((r) => {
        const n = q.safeParseUpToVersion(r, 8);
        if (n.type !== "ok")
          throw new Error("Failed to migrate child collections");
        return n.value;
      })
    };
  }
}), w_ = f({
  v: Tt()
}), q = Ne({
  latestVersion: 8,
  versionMap: {
    1: Ka,
    2: o_,
    3: u_,
    4: d_,
    5: g_,
    6: b_,
    7: A_,
    8: E_
  },
  getVersion(e) {
    const t = w_.safeParse(e);
    return t.success ? t.data.v : Ka.schema.safeParse(e).success ? 1 : null;
  }
}), C_ = 8;
function ki(e) {
  return {
    v: C_,
    ...e,
    _ref_id: e._ref_id ? e._ref_id : xi("coll")
  };
}
function x_(e) {
  const t = e.name ?? "Untitled", r = (e.folders ?? []).map(x_), n = (e.requests ?? []).map(Dg), a = e.auth ?? { authType: "inherit", authActive: !0 }, s = e.headers ?? [], i = ki({
    name: t,
    folders: r,
    requests: n,
    auth: a,
    headers: s
  });
  return e.id && (i.id = e.id), e._ref_id && (i._ref_id = e._ref_id), i;
}
function R_(e) {
  const t = e.name ?? "Untitled", r = (e.folders ?? []).map(R_), n = (e.requests ?? []).map(n_), a = e.auth ?? { authType: "inherit", authActive: !0 }, s = e.headers ?? [], i = ki({
    name: t,
    folders: r,
    requests: n,
    auth: a,
    headers: s
  });
  return e.id && (i.id = e.id), e._ref_id && (i._ref_id = e._ref_id), i;
}
var $e = function(e) {
  return function(t) {
    return !e(t);
  };
}, O_ = Mo, I_ = Vo;
function Pi(e, t) {
  return t === void 0 ? function(r) {
    return Pi(e, r);
  } : I_(e, t) ? Xa : es(t[e]);
}
var Vi = function(e) {
  return function(t) {
    return t.map(function(r) {
      return e(r);
    });
  };
}, k_ = function(e) {
  return function(t) {
    for (var r = [], n = 0; n < t.length; n++) {
      var a = e(n, t[n]);
      Ya(a) && r.push(a.value);
    }
    return r;
  };
}, P_ = function(e) {
  return k_(function(t, r) {
    return e(r);
  });
}, Ni = function(e) {
  return e.slice();
}, V_ = Po, qa = function(e, t, r) {
  if (r || arguments.length === 2) for (var n = 0, a = t.length, s; n < a; n++)
    (s || !(n in t)) && (s || (s = Array.prototype.slice.call(t, 0, n)), s[n] = t[n]);
  return e.concat(s || Array.prototype.slice.call(t));
}, N_ = function(e) {
  return function(t) {
    return qa(qa([], t, !0), [e], !1);
  };
}, M_ = N_, j_ = function(e) {
  return [e];
}, H_ = M_, D_ = Pi, L_ = function(e) {
  return function(t) {
    return t.map(function(r) {
      return e(r);
    });
  };
}, U_ = function() {
  return {
    concat: function(e, t) {
      return e.concat(t);
    }
  };
}, K_ = function() {
  return {
    concat: U_().concat,
    empty: []
  };
}, Cr = Xa, wt = es;
function Mi(e) {
  return function(t) {
    return e(t) ? wt(t) : Cr;
  };
}
var tn = function(e) {
  return function(t) {
    return ji(t) ? Cr : wt(e(t.value));
  };
}, B_ = Ya, ji = function(e) {
  return e._tag === "None";
}, q_ = function(e, t) {
  return function(r) {
    return ji(r) ? e() : t(r.value);
  };
}, Z_ = q_, Vn = Z_, F_ = function(e, t) {
  for (var r = t(e); r._tag === "Left"; )
    r = t(r.left);
  return r.right;
}, Ee = $o, te = Eo, W_ = /* @__PURE__ */ _o(2, function(e, t) {
  return rt(e) ? e : t(e.right);
}), Ct = function(e) {
  return function(t) {
    return rt(t) ? t : te(e(t.right));
  };
}, xr = function(e) {
  return function(t) {
    return rt(t) ? Ee(e(t.left)) : t;
  };
}, rt = Ao, G_ = To, J_ = function(e) {
  return function(t) {
    return rt(t) ? e(t.left) : t.right;
  };
}, Nn = J_, Za = W_, nr = function() {
  return nr = Object.assign || function(e) {
    for (var t, r = 1, n = arguments.length; r < n; r++) {
      t = arguments[r];
      for (var a in t) Object.prototype.hasOwnProperty.call(t, a) && (e[a] = t[a]);
    }
    return e;
  }, nr.apply(this, arguments);
}, xt = function(e, t, r) {
  return te({
    value: e,
    next: t,
    start: r
  });
}, Rt = function(e, t, r) {
  return t === void 0 && (t = []), r === void 0 && (r = !1), Ee({
    input: e,
    expected: t,
    fatal: r
  });
}, z_ = function(e, t) {
  return nr(nr({}, e), { expected: t });
}, Q_ = function(e, t) {
  return Y_().concat(e, t);
}, Y_ = function() {
  return {
    concat: function(e, t) {
      return e.input.cursor < t.input.cursor ? Io().concat(e, t) : e.input.cursor > t.input.cursor ? kr().concat(e, t) : Oo({
        input: kr(),
        fatal: kr(),
        expected: K_()
      }).concat(e, t);
    }
  };
}, X_ = function(e, t) {
  return t === void 0 && (t = 0), {
    buffer: e,
    cursor: t
  };
}, eb = function(e) {
  return D_(e.cursor, e.buffer);
}, tb = function(e) {
  return e.cursor >= e.buffer.length;
}, rb = function(e) {
  return _(eb(e), tn(function(t) {
    return { value: t, next: { buffer: e.buffer, cursor: e.cursor + 1 } };
  }));
}, Ae = function() {
  return Ae = Object.assign || function(e) {
    for (var t, r = 1, n = arguments.length; r < n; r++) {
      t = arguments[r];
      for (var a in t) Object.prototype.hasOwnProperty.call(t, a) && (e[a] = t[a]);
    }
    return e;
  }, Ae.apply(this, arguments);
}, Mn = function(e) {
  return function(t) {
    return xt(e, t, t);
  };
}, nb = function() {
  return function(e) {
    return Rt(e);
  };
}, ab = function(e) {
  return function() {
    return Rt(e);
  };
}, H = function(e) {
  return _(ob(sb()), Ue(function(t) {
    var r = t[0], n = t[1];
    return e(r) ? nt(r) : ab(n);
  }));
}, j = function(e, t) {
  return function(r) {
    return _(e(r), xr(function(n) {
      return z_(n, [t]);
    }));
  };
}, sb = function() {
  return function(e) {
    return _(rb(e), Vn(function() {
      return Rt(e);
    }, function(t) {
      var r = t.value, n = t.next;
      return xt(r, n, e);
    }));
  };
}, ib = function(e, t) {
  return function(r) {
    return _(e(r), Za(function(n) {
      return _(t(n.value)(n.next), Za(function(a) {
        return xt(a.value, a.next, r);
      }));
    }));
  };
}, Rr = function(e, t) {
  return function(r) {
    var n = e(r);
    return G_(n) || n.left.fatal ? n : _(t()(r), xr(function(a) {
      return Q_(n.left, a);
    }));
  };
}, ob = function(e) {
  return function(t) {
    return _(e(t), Ct(function(r) {
      return Ae(Ae({}, r), { value: [r.value, t] });
    }));
  };
}, Hi = function(e) {
  return Ke(function() {
    return nt(e.empty);
  });
}, jn = function() {
  return j(function(e) {
    return tb(e) ? xt(void 0, e, e) : Rt(e);
  }, "end of file");
}, cb = function(e) {
  return _(Hn(e), Ke(function() {
    return nt([]);
  }));
}, Hn = function(e) {
  return _(e, Ue(function(t) {
    return Ln(j_(t), function(r) {
      return _(e, M(function(n) {
        return Ee(H_(n)(r));
      }), Ke(function() {
        return nt(te(r));
      }));
    });
  }));
}, ub = function(e, t) {
  return function(r) {
    return _(e, Ue(function() {
      return r;
    }), Un(function() {
      return t;
    }));
  };
}, Di = function(e) {
  return ub(e, e);
}, lb = function(e) {
  return cb(H($e(e)));
}, Dn = function(e, t) {
  return _(t, M(function() {
    return V_;
  }), Ke(function() {
    return db(e, t);
  }));
}, db = function(e, t) {
  return _(e, Ue(function(r) {
    return Ln(jo(r), function(n) {
      return _(t, M(function() {
        return te(n);
      }), Ke(function() {
        return _(e, M(function(a) {
          return Ee(O_(a)(n));
        }));
      }));
    });
  }));
}, Ot = function(e, t) {
  return function(r) {
    return _(e(r), Ct(function(n) {
      return Ae(Ae({}, n), { value: t(n.value) });
    }));
  };
}, Li = function(e, t) {
  return Or(e, function(r) {
    return Ot(t, r);
  });
}, Or = function(e, t) {
  return ib(e, t);
}, Ln = function(e, t) {
  var r = function(n) {
    return function(a) {
      return rt(a.value) ? Ee({ value: a.value.left, stream: a.next }) : te(xt(a.value.right, a.next, n));
    };
  };
  return function(n) {
    return F_({ value: e, stream: n }, function(a) {
      var s = t(a.value)(a.stream);
      return rt(s) ? te(Rt(a.stream, s.left.expected, s.left.fatal)) : r(n)(s.right);
    });
  };
}, fb = function(e, t) {
  return Rr(e, t);
}, M = function(e) {
  return function(t) {
    return Ot(t, e);
  };
}, nt = Mn, Ue = function(e) {
  return function(t) {
    return Or(t, e);
  };
}, Un = function(e) {
  return function(t) {
    return Or(t, function(r) {
      return Ot(e(r), function() {
        return r;
      });
    });
  };
}, Ke = function(e) {
  return function(t) {
    return fb(t, e);
  };
}, hb = "Parser", pb = function(e) {
  return {
    concat: function(t, r) {
      return Li(Ot(t, function(n) {
        return function(a) {
          return e.concat(n, a);
        };
      }), r);
    }
  };
}, yb = function(e) {
  return Ae(Ae({}, pb(e)), { empty: Mn(e.empty) });
}, mb = {
  URI: hb,
  map: Ot,
  ap: Li,
  chain: Or,
  chainRec: Ln
}, Ui = function(e, t, r) {
  var n;
  return Object.assign({}, e, (n = {}, n[t] = r, n));
}, Ki = function(e) {
  return function(t) {
    return _(t, M(function(r) {
      return Ui({}, e, r);
    }));
  };
}, rn = function(e, t) {
  return function(r) {
    return _(r, Ue(function(n) {
      return _(t(n), M(function(a) {
        return Ui(n, e, a);
      }));
    }));
  };
}, vb = function(e) {
  return ko(e)(e.empty);
}, gb = Hi(on), at = function(e) {
  return j(H(function(t) {
    return t === e;
  }), '"'.concat(e, '"'));
}, _b = function(e) {
  return j(H(function(t) {
    return t !== e;
  }), 'anything but "'.concat(e, '"'));
}, Kn = function(e) {
  return gb(It(e));
}, It = function(e) {
  return _(Hn(e), M(function(t) {
    return t.join("");
  }));
}, Bn = function(e) {
  return "0123456789".indexOf(e) !== -1;
}, nn = j(H(Bn), "a digit"), bb = /^\s$/, Bi = function(e) {
  return bb.test(e);
}, qi = j(H(Bi), "a whitespace"), Sb = function(e) {
  return e === "_";
}, kt = function(e) {
  return /[a-z]/.test(e.toLowerCase());
}, Zi = function(e) {
  return kt(e) || Bn(e) || Sb(e);
};
j(H(Zi), "a word character");
j(H(kt), "a letter");
var Ab = function(e) {
  return e.toLowerCase() !== e.toUpperCase();
};
j(H(Ab), "an unicode letter");
var Fi = function(e) {
  return kt(e) && e === e.toUpperCase();
};
j(H(Fi), "an upper case letter");
var Wi = function(e) {
  return kt(e) && e === e.toLowerCase();
};
j(H(Wi), "a lower case letter");
j(H($e(Bn)), "a non-digit");
var Gi = j(H($e(Bi)), "a non-whitespace character");
j(H($e(Zi)), "a non-word character");
j(H($e(kt)), "a non-letter character");
j(H($e(Fi)), "anything but an upper case letter");
j(H($e(Wi)), "anything but a lower case letter");
var Ji = function(e) {
  return j(mb.chainRec(e, function(t) {
    return _(Eb(0, t), Vn(function() {
      return nt(te(e));
    }, function(r) {
      return _(at(r), Ue(function() {
        return nt(Ee(t.slice(1)));
      }));
    }));
  }), JSON.stringify(e));
}, an = vb(yb(on)), bt = Hi(on), Tb = function(e) {
  return bt($b(e));
}, $b = function(e) {
  return _(Hn(e), M(function(t) {
    return t.join("");
  }));
}, Eb = function(e, t) {
  return e < t.length ? wt(t.charAt(e)) : Cr;
}, wb = Kn(qi);
It(qi);
Kn(Gi);
It(Gi);
var Cb = function(e) {
  var t = +e;
  return isNaN(t) || e === "" ? Cr : wt(t);
};
j(_(an([bt(at("-")), It(nn)]), M(function(e) {
  return +e;
})), "an integer");
j(_(an([bt(at("-")), Kn(nn), bt(an([at("."), It(nn)]))]), Ue(function(e) {
  return _(Cb(e), Vn(function() {
    return nb();
  }, Mn));
})), "a float");
var xb = Di(at('"'))(Tb(Rr(Ji('\\"'), function() {
  return _b('"');
})));
function zi(e) {
  return function(t) {
    return t(X_(e.split("")));
  };
}
const Fa = (e, t) => (r) => ({
  ...r,
  [e]: t(r[e])
}), Rb = ["#", ":"], st = Di(wb), qn = (e) => (t) => t.join(e), Zn = (e) => _(
  lb((t) => e.includes(t)),
  M(qn(""))
), Ob = be(
  Zn,
  Un(() => H(() => !0))
), Qi = _(
  xb,
  M((e) => JSON.parse(`"${e}"`))
), Ib = _(
  st(Qi),
  Ke(
    () => _(
      Zn([":", `
`]),
      M(ts)
    )
  )
), kb = _(
  st(Qi),
  Ke(
    () => _(
      Zn([`
`]),
      M(ts)
    )
  )
), Yi = _(
  bt(Ji("#")),
  M($e(rs))
), Xi = _(
  st(Yi),
  Ki("commented"),
  rn("key", () => st(Ib)),
  Un(() => at(":")),
  rn("value", () => kb)
), Pb = _(
  st(Yi),
  Ki("commented"),
  rn("key", () => Rr(
    Ob([`
`]),
    () => _(
      Dn(H((e) => !0), jn()),
      M(be(
        Ni,
        qn("")
      ))
    )
  )),
  M(be(
    Mi(({ key: e }) => !rs(e))
  ))
), Vb = _(
  Dn(st(Xi), jn())
), Nb = _(
  Dn(
    Rr(
      _(Xi, M(wt)),
      () => _(
        Pb,
        M(be(
          tn((e) => ({ ...e, value: "" }))
        ))
      )
    ),
    jn()
  ),
  M(be(
    P_(be(
      Mi(B_),
      tn((e) => e.value)
    ))
  ))
), Mb = (e) => {
  if (Rb.some((n) => e.includes(n)))
    return !0;
  const t = JSON.stringify(e);
  return t.substring(1, t.length - 1).trim() !== e;
}, Wa = (e) => Mb(e) ? JSON.stringify(e) : e, BS = (e) => _(
  e,
  L_(
    be(
      Fa("key", Wa),
      Fa("value", Wa),
      ({ key: t, value: r, active: n }) => n ? `${t}: ${r}` : `# ${t}: ${r}`
    )
  ),
  qn(`
`)
), jb = (e) => _(
  Nb,
  zi(e),
  xr((t) => ({
    message: `Expected ${t.expected.map((r) => `'${r}'`).join(", ")}`,
    expected: t.expected,
    pos: t.input.cursor
  })),
  Ct(
    ({ value: t }) => _(
      t,
      Vi(
        ({ key: r, value: n, commented: a }) => ({
          active: !a,
          key: r,
          value: n
        })
      )
    )
  )
), qS = (e) => _(
  Vb,
  zi(e),
  xr((t) => ({
    message: `Expected ${t.expected.map((r) => `'${r}'`).join(", ")}`,
    expected: t.expected,
    pos: t.input.cursor
  })),
  Ct(
    ({ value: t }) => _(
      t,
      Vi(
        ({ key: r, value: n, commented: a }) => ({
          active: !a,
          key: r,
          value: n
        })
      )
    )
  )
), ZS = be(
  jb,
  Ct(Ni),
  Nn(() => [])
), Hb = f({
  id: z(c()),
  name: c(),
  variables: x(
    f({
      key: c(),
      value: c()
    })
  )
}), Ga = T({
  initial: !0,
  schema: Hb
}), eo = () => Math.random().toString(36).substring(2, 16), to = f({
  v: l(1),
  id: c(),
  name: c(),
  variables: x(
    k([
      f({
        key: c(),
        secret: l(!0)
      }),
      f({
        key: c(),
        value: c(),
        secret: l(!1).catch(!1)
      })
    ])
  )
}), Db = T({
  initial: !1,
  schema: to,
  up(e) {
    return {
      ...e,
      v: 1,
      id: e.id || eo(),
      variables: e.variables.map((r) => ({
        ...r,
        secret: !1
      }))
    };
  }
}), Lb = to.extend({
  v: l(2),
  variables: x(
    f({
      key: c(),
      initialValue: c(),
      currentValue: c(),
      secret: w()
    })
  )
}), Ub = T({
  initial: !1,
  schema: Lb,
  up(e) {
    return {
      ...e,
      v: 2,
      variables: e.variables.map((r) => {
        const { key: n, secret: a } = r;
        return {
          key: n,
          secret: a,
          initialValue: a ? "" : r.value,
          currentValue: a ? "" : r.value
        };
      })
    };
  }
}), ro = [
  // Common
  {
    key: "$guid",
    description: "A v4 style GUID.",
    getValue: () => {
      const e = "0123456789abcdef";
      let t = "";
      for (let r = 0; r < 36; r++)
        r === 8 || r === 13 || r === 18 || r === 23 ? t += "-" : r === 14 ? t += "4" : r === 19 ? t += e.charAt(8 + Math.floor(Math.random() * 4)) : t += e.charAt(
          Math.floor(Math.random() * e.length)
        );
      return t;
    }
  },
  {
    key: "$timestamp",
    description: "The current UNIX timestamp in seconds.",
    getValue: () => Math.floor(Date.now() / 1e3).toString()
  },
  {
    key: "$isoTimestamp",
    description: "The current ISO timestamp at zero UTC.",
    getValue: () => (/* @__PURE__ */ new Date()).toISOString()
  },
  {
    key: "$randomUUID",
    description: "A random 36-character UUID.",
    getValue: () => {
      const e = "0123456789abcdef";
      let t = "";
      for (let r = 0; r < 36; r++)
        r === 8 || r === 13 || r === 18 || r === 23 ? t += "-" : t += e.charAt(
          Math.floor(Math.random() * e.length)
        );
      return t;
    }
  },
  // Text, numbers, and colors
  {
    key: "$randomAlphaNumeric",
    description: "A random alphanumeric character.",
    getValue: () => {
      const e = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      return e.charAt(Math.floor(Math.random() * e.length));
    }
  },
  {
    key: "$randomBoolean",
    description: "A random boolean value.",
    getValue: () => Math.random() < 0.5 ? "true" : "false"
  },
  {
    key: "$randomInt",
    description: "A random integer between 0 and 1000.",
    getValue: () => Math.floor(Math.random() * 1e3).toString()
  },
  {
    key: "$randomColor",
    description: "A random color.",
    getValue: () => {
      const e = ["red", "green", "blue", "yellow", "purple", "orange"];
      return e[Math.floor(Math.random() * e.length)];
    }
  },
  {
    key: "$randomHexColor",
    description: "A random hex value.",
    getValue: () => {
      const e = "0123456789abcdef";
      let t = "#";
      for (let r = 0; r < 6; r++)
        t += e.charAt(
          Math.floor(Math.random() * e.length)
        );
      return t;
    }
  },
  {
    key: "$randomAbbreviation",
    description: "A random abbreviation.",
    getValue: () => {
      const e = [
        "SQL",
        "PCI",
        "JSON",
        "HTML",
        "CSS",
        "JS",
        "TS",
        "API"
      ];
      return e[Math.floor(Math.random() * e.length)];
    }
  },
  // Internet and IP addresses
  {
    key: "$randomIP",
    description: "A random IPv4 address.",
    getValue: () => Array.from(
      { length: 4 },
      () => Math.floor(Math.random() * 256)
    ).join(".")
  },
  {
    key: "$randomIPV6",
    description: "A random IPv6 address.",
    getValue: () => Array.from(
      { length: 8 },
      () => Math.floor(Math.random() * 65536).toString(16)
    ).join(":")
  },
  {
    key: "$randomMACAddress",
    description: "A random MAC address.",
    getValue: () => Array.from(
      { length: 6 },
      () => Math.floor(Math.random() * 256).toString(16)
    ).join(":")
  },
  {
    key: "$randomPassword",
    description: "A random 15-character alphanumeric password.",
    getValue: () => {
      const e = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      let t = "";
      for (let r = 0; r < 15; r++)
        t += e.charAt(
          Math.floor(Math.random() * e.length)
        );
      return t;
    }
  },
  {
    key: "$randomLocale",
    description: "A random two-letter language code (ISO 639-1).",
    getValue: () => {
      const e = ["ny", "sr", "si"];
      return e[Math.floor(Math.random() * e.length)];
    }
  },
  {
    key: "$randomUserAgent",
    description: "A random user agent.",
    getValue: () => {
      const e = [
        "Mozilla/5.0 (Macintosh; U; Intel Mac OS X 10.9.8; rv:15.6) Gecko/20100101 Firefox/15.6.6",
        "Mozilla/5.0 (Windows NT 6.1; WOW64; rv:15.6) Gecko/20100101 Firefox/15.6.6",
        "Mozilla/5.0 (Windows NT 6.1; WOW64; rv:15.6) Gecko/20100101 Firefox/15.6.6"
      ];
      return e[Math.floor(Math.random() * e.length)];
    }
  },
  {
    key: "$randomProtocol",
    description: "A random internet protocol.",
    getValue: () => {
      const e = ["http", "https"];
      return e[Math.floor(Math.random() * e.length)];
    }
  },
  {
    key: "$randomSemver",
    description: "A random semantic version number.",
    getValue: () => Array.from(
      { length: 3 },
      () => Math.floor(Math.random() * 10)
    ).join(".")
  },
  // Names
  {
    key: "$randomFirstName",
    description: "A random first name.",
    getValue: () => {
      const e = [
        "Ethan",
        "Chandler",
        "Megane",
        "John",
        "Jane",
        "Alice",
        "Bob"
      ];
      return e[Math.floor(Math.random() * e.length)];
    }
  },
  {
    key: "$randomLastName",
    description: "A random last name.",
    getValue: () => {
      const e = [
        "Schaden",
        "Schneider",
        "Willms",
        "Doe",
        "Smith",
        "Johnson"
      ];
      return e[Math.floor(Math.random() * e.length)];
    }
  },
  {
    key: "$randomFullName",
    description: "A random first and last name.",
    getValue: () => {
      const e = [
        "Ethan",
        "Chandler",
        "Megane",
        "John",
        "Jane",
        "Alice",
        "Bob"
      ], t = [
        "Schaden",
        "Schneider",
        "Willms",
        "Doe",
        "Smith",
        "Johnson"
      ];
      return `${e[Math.floor(Math.random() * e.length)]} ${t[Math.floor(Math.random() * t.length)]}`;
    }
  },
  {
    key: "$randomNamePrefix",
    description: "A random name prefix.",
    getValue: () => {
      const e = ["Dr.", "Ms.", "Mr.", "Mrs.", "Miss", "Prof."];
      return e[Math.floor(Math.random() * e.length)];
    }
  },
  {
    key: "$randomNameSuffix",
    description: "A random name suffix.",
    getValue: () => {
      const e = ["I", "MD", "DDS", "PhD", "Esq.", "Jr."];
      return e[Math.floor(Math.random() * e.length)];
    }
  },
  // Addresses
  {
    key: "$randomCity",
    description: "A random city name.",
    getValue: () => {
      const e = [
        "New York",
        "Los Angeles",
        "Chicago",
        "Houston",
        "Phoenix",
        "Philadelphia"
      ];
      return e[Math.floor(Math.random() * e.length)];
    }
  },
  // profession
  {
    key: "$randomJobArea",
    description: "A random job area.",
    getValue: () => {
      const e = [
        "Mobility",
        "Intranet",
        "Configuration",
        "Development",
        "Design",
        "Testing"
      ];
      return e[Math.floor(Math.random() * e.length)];
    }
  },
  {
    key: "$randomJobDescriptor",
    description: "A random job descriptor.",
    getValue: () => {
      const e = [
        "Forward",
        "Corporate",
        "Senior",
        "Junior",
        "Lead",
        "Principal"
      ];
      return e[Math.floor(Math.random() * e.length)];
    }
  },
  {
    key: "$randomJobTitle",
    description: "A random job title.",
    getValue: () => {
      const e = [
        "International Creative Liaison",
        "Global Branding Officer",
        "Dynamic Data Specialist",
        "Internal Communications Consultant",
        "Productivity Analyst",
        "Regional Applications Developer"
      ];
      return e[Math.floor(Math.random() * e.length)];
    }
  },
  {
    key: "$randomJobType",
    description: "A random job type.",
    getValue: () => {
      const e = ["Supervisor", "Manager", "Coordinator", "Director"];
      return e[Math.floor(Math.random() * e.length)];
    }
  }
  // TODO: Support various other predefined variables
], Kb = f({
  v: Tt()
}), FS = Ne({
  latestVersion: 2,
  versionMap: {
    0: Ga,
    1: Db,
    2: Ub
  },
  getVersion(e) {
    const t = Kb.safeParse(e);
    return t.success ? t.data.v : Ga.schema.safeParse(e).success ? 0 : null;
  }
}), ar = /<<([^>]*)>>/g, sr = 10, no = "ENV_EXPAND_LOOP", Ja = 2;
function Bb(e, t) {
  let r = e, n = 0;
  for (; r.match(ar) != null && n <= sr; )
    r = r.replace(ar, (a) => {
      const s = a.replace(/[<>]/g, ""), i = ro.find(
        (u) => u.key === s
      );
      if (i)
        return i.getValue();
      const o = t.find((u) => u.key === s);
      return o && "currentValue" in o ? o.currentValue : a;
    }), n++;
  return n > sr ? Ee(no) : te(r);
}
const WS = (e, t) => _(
  Bb(e, t),
  Nn(() => e)
);
function qb(e, t, r = !1, n = !1) {
  if (!t || !e)
    return te(e);
  let a = e, s = 0, i = !1;
  for (; a.match(ar) != null && s <= sr && !i; )
    a = decodeURI(encodeURI(a)).replace(ar, (o, u) => {
      const d = ro.find(
        (A) => A.key === u
      );
      if (d)
        return d.getValue();
      const y = t.find((A) => A && A.key === u);
      return y && "currentValue" in y ? y.secret && n ? (i = !0, `<<${u}>>`) : y.secret && r ? "*".repeat(
        y.currentValue.length
      ) : y.currentValue : "";
    }), s++;
  return s > sr ? Ee(no) : te(a);
}
const GS = (e, t, r = !1, n = !1) => _(
  qb(e, t, r, n),
  Nn(() => e)
), Zb = (e) => ({
  key: e.key,
  initialValue: e.initialValue ?? e.value ?? "",
  currentValue: e.currentValue ?? e.value ?? "",
  secret: e.secret ?? !1
}), JS = (e) => {
  if (e.v && e.v === Ja) return e;
  const t = e.id || eo(), r = e.name ?? "Untitled", n = (e.variables ?? []).map(Zb);
  return {
    v: Ja,
    id: t,
    name: r,
    variables: n
  };
}, Fb = x(
  k([
    f({
      key: c(),
      value: c(),
      secret: l(!1)
    }),
    f({
      key: c(),
      secret: l(!0)
    }),
    f({
      key: c(),
      value: c()
    })
  ])
), za = T({
  initial: !0,
  schema: Fb
}), ao = f({
  v: l(1),
  variables: x(
    k([
      f({
        key: c(),
        secret: l(!0)
      }),
      f({
        key: c(),
        value: c(),
        secret: l(!1)
      })
    ])
  )
}), Wb = T({
  initial: !1,
  schema: ao,
  up(e) {
    return {
      v: 1,
      variables: e.map((r) => "value" in r ? {
        key: r.key,
        value: r.value,
        secret: !1
      } : {
        key: r.key,
        secret: !0
      })
    };
  }
}), Gb = ao.extend({
  v: l(2),
  variables: x(
    f({
      key: c(),
      initialValue: c(),
      currentValue: c(),
      secret: w()
    })
  )
}), Jb = T({
  initial: !1,
  schema: Gb,
  up(e) {
    return {
      ...e,
      v: 2,
      variables: e.variables.map((r) => {
        const { key: n, secret: a } = r;
        return {
          key: n,
          secret: a ?? !1,
          initialValue: r.secret ? "" : r.value,
          currentValue: r.secret ? "" : r.value
        };
      })
    };
  }
}), zb = f({
  v: Tt()
}), zS = Ne({
  latestVersion: 2,
  versionMap: {
    0: za,
    1: Wb,
    2: Jb
  },
  getVersion(e) {
    const t = zb.safeParse(e);
    return t.success ? t.data.v : za.schema.safeParse(e).success ? 0 : null;
  }
});
async function Qb(e = 6) {
  const t = new Uint8Array(e);
  return crypto.getRandomValues(t), Array.from(t).map((r) => r.toString(16).padStart(2, "0")).join("").substring(0, e);
}
function Yb(e) {
  const r = new TextEncoder().encode(e);
  return crypto.subtle.digest("SHA-256", r);
}
function Xb(e) {
  const r = new TextEncoder().encode(e);
  return crypto.subtle.digest("SHA-1", r);
}
async function eS(e, t) {
  return t === "sha256" ? Yb(e) : Xb(e);
}
async function tS(e, t, r) {
  const n = new TextEncoder(), a = n.encode(e), s = n.encode(t), i = r === "sha256" ? "SHA-256" : "SHA-1", o = await crypto.subtle.importKey(
    "raw",
    a,
    {
      name: "HMAC",
      hash: { name: i }
    },
    !1,
    ["sign"]
  ), u = await crypto.subtle.sign("HMAC", o, s);
  return btoa(String.fromCharCode.apply(null, [...new Uint8Array(u)]));
}
function qe(e) {
  return e.replace(/\r\n/g, `
`).replace(/\r/g, `
`);
}
async function rS(e, t) {
  if (!e) return "";
  if (e instanceof FormData)
    if (t === "multipart/form-data") {
      const r = [];
      return e.forEach((n, a) => {
        typeof n == "string" ? r.push(`${a}=${n}`) : r.push(`${a}=${n instanceof File ? n.name : "blob"}`);
      }), qe(r.join("&"));
    } else {
      const r = [];
      return e.forEach((n, a) => {
        typeof n == "string" && r.push(`${a}=${encodeURIComponent(n)}`);
      }), qe(r.join("&"));
    }
  if (e instanceof Blob)
    try {
      const r = await e.text();
      return qe(r);
    } catch (r) {
      return console.error("Failed to read blob content", r), "";
    }
  if (t.includes("application/json") && typeof e == "string")
    try {
      const r = JSON.parse(e);
      return qe(JSON.stringify(r));
    } catch {
      return qe(e.toString());
    }
  return qe(e.toString());
}
async function QS(e) {
  const t = e.timestamp !== void 0 && e.timestamp !== null ? e.timestamp : Math.floor(Date.now() / 1e3), r = e.nonce && e.nonce !== "" ? e.nonce : await Qb(), n = new URL(e.url), a = n.hostname, s = n.port || (n.protocol === "https:" ? "443" : "80"), i = n.pathname + n.search, o = {
    ts: t,
    nonce: r,
    method: e.method.toUpperCase(),
    resource: i,
    host: a,
    port: s,
    hash: "",
    ext: e.ext || ""
  };
  if (e.includePayloadHash && e.payload)
    try {
      const A = e.contentType || "text/plain", E = await rS(e.payload, A), Z = `hawk.1.payload
${A}
${E}
`, U = await eS(Z, e.algorithm);
      o.hash = btoa(
        String.fromCharCode.apply(null, [...new Uint8Array(U)])
      );
    } catch (A) {
      console.error("Error calculating payload hash:", A);
    }
  const u = `hawk.1.header
${o.ts}
${o.nonce}
${o.method}
${o.resource}
${o.host}
${o.port}
${o.hash}
${o.ext}
`, d = await tS(e.key, u, e.algorithm), y = [
    `Hawk id="${e.id}"`,
    `ts="${o.ts}"`,
    `nonce="${o.nonce}"`,
    `mac="${d}"`
  ];
  return e.ext && e.ext !== "" && y.push(`ext="${e.ext}"`), e.app && e.app !== "" && y.push(`app="${e.app}"`), e.dlg && e.dlg !== "" && y.push(`dlg="${e.dlg}"`), o.hash !== "" && y.push(`hash="${o.hash}"`), y.join(", ");
}
async function YS(e) {
  const t = new TextEncoder();
  new TextDecoder();
  const r = e.timestamp || Math.floor(Date.now() / 1e3).toString(), n = e.nonce || crypto.randomUUID(), a = e.host || new URL(e.url).host, s = await crypto.subtle.importKey(
    "raw",
    t.encode(e.clientSecret),
    { name: "HMAC", hash: "SHA-256" },
    !1,
    ["sign"]
  );
  await crypto.subtle.sign(
    "HMAC",
    s,
    t.encode(r)
  );
  let i = "";
  if (e.body) {
    const A = await crypto.subtle.digest(
      "SHA-256",
      t.encode(e.body)
    );
    i = Array.from(new Uint8Array(A)).map((E) => E.toString(16).padStart(2, "0")).join("");
  }
  const o = `${e.method} ${e.url} ${a} ${r} ${n} ${i}`, u = await crypto.subtle.sign(
    "HMAC",
    s,
    t.encode(o)
  ), d = btoa(
    String.fromCharCode(...new Uint8Array(u))
  );
  return `EG1-HMAC-SHA256 client_token=${e.clientToken};access_token=${e.accessToken};timestamp=${r};nonce=${n};signature=${d}`;
}
const Ge = new TextEncoder(), ir = new TextDecoder();
function nS(...e) {
  const t = e.reduce((a, { length: s }) => a + s, 0), r = new Uint8Array(t);
  let n = 0;
  for (const a of e)
    r.set(a, n), n += a.length;
  return r;
}
function aS(e) {
  if (Uint8Array.prototype.toBase64)
    return e.toBase64();
  const t = 32768, r = [];
  for (let n = 0; n < e.length; n += t)
    r.push(String.fromCharCode.apply(null, e.subarray(n, n + t)));
  return btoa(r.join(""));
}
function sS(e) {
  if (Uint8Array.fromBase64)
    return Uint8Array.fromBase64(e);
  const t = atob(e), r = new Uint8Array(t.length);
  for (let n = 0; n < t.length; n++)
    r[n] = t.charCodeAt(n);
  return r;
}
function iS(e) {
  if (Uint8Array.fromBase64)
    return Uint8Array.fromBase64(typeof e == "string" ? e : ir.decode(e), {
      alphabet: "base64url"
    });
  let t = e;
  t instanceof Uint8Array && (t = ir.decode(t)), t = t.replace(/-/g, "+").replace(/_/g, "/").replace(/\s/g, "");
  try {
    return sS(t);
  } catch {
    throw new TypeError("The input to be decoded is not correctly encoded.");
  }
}
function Dr(e) {
  let t = e;
  return typeof t == "string" && (t = Ge.encode(t)), Uint8Array.prototype.toBase64 ? t.toBase64({ alphabet: "base64url", omitPadding: !0 }) : aS(t).replace(/=/g, "").replace(/\+/g, "-").replace(/\//g, "_");
}
class Ir extends Error {
  constructor(r, n) {
    var a;
    super(r, n);
    ae(this, "code", "ERR_JOSE_GENERIC");
    this.name = this.constructor.name, (a = Error.captureStackTrace) == null || a.call(Error, this, this.constructor);
  }
}
ae(Ir, "code", "ERR_JOSE_GENERIC");
class Oe extends Ir {
  constructor() {
    super(...arguments);
    ae(this, "code", "ERR_JOSE_NOT_SUPPORTED");
  }
}
ae(Oe, "code", "ERR_JOSE_NOT_SUPPORTED");
class Fe extends Ir {
  constructor() {
    super(...arguments);
    ae(this, "code", "ERR_JWS_INVALID");
  }
}
ae(Fe, "code", "ERR_JWS_INVALID");
class so extends Ir {
  constructor() {
    super(...arguments);
    ae(this, "code", "ERR_JWT_INVALID");
  }
}
ae(so, "code", "ERR_JWT_INVALID");
function se(e, t = "algorithm.name") {
  return new TypeError(`CryptoKey does not support this operation, its ${t} must be ${e}`);
}
function pt(e, t) {
  return e.name === t;
}
function Lr(e) {
  return parseInt(e.name.slice(4), 10);
}
function oS(e) {
  switch (e) {
    case "ES256":
      return "P-256";
    case "ES384":
      return "P-384";
    case "ES512":
      return "P-521";
    default:
      throw new Error("unreachable");
  }
}
function cS(e, t) {
  if (!e.usages.includes(t))
    throw new TypeError(`CryptoKey does not support this operation, its usages must include ${t}.`);
}
function uS(e, t, r) {
  switch (t) {
    case "HS256":
    case "HS384":
    case "HS512": {
      if (!pt(e.algorithm, "HMAC"))
        throw se("HMAC");
      const n = parseInt(t.slice(2), 10);
      if (Lr(e.algorithm.hash) !== n)
        throw se(`SHA-${n}`, "algorithm.hash");
      break;
    }
    case "RS256":
    case "RS384":
    case "RS512": {
      if (!pt(e.algorithm, "RSASSA-PKCS1-v1_5"))
        throw se("RSASSA-PKCS1-v1_5");
      const n = parseInt(t.slice(2), 10);
      if (Lr(e.algorithm.hash) !== n)
        throw se(`SHA-${n}`, "algorithm.hash");
      break;
    }
    case "PS256":
    case "PS384":
    case "PS512": {
      if (!pt(e.algorithm, "RSA-PSS"))
        throw se("RSA-PSS");
      const n = parseInt(t.slice(2), 10);
      if (Lr(e.algorithm.hash) !== n)
        throw se(`SHA-${n}`, "algorithm.hash");
      break;
    }
    case "Ed25519":
    case "EdDSA": {
      if (!pt(e.algorithm, "Ed25519"))
        throw se("Ed25519");
      break;
    }
    case "ES256":
    case "ES384":
    case "ES512": {
      if (!pt(e.algorithm, "ECDSA"))
        throw se("ECDSA");
      const n = oS(t);
      if (e.algorithm.namedCurve !== n)
        throw se(n, "algorithm.namedCurve");
      break;
    }
    default:
      throw new TypeError("CryptoKey does not support this operation");
  }
  cS(e, r);
}
function io(e, t, ...r) {
  var n;
  if (r = r.filter(Boolean), r.length > 2) {
    const a = r.pop();
    e += `one of type ${r.join(", ")}, or ${a}.`;
  } else r.length === 2 ? e += `one of type ${r[0]} or ${r[1]}.` : e += `of type ${r[0]}.`;
  return t == null ? e += ` Received ${t}` : typeof t == "function" && t.name ? e += ` Received function ${t.name}` : typeof t == "object" && t != null && (n = t.constructor) != null && n.name && (e += ` Received an instance of ${t.constructor.name}`), e;
}
const lS = (e, ...t) => io("Key must be ", e, ...t);
function oo(e, t, ...r) {
  return io(`Key for the ${e} algorithm must be `, t, ...r);
}
function co(e) {
  return (e == null ? void 0 : e[Symbol.toStringTag]) === "CryptoKey";
}
function uo(e) {
  return (e == null ? void 0 : e[Symbol.toStringTag]) === "KeyObject";
}
const lo = (e) => co(e) || uo(e), dS = (...e) => {
  const t = e.filter(Boolean);
  if (t.length === 0 || t.length === 1)
    return !0;
  let r;
  for (const n of t) {
    const a = Object.keys(n);
    if (!r || r.size === 0) {
      r = new Set(a);
      continue;
    }
    for (const s of a) {
      if (r.has(s))
        return !1;
      r.add(s);
    }
  }
  return !0;
};
function fS(e) {
  return typeof e == "object" && e !== null;
}
const fo = (e) => {
  if (!fS(e) || Object.prototype.toString.call(e) !== "[object Object]")
    return !1;
  if (Object.getPrototypeOf(e) === null)
    return !0;
  let t = e;
  for (; Object.getPrototypeOf(t) !== null; )
    t = Object.getPrototypeOf(t);
  return Object.getPrototypeOf(e) === t;
}, hS = (e, t) => {
  if (e.startsWith("RS") || e.startsWith("PS")) {
    const { modulusLength: r } = t.algorithm;
    if (typeof r != "number" || r < 2048)
      throw new TypeError(`${e} requires key modulusLength to be 2048 bits or larger`);
  }
};
function pS(e) {
  let t, r;
  switch (e.kty) {
    case "RSA": {
      switch (e.alg) {
        case "PS256":
        case "PS384":
        case "PS512":
          t = { name: "RSA-PSS", hash: `SHA-${e.alg.slice(-3)}` }, r = e.d ? ["sign"] : ["verify"];
          break;
        case "RS256":
        case "RS384":
        case "RS512":
          t = { name: "RSASSA-PKCS1-v1_5", hash: `SHA-${e.alg.slice(-3)}` }, r = e.d ? ["sign"] : ["verify"];
          break;
        case "RSA-OAEP":
        case "RSA-OAEP-256":
        case "RSA-OAEP-384":
        case "RSA-OAEP-512":
          t = {
            name: "RSA-OAEP",
            hash: `SHA-${parseInt(e.alg.slice(-3), 10) || 1}`
          }, r = e.d ? ["decrypt", "unwrapKey"] : ["encrypt", "wrapKey"];
          break;
        default:
          throw new Oe('Invalid or unsupported JWK "alg" (Algorithm) Parameter value');
      }
      break;
    }
    case "EC": {
      switch (e.alg) {
        case "ES256":
          t = { name: "ECDSA", namedCurve: "P-256" }, r = e.d ? ["sign"] : ["verify"];
          break;
        case "ES384":
          t = { name: "ECDSA", namedCurve: "P-384" }, r = e.d ? ["sign"] : ["verify"];
          break;
        case "ES512":
          t = { name: "ECDSA", namedCurve: "P-521" }, r = e.d ? ["sign"] : ["verify"];
          break;
        case "ECDH-ES":
        case "ECDH-ES+A128KW":
        case "ECDH-ES+A192KW":
        case "ECDH-ES+A256KW":
          t = { name: "ECDH", namedCurve: e.crv }, r = e.d ? ["deriveBits"] : [];
          break;
        default:
          throw new Oe('Invalid or unsupported JWK "alg" (Algorithm) Parameter value');
      }
      break;
    }
    case "OKP": {
      switch (e.alg) {
        case "Ed25519":
        case "EdDSA":
          t = { name: "Ed25519" }, r = e.d ? ["sign"] : ["verify"];
          break;
        case "ECDH-ES":
        case "ECDH-ES+A128KW":
        case "ECDH-ES+A192KW":
        case "ECDH-ES+A256KW":
          t = { name: e.crv }, r = e.d ? ["deriveBits"] : [];
          break;
        default:
          throw new Oe('Invalid or unsupported JWK "alg" (Algorithm) Parameter value');
      }
      break;
    }
    default:
      throw new Oe('Invalid or unsupported JWK "kty" (Key Type) Parameter value');
  }
  return { algorithm: t, keyUsages: r };
}
const yS = async (e) => {
  if (!e.alg)
    throw new TypeError('"alg" argument is required when "jwk.alg" is not present');
  const { algorithm: t, keyUsages: r } = pS(e), n = { ...e };
  return delete n.alg, delete n.use, crypto.subtle.importKey("jwk", n, t, e.ext ?? !e.d, e.key_ops ?? r);
}, mS = (e, t, r, n, a) => {
  if (a.crit !== void 0 && (n == null ? void 0 : n.crit) === void 0)
    throw new e('"crit" (Critical) Header Parameter MUST be integrity protected');
  if (!n || n.crit === void 0)
    return /* @__PURE__ */ new Set();
  if (!Array.isArray(n.crit) || n.crit.length === 0 || n.crit.some((i) => typeof i != "string" || i.length === 0))
    throw new e('"crit" (Critical) Header Parameter MUST be an array of non-empty strings when present');
  let s;
  r !== void 0 ? s = new Map([...Object.entries(r), ...t.entries()]) : s = t;
  for (const i of n.crit) {
    if (!s.has(i))
      throw new Oe(`Extension Header Parameter "${i}" is not recognized`);
    if (a[i] === void 0)
      throw new e(`Extension Header Parameter "${i}" is missing`);
    if (s.get(i) && n[i] === void 0)
      throw new e(`Extension Header Parameter "${i}" MUST be integrity protected`);
  }
  return new Set(n.crit);
};
function Fn(e) {
  return fo(e) && typeof e.kty == "string";
}
function vS(e) {
  return e.kty !== "oct" && typeof e.d == "string";
}
function gS(e) {
  return e.kty !== "oct" && typeof e.d > "u";
}
function _S(e) {
  return e.kty === "oct" && typeof e.k == "string";
}
let Je;
const Qa = async (e, t, r, n = !1) => {
  Je || (Je = /* @__PURE__ */ new WeakMap());
  let a = Je.get(e);
  if (a != null && a[r])
    return a[r];
  const s = await yS({ ...t, alg: r });
  return n && Object.freeze(e), a ? a[r] = s : Je.set(e, { [r]: s }), s;
}, bS = (e, t) => {
  var i;
  Je || (Je = /* @__PURE__ */ new WeakMap());
  let r = Je.get(e);
  if (r != null && r[t])
    return r[t];
  const n = e.type === "public", a = !!n;
  let s;
  if (e.asymmetricKeyType === "x25519") {
    switch (t) {
      case "ECDH-ES":
      case "ECDH-ES+A128KW":
      case "ECDH-ES+A192KW":
      case "ECDH-ES+A256KW":
        break;
      default:
        throw new TypeError("given KeyObject instance cannot be used for this algorithm");
    }
    s = e.toCryptoKey(e.asymmetricKeyType, a, n ? [] : ["deriveBits"]);
  }
  if (e.asymmetricKeyType === "ed25519") {
    if (t !== "EdDSA" && t !== "Ed25519")
      throw new TypeError("given KeyObject instance cannot be used for this algorithm");
    s = e.toCryptoKey(e.asymmetricKeyType, a, [
      n ? "verify" : "sign"
    ]);
  }
  if (e.asymmetricKeyType === "rsa") {
    let o;
    switch (t) {
      case "RSA-OAEP":
        o = "SHA-1";
        break;
      case "RS256":
      case "PS256":
      case "RSA-OAEP-256":
        o = "SHA-256";
        break;
      case "RS384":
      case "PS384":
      case "RSA-OAEP-384":
        o = "SHA-384";
        break;
      case "RS512":
      case "PS512":
      case "RSA-OAEP-512":
        o = "SHA-512";
        break;
      default:
        throw new TypeError("given KeyObject instance cannot be used for this algorithm");
    }
    if (t.startsWith("RSA-OAEP"))
      return e.toCryptoKey({
        name: "RSA-OAEP",
        hash: o
      }, a, n ? ["encrypt"] : ["decrypt"]);
    s = e.toCryptoKey({
      name: t.startsWith("PS") ? "RSA-PSS" : "RSASSA-PKCS1-v1_5",
      hash: o
    }, a, [n ? "verify" : "sign"]);
  }
  if (e.asymmetricKeyType === "ec") {
    const u = (/* @__PURE__ */ new Map([
      ["prime256v1", "P-256"],
      ["secp384r1", "P-384"],
      ["secp521r1", "P-521"]
    ])).get((i = e.asymmetricKeyDetails) == null ? void 0 : i.namedCurve);
    if (!u)
      throw new TypeError("given KeyObject instance cannot be used for this algorithm");
    t === "ES256" && u === "P-256" && (s = e.toCryptoKey({
      name: "ECDSA",
      namedCurve: u
    }, a, [n ? "verify" : "sign"])), t === "ES384" && u === "P-384" && (s = e.toCryptoKey({
      name: "ECDSA",
      namedCurve: u
    }, a, [n ? "verify" : "sign"])), t === "ES512" && u === "P-521" && (s = e.toCryptoKey({
      name: "ECDSA",
      namedCurve: u
    }, a, [n ? "verify" : "sign"])), t.startsWith("ECDH-ES") && (s = e.toCryptoKey({
      name: "ECDH",
      namedCurve: u
    }, a, n ? [] : ["deriveBits"]));
  }
  if (!s)
    throw new TypeError("given KeyObject instance cannot be used for this algorithm");
  return r ? r[t] = s : Je.set(e, { [t]: s }), s;
}, SS = async (e, t) => {
  if (e instanceof Uint8Array || co(e))
    return e;
  if (uo(e)) {
    if (e.type === "secret")
      return e.export();
    if ("toCryptoKey" in e && typeof e.toCryptoKey == "function")
      try {
        return bS(e, t);
      } catch (n) {
        if (n instanceof TypeError)
          throw n;
      }
    let r = e.export({ format: "jwk" });
    return Qa(e, r, t);
  }
  if (Fn(e))
    return e.k ? iS(e.k) : Qa(e, e, t, !0);
  throw new Error("unreachable");
}, We = (e) => e == null ? void 0 : e[Symbol.toStringTag], sn = (e, t, r) => {
  var n, a;
  if (t.use !== void 0) {
    let s;
    switch (r) {
      case "sign":
      case "verify":
        s = "sig";
        break;
      case "encrypt":
      case "decrypt":
        s = "enc";
        break;
    }
    if (t.use !== s)
      throw new TypeError(`Invalid key for this operation, its "use" must be "${s}" when present`);
  }
  if (t.alg !== void 0 && t.alg !== e)
    throw new TypeError(`Invalid key for this operation, its "alg" must be "${e}" when present`);
  if (Array.isArray(t.key_ops)) {
    let s;
    switch (!0) {
      case r === "sign":
      case e === "dir":
      case e.includes("CBC-HS"):
        s = r;
        break;
      case e.startsWith("PBES2"):
        s = "deriveBits";
        break;
      case /^A\d{3}(?:GCM)?(?:KW)?$/.test(e):
        !e.includes("GCM") && e.endsWith("KW") ? s = "unwrapKey" : s = r;
        break;
      case r === "encrypt":
        s = "wrapKey";
        break;
      case r === "decrypt":
        s = e.startsWith("RSA") ? "unwrapKey" : "deriveBits";
        break;
    }
    if (s && ((a = (n = t.key_ops) == null ? void 0 : n.includes) == null ? void 0 : a.call(n, s)) === !1)
      throw new TypeError(`Invalid key for this operation, its "key_ops" must include "${s}" when present`);
  }
  return !0;
}, AS = (e, t, r) => {
  if (!(t instanceof Uint8Array)) {
    if (Fn(t)) {
      if (_S(t) && sn(e, t, r))
        return;
      throw new TypeError('JSON Web Key for symmetric algorithms must have JWK "kty" (Key Type) equal to "oct" and the JWK "k" (Key Value) present');
    }
    if (!lo(t))
      throw new TypeError(oo(e, t, "CryptoKey", "KeyObject", "JSON Web Key", "Uint8Array"));
    if (t.type !== "secret")
      throw new TypeError(`${We(t)} instances for symmetric algorithms must be of type "secret"`);
  }
}, TS = (e, t, r) => {
  if (Fn(t))
    switch (r) {
      case "decrypt":
      case "sign":
        if (vS(t) && sn(e, t, r))
          return;
        throw new TypeError("JSON Web Key for this operation be a private JWK");
      case "encrypt":
      case "verify":
        if (gS(t) && sn(e, t, r))
          return;
        throw new TypeError("JSON Web Key for this operation be a public JWK");
    }
  if (!lo(t))
    throw new TypeError(oo(e, t, "CryptoKey", "KeyObject", "JSON Web Key"));
  if (t.type === "secret")
    throw new TypeError(`${We(t)} instances for asymmetric algorithms must not be of type "secret"`);
  if (t.type === "public")
    switch (r) {
      case "sign":
        throw new TypeError(`${We(t)} instances for asymmetric algorithm signing must be of type "private"`);
      case "decrypt":
        throw new TypeError(`${We(t)} instances for asymmetric algorithm decryption must be of type "private"`);
    }
  if (t.type === "private")
    switch (r) {
      case "verify":
        throw new TypeError(`${We(t)} instances for asymmetric algorithm verifying must be of type "public"`);
      case "encrypt":
        throw new TypeError(`${We(t)} instances for asymmetric algorithm encryption must be of type "public"`);
    }
}, $S = (e, t, r) => {
  e.startsWith("HS") || e === "dir" || e.startsWith("PBES2") || /^A(?:128|192|256)(?:GCM)?(?:KW)?$/.test(e) || /^A(?:128|192|256)CBC-HS(?:256|384|512)$/.test(e) ? AS(e, t, r) : TS(e, t, r);
}, ES = (e, t) => {
  const r = `SHA-${e.slice(-3)}`;
  switch (e) {
    case "HS256":
    case "HS384":
    case "HS512":
      return { hash: r, name: "HMAC" };
    case "PS256":
    case "PS384":
    case "PS512":
      return { hash: r, name: "RSA-PSS", saltLength: parseInt(e.slice(-3), 10) >> 3 };
    case "RS256":
    case "RS384":
    case "RS512":
      return { hash: r, name: "RSASSA-PKCS1-v1_5" };
    case "ES256":
    case "ES384":
    case "ES512":
      return { hash: r, name: "ECDSA", namedCurve: t.namedCurve };
    case "Ed25519":
    case "EdDSA":
      return { name: "Ed25519" };
    default:
      throw new Oe(`alg ${e} is not supported either by JOSE or your javascript runtime`);
  }
}, wS = async (e, t, r) => {
  if (t instanceof Uint8Array) {
    if (!e.startsWith("HS"))
      throw new TypeError(lS(t, "CryptoKey", "KeyObject", "JSON Web Key"));
    return crypto.subtle.importKey("raw", t, { hash: `SHA-${e.slice(-3)}`, name: "HMAC" }, !1, [r]);
  }
  return uS(t, e, r), t;
}, Ce = (e) => Math.floor(e.getTime() / 1e3), ho = 60, po = ho * 60, Wn = po * 24, CS = Wn * 7, xS = Wn * 365.25, RS = /^(\+|\-)? ?(\d+|\d+\.\d+) ?(seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|weeks?|w|years?|yrs?|y)(?: (ago|from now))?$/i, Ur = (e) => {
  const t = RS.exec(e);
  if (!t || t[4] && t[1])
    throw new TypeError("Invalid time period format");
  const r = parseFloat(t[2]), n = t[3].toLowerCase();
  let a;
  switch (n) {
    case "sec":
    case "secs":
    case "second":
    case "seconds":
    case "s":
      a = Math.round(r);
      break;
    case "minute":
    case "minutes":
    case "min":
    case "mins":
    case "m":
      a = Math.round(r * ho);
      break;
    case "hour":
    case "hours":
    case "hr":
    case "hrs":
    case "h":
      a = Math.round(r * po);
      break;
    case "day":
    case "days":
    case "d":
      a = Math.round(r * Wn);
      break;
    case "week":
    case "weeks":
    case "w":
      a = Math.round(r * CS);
      break;
    default:
      a = Math.round(r * xS);
      break;
  }
  return t[1] === "-" || t[4] === "ago" ? -a : a;
};
function xe(e, t) {
  if (!Number.isFinite(t))
    throw new TypeError(`Invalid ${e} input`);
  return t;
}
var P;
class OS {
  constructor(t) {
    ye(this, P);
    if (!fo(t))
      throw new TypeError("JWT Claims Set MUST be an object");
    me(this, P, structuredClone(t));
  }
  data() {
    return Ge.encode(JSON.stringify(g(this, P)));
  }
  get iss() {
    return g(this, P).iss;
  }
  set iss(t) {
    g(this, P).iss = t;
  }
  get sub() {
    return g(this, P).sub;
  }
  set sub(t) {
    g(this, P).sub = t;
  }
  get aud() {
    return g(this, P).aud;
  }
  set aud(t) {
    g(this, P).aud = t;
  }
  set jti(t) {
    g(this, P).jti = t;
  }
  set nbf(t) {
    typeof t == "number" ? g(this, P).nbf = xe("setNotBefore", t) : t instanceof Date ? g(this, P).nbf = xe("setNotBefore", Ce(t)) : g(this, P).nbf = Ce(/* @__PURE__ */ new Date()) + Ur(t);
  }
  set exp(t) {
    typeof t == "number" ? g(this, P).exp = xe("setExpirationTime", t) : t instanceof Date ? g(this, P).exp = xe("setExpirationTime", Ce(t)) : g(this, P).exp = Ce(/* @__PURE__ */ new Date()) + Ur(t);
  }
  set iat(t) {
    typeof t > "u" ? g(this, P).iat = Ce(/* @__PURE__ */ new Date()) : t instanceof Date ? g(this, P).iat = xe("setIssuedAt", Ce(t)) : typeof t == "string" ? g(this, P).iat = xe("setIssuedAt", Ce(/* @__PURE__ */ new Date()) + Ur(t)) : g(this, P).iat = xe("setIssuedAt", t);
  }
}
P = new WeakMap();
const IS = async (e, t, r) => {
  const n = await wS(e, t, "sign");
  hS(e, n);
  const a = await crypto.subtle.sign(ES(e, n.algorithm), n, r);
  return new Uint8Array(a);
};
var St, W, Y;
class kS {
  constructor(t) {
    ye(this, St);
    ye(this, W);
    ye(this, Y);
    if (!(t instanceof Uint8Array))
      throw new TypeError("payload must be an instance of Uint8Array");
    me(this, St, t);
  }
  setProtectedHeader(t) {
    if (g(this, W))
      throw new TypeError("setProtectedHeader can only be called once");
    return me(this, W, t), this;
  }
  setUnprotectedHeader(t) {
    if (g(this, Y))
      throw new TypeError("setUnprotectedHeader can only be called once");
    return me(this, Y, t), this;
  }
  async sign(t, r) {
    if (!g(this, W) && !g(this, Y))
      throw new Fe("either setProtectedHeader or setUnprotectedHeader must be called before #sign()");
    if (!dS(g(this, W), g(this, Y)))
      throw new Fe("JWS Protected and JWS Unprotected Header Parameter names must be disjoint");
    const n = {
      ...g(this, W),
      ...g(this, Y)
    }, a = mS(Fe, /* @__PURE__ */ new Map([["b64", !0]]), r == null ? void 0 : r.crit, g(this, W), n);
    let s = !0;
    if (a.has("b64") && (s = g(this, W).b64, typeof s != "boolean"))
      throw new Fe('The "b64" (base64url-encode payload) Header Parameter must be a boolean');
    const { alg: i } = n;
    if (typeof i != "string" || !i)
      throw new Fe('JWS "alg" (Algorithm) Header Parameter missing or invalid');
    $S(i, t, "sign");
    let o = g(this, St);
    s && (o = Ge.encode(Dr(o)));
    let u;
    g(this, W) ? u = Ge.encode(Dr(JSON.stringify(g(this, W)))) : u = Ge.encode("");
    const d = nS(u, Ge.encode("."), o), y = await SS(t, i), A = await IS(i, y, d), E = {
      signature: Dr(A),
      payload: ""
    };
    return s && (E.payload = ir.decode(o)), g(this, Y) && (E.header = g(this, Y)), g(this, W) && (E.protected = ir.decode(u)), E;
  }
}
St = new WeakMap(), W = new WeakMap(), Y = new WeakMap();
var ze;
class PS {
  constructor(t) {
    ye(this, ze);
    me(this, ze, new kS(t));
  }
  setProtectedHeader(t) {
    return g(this, ze).setProtectedHeader(t), this;
  }
  async sign(t, r) {
    const n = await g(this, ze).sign(t, r);
    if (n.payload === void 0)
      throw new TypeError("use the flattened module for creating JWS with b64: false");
    return `${n.protected}.${n.payload}.${n.signature}`;
  }
}
ze = new WeakMap();
var _e, J;
class VS {
  constructor(t = {}) {
    ye(this, _e);
    ye(this, J);
    me(this, J, new OS(t));
  }
  setIssuer(t) {
    return g(this, J).iss = t, this;
  }
  setSubject(t) {
    return g(this, J).sub = t, this;
  }
  setAudience(t) {
    return g(this, J).aud = t, this;
  }
  setJti(t) {
    return g(this, J).jti = t, this;
  }
  setNotBefore(t) {
    return g(this, J).nbf = t, this;
  }
  setExpirationTime(t) {
    return g(this, J).exp = t, this;
  }
  setIssuedAt(t) {
    return g(this, J).iat = t, this;
  }
  setProtectedHeader(t) {
    return me(this, _e, t), this;
  }
  async sign(t, r) {
    var a;
    const n = new PS(g(this, J).data());
    if (n.setProtectedHeader(g(this, _e)), Array.isArray((a = g(this, _e)) == null ? void 0 : a.crit) && g(this, _e).crit.includes("b64") && g(this, _e).b64 === !1)
      throw new so("JWTs MUST NOT use unencoded payload");
    return n.sign(t, r);
  }
}
_e = new WeakMap(), J = new WeakMap();
async function XS(e) {
  const {
    algorithm: t,
    secret: r,
    privateKey: n,
    payload: a,
    jwtHeaders: s,
    isSecretBase64Encoded: i
  } = e;
  let o = {}, u = {};
  try {
    const d = (a == null ? void 0 : a.trim()) || "{}";
    d === "" ? o = {} : o = JSON.parse(d);
  } catch (d) {
    return console.error("Failed to parse JWT payload JSON:", d), console.error("Payload value:", a), null;
  }
  try {
    const d = (s == null ? void 0 : s.trim()) || "{}";
    d === "" ? u = {} : u = JSON.parse(d);
  } catch (d) {
    return console.error("Failed to parse JWT headers JSON:", d), console.error("Headers value:", s), null;
  }
  try {
    let d;
    if (t.startsWith("RS") || t.startsWith("ES") || t.startsWith("PS")) {
      if (!n)
        return console.error("Private key is required for RSA/ECDSA algorithms"), null;
      d = new TextEncoder().encode(n);
    } else {
      if (!r)
        return console.error("Secret is required for HMAC algorithms"), null;
      d = i ? Uint8Array.from(Buffer.from(r, "base64")) : new TextEncoder().encode(r);
    }
    return await new VS(o).setProtectedHeader({
      alg: t,
      ...u
    }).sign(d);
  } catch (d) {
    return console.error("Error generating JWT token:", d), null;
  }
}
export {
  Ks as AuthCodeGrantTypeParams,
  fg as ClientCredentialsGrantTypeParams,
  C_ as CollectionSchemaVersion,
  FS as Environment,
  Ja as EnvironmentSchemaVersion,
  Xs as FormDataKeyValue,
  _i as GQLHeader,
  $i as GQL_REQ_SCHEMA_VERSION,
  zS as GlobalEnvironment,
  ro as HOPP_SUPPORTED_PREDEFINED_VARIABLES,
  q as HoppCollection,
  wr as HoppGQLAuth,
  Et as HoppGQLAuthAPIKey,
  kn as HoppGQLAuthAWSSignature,
  He as HoppGQLAuthBasic,
  De as HoppGQLAuthBearer,
  Le as HoppGQLAuthInherit,
  je as HoppGQLAuthNone,
  Tr as HoppGQLAuthOAuth2,
  Pn as HoppGQLRequest,
  $r as HoppRESTAuth,
  Me as HoppRESTAuthAPIKey,
  ft as HoppRESTAuthAWSSignature,
  ai as HoppRESTAuthAkamaiEdgeGrid,
  fe as HoppRESTAuthBasic,
  he as HoppRESTAuthBearer,
  Ar as HoppRESTAuthDigest,
  ni as HoppRESTAuthHAWK,
  pe as HoppRESTAuthInherit,
  yg as HoppRESTAuthJWT,
  de as HoppRESTAuthNone,
  Tr as HoppRESTAuthOAuth2,
  Sr as HoppRESTHeaders,
  En as HoppRESTParams,
  xn as HoppRESTReqBody,
  Er as HoppRESTRequest,
  wg as HoppRESTRequestResponse,
  ii as HoppRESTRequestResponses,
  Tn as HoppRESTRequestVariables,
  _g as HoppRESTResponseOriginalRequest,
  $t as ImplicitOauthFlowParams,
  Qs as PasswordGrantTypeParams,
  hi as RESTReqSchemaVersion,
  jS as ValidContentTypesList,
  YS as calculateAkamaiEdgeGridHeader,
  QS as calculateHawkHeader,
  XS as generateJWTToken,
  xi as generateUniqueRefId,
  r_ as getDefaultGQLRequest,
  Hg as getDefaultRESTRequest,
  HS as isEqualHoppRESTRequest,
  US as isHoppRESTRequest,
  Ng as knownContentTypes,
  ki as makeCollection,
  KS as makeGQLRequest,
  MS as makeHoppRESTResponseOriginalRequest,
  LS as makeRESTRequest,
  WS as parseBodyEnvVariables,
  Bb as parseBodyEnvVariablesE,
  ZS as parseRawKeyValueEntries,
  jb as parseRawKeyValueEntriesE,
  GS as parseTemplateString,
  qb as parseTemplateStringE,
  BS as rawKeyValueEntriesToString,
  DS as safelyExtractRESTRequest,
  qS as strictParseRawKeyValueEntriesE,
  n_ as translateToGQLRequest,
  JS as translateToNewEnvironment,
  Zb as translateToNewEnvironmentVariables,
  R_ as translateToNewGQLCollection,
  x_ as translateToNewRESTCollection,
  Dg as translateToNewRequest
};
